{
  "% к прошлой неделе": "% par rapport à la semaine dernière",
  ". STEOS ID и финансовые квитанции сохраняются.": ". Le STEOS ID et les reçus financiers sont conservés.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Les voix prêtes sont disponibles dans « Synthèse vocale » → « Mes voix ».",
  ". Он не меняет голос озвучки чата.": ". Cela ne modifie pas la voix de synthèse du chat.",
  ". После подтверждения обновите профиль.": ". Après confirmation, actualisez votre profil.",
  ". Проверьте папку «Спам».": ". Vérifiez votre dossier « Spam ».",
  "Circle каждый месяц по подписке": "Circle chaque mois avec l’abonnement",
  "Circle по подписке на этот месяц потрачены": "Les Circle de l’abonnement du mois sont épuisés",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Non connecté",
  "Telegram ID скопирован.": "L’ID Telegram a été copié.",
  "{0} {1} C сгорят {2}": "{0} {1} C expireront le {2}",
  "{0} из {1}": "{0} sur {1}",
  "{0} фото хватит для сходства": "{0} photos suffisent pour obtenir une bonne ressemblance",
  "{0}: {1} работ": "{0} : {1} créations",
  "{0}: пока недоступно": "{0} : indisponible pour le moment",
  "· Вы и варианты": "· Vous et les variantes",
  "· Новое": "· Nouveau",
  "· занято": "· occupé",
  "· отменена": "· annulée",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». L’entraînement commencera après avoir appuyé séparément sur « Relancer le traitement » dans la carte.",
  "Автовоспроизведение примеров": "Lecture automatique des exemples",
  "Аккаунт": "Compte",
  "Аккаунт подключён": "Compte connecté",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "L’archive est indisponible ou le lien a expiré. Vous pouvez demander une nouvelle exportation.",
  "Бабушка": "Grand-mère",
  "Баланс и вывод доступны в STEOS ID.": "Le solde et les retraits sont disponibles dans STEOS ID.",
  "Баланс и награды": "Solde et récompenses",
  "Без имени": "Sans nom",
  "Бесплатный план": "Forfait gratuit",
  "Ближайшие": "Les plus proches",
  "Близкие": "Proches",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Cette personne disparaîtra de votre profil. Ses photos ne seront plus disponibles pour de nouvelles créations.",
  "Близкий удалён.": "La personne proche a été supprimée.",
  "Близких пока нет.": "Vous n’avez pas encore de proches.",
  "Брат": "Frère",
  "В Steos с": "Sur Steos depuis",
  "В избранное": "Ajouter aux favoris",
  "Валюта": "Devise",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "La variante sera supprimée. Les photos originales et le STEOS ID seront conservés.",
  "Вариантов: {0}": "Nombre de variantes : {0}",
  "Варианты": "Variantes",
  "Ваш собственный голос": "Votre propre voix",
  "Введите УДАЛИТЬ": "Saisissez УДАЛИТЬ",
  "Введите пароль": "Saisissez le mot de passe",
  "Введите почту": "Saisissez votre adresse e-mail",
  "Вернуться ко входу": "Retour à la connexion",
  "Версия": "Version",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "La version du consentement a changé. Actualisez la page et confirmez le texte à jour.",
  "Версия согласия изменилась. Обновите страницу.": "La version du consentement a changé. Actualisez la page.",
  "Версия:": "Version :",
  "Взрослый": "Adulte",
  "Включаем микрофон…": "Activation du microphone…",
  "Включено": "Activé",
  "Возраст": "Âge",
  "Войти": "Se connecter",
  "Восстановить пароль": "Réinitialiser le mot de passe",
  "Все Circle на балансе без срока": "Vos Circle n’expirent pas",
  "Вы": "Vous",
  "Вы и близкие": "Vous et vos proches",
  "Вы и варианты": "Vous et vos looks",
  "Выберите голос": "Choisir une voix",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Choisissez un outil et remplissez son formulaire. La création terminée sera enregistrée dans l’historique.",
  "Выбран": "Sélectionné",
  "Выбрать голос": "Choisir une voix",
  "Выбрать голос по умолчанию": "Choisir la voix par défaut",
  "Выбрать из работ": "Choisir parmi les créations",
  "Выгрузить мои данные": "Exporter mes données",
  "Выгрузка:": "Exportation :",
  "Выключено": "Désactivé",
  "Голос": "Voix",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "La voix est prête. Elle est disponible dans l’onglet « Mes voix » de la synthèse vocale.",
  "Голос и клон": "Voix et clone",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "La voix a changé. Les données ont été mises à jour : vérifiez-les avant d’enregistrer.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "La voix a changé. Vérifiez les données mises à jour avant de relancer le traitement.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "La voix disparaîtra de votre liste. Cette action est irréversible.",
  "Голос по умолчанию для создания:": "Voix par défaut pour la création :",
  "Голос принят в обработку. Здесь появится его статус.": "La voix a été prise en charge. Son statut apparaîtra ici.",
  "Голос уже удалён или недоступен.": "La voix a déjà été supprimée ou n’est plus disponible.",
  "Голос:": "Voix :",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Aucune voix trouvée. Ouvrez le catalogue ou modifiez votre recherche.",
  "Горизонтальное": "Horizontal",
  "Готов": "Prêt",
  "Готовим образцы": "Préparation des échantillons",
  "Готово": "Terminé",
  "Готовые работы": "Créations prêtes",
  "Далее": "Suivant",
  "Данные Telegram обновлены.": "Les données Telegram ont été mises à jour.",
  "Данные баланса временно недоступны": "Les données du solde sont temporairement indisponibles",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Les données sont transférées vers le compte confirmé. Les anciennes sessions ont été fermées ; le reçu permet de poursuivre la vérification après le rechargement.",
  "Дедушка": "Grand-père",
  "До 5 фото: лицо крупно, при хорошем свете": "Jusqu’à 5 photos : visage en gros plan, avec un bon éclairage",
  "До пяти фото. Они будут использоваться как ваш образ.": "Jusqu’à cinq photos. Elles serviront à créer votre apparence.",
  "Добавить близкого": "Ajouter un proche",
  "Добавить фото": "Ajouter une photo",
  "Добавьте ещё": "En ajouter d’autres",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Ajoutez entre 2 secondes et 1,5 minutes de votre voix. Parlez naturellement, sans musique ni autres voix.",
  "Дочь": "Fille",
  "Друг": "Ami",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Si le compte existe, un lien permettant de définir un nouveau mot de passe a été envoyé à",
  "Ещё варианты": "Autres variantes",
  "Ещё операции": "Plus d'opérations",
  "Ещё работы": "Autres créations",
  "Жена": "Épouse",
  "ЗАМЕНА ОБРАЗЦОВ": "REMPLACEMENT DES ÉCHANTILLONS",
  "Забыли пароль?": "Mot de passe oublié ?",
  "Загружаем аккаунт…": "Chargement du compte…",
  "Загружаем варианты…": "Chargement des variantes…",
  "Загружаем ваши голоса…": "Chargement de vos voix…",
  "Загружаем голоса…": "Chargement des voix…",
  "Загружаем настройки…": "Chargement des paramètres…",
  "Загружаем обновления…": "Chargement des mises à jour…",
  "Загружаем операции…": "Chargement des opérations…",
  "Загружаем пример…": "Chargement de l’exemple…",
  "Загружаем работы…": "Chargement des créations…",
  "Загружаем фото…": "Chargement des photos…",
  "Загрузить аудиофайлы": "Importer des fichiers audio",
  "Загрузить выбранные фото": "Importer les photos sélectionnées",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "L’importation n’est pas encore confirmée. Appuyez sur « Continuer l’envoi » : nous vérifierons d’abord l’importation précédente.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "L’importation n’est pas confirmée. La reprise vérifiera d’abord les importations précédentes.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "L’importation a été refusée. Appuyez sur « Continuer l’envoi » pour obtenir un nouveau lien et importer l’échantillon.",
  "Закрыть": "Fermer",
  "Закрыть мастер": "Fermer l’assistant",
  "Заменить образцы": "Remplacer les échantillons",
  "Записать с микрофона": "Enregistrer avec le microphone",
  "Запись": "Enregistrement",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "L’enregistrement n’est pas disponible ici. Ouvrez l’application via HTTPS ou importez un fichier audio.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "L’enregistrement a été interrompu. Réessayez ou importez un fichier.",
  "Запись-{0}.{1}": "Enregistrement-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Enregistrez un échantillon, attendez la fin de l’entraînement, puis faites lire du texte avec votre voix.",
  "Запишите речь или загрузите аудиофайлы": "Enregistrez votre voix ou importez des fichiers audio",
  "Запишите свой голос один раз — используйте его в озвучке.": "Enregistrez votre voix une seule fois pour l’utiliser dans la synthèse vocale.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "La demande a été enregistrée. La reprise vérifiera la demande précédente sans créer une deuxième voix.",
  "Запустить обработку": "Lancer le traitement",
  "Здесь появятся ваши работы": "Vos créations apparaîtront ici",
  "Из них": "Parmi celles-ci",
  "Из них {0} C можно вывести": "Parmi celles-ci, {0} C peuvent être retirés",
  "Избранное": "Favoris",
  "Избранные работы": "Créations favorites",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "La modification n’est pas confirmée. Vérifiez la fiche à jour avant de réessayer.",
  "Изменить": "Modifier",
  "Изменить близкого": "Modifier un proche",
  "Изменить вариант": "Modifier la variante",
  "Изменить голос": "Modifier la voix",
  "Изменить мои фото": "Modifier mes photos",
  "Имя близкого": "Nom du proche",
  "Имя голоса": "Nom de la voix",
  "Имя пользователя не задано": "Nom d’utilisateur non défini",
  "Использовать как себя": "Utiliser comme mon apparence",
  "Используем сохранённые образцы голоса «": "Utilisation des échantillons vocaux enregistrés de «",
  "Используйте свои фото и фото близких в инструментах студии.": "Utilisez vos photos et celles de vos proches dans les outils du studio.",
  "История очищена: {0} работ, {1} заказов.": "Historique effacé : {0} créations, {1} commandes.",
  "КЛОН ГОЛОСА": "CLONE VOCAL",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Chaque échantillon doit contenir au moins une seconde de parole.",
  "Как в системе": "Comme dans le système",
  "Как пользоваться": "Mode d’emploi",
  "Как снимать": "Conseils pour prendre des photos",
  "Каталог голосов": "Catalogue des voix",
  "Квадрат": "Carré",
  "Кем приходится": "Lien de parenté",
  "Ко входу": "Retour à la connexion",
  "Количество вариантов пока недоступно": "Le nombre de variantes est actuellement indisponible",
  "Конфиденциальность": "Confidentialité",
  "Копирование недоступно. ID показан в карточке аккаунта.": "La copie n’est pas disponible. L’ID figure sur la fiche du compte.",
  "Кружок с героем": "Message vidéo avec un personnage",
  "Лимит {0} голосов выбран": "Limite de {0} voix atteinte",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "La limite de voix est atteinte. Supprimez une voix inutile pour en ajouter une nouvelle.",
  "Лимит:": "Limite :",
  "Мама": "Maman",
  "Можно добавить до {0} образцов.": "Vous pouvez ajouter jusqu’à {0} échantillons.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Vous pouvez fermer l’application. Le statut sera mis à jour une fois le traitement terminé.",
  "Мои варианты": "Mes variantes",
  "Мои голоса": "Mes voix",
  "Мои данные": "Mes données",
  "Мои фото": "Mes photos",
  "Моё": "Mon apparence",
  "Моё фото": "Ma photo",
  "Муж": "Époux",
  "НОВЫЙ ГОЛОС": "NOUVELLE VOIX",
  "Награды": "Récompenses",
  "Награды и задания": "Récompenses et missions",
  "Назад": "Retour",
  "Название варианта": "Nom de la variante",
  "Назначить голос": "Attribuer une voix",
  "Настройки": "Paramètres",
  "Настройки уже изменились. Показана актуальная версия.": "Les paramètres ont déjà changé. La version à jour est affichée.",
  "Начните с 2 секунд речи в тихом месте.": "Commencez par 2 secondes de parole dans un endroit calme.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Au maximum 5 photos JPEG ou PNG, de 10 Mo chacune au plus.",
  "Не задано": "Non défini",
  "Не короче 8 знаков": "Au moins 8 caractères",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Impossible d’activer le microphone. Autorisez l’accès ou importez un fichier.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Impossible de se connecter. Rouvrez l’application depuis Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Impossible de lire l’exemple. Rouvrez la fiche et réessayez.",
  "Не удалось загрузить варианты.": "Impossible de charger les variantes.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Impossible de charger les voix. Modifiez la recherche ou l’onglet pour réessayer.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Impossible de charger les paramètres. Essayez d’actualiser.",
  "Не удалось загрузить работы.": "Impossible de charger les créations.",
  "Не удалось загрузить следующую страницу.": "Impossible de charger la page suivante.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Impossible de charger la page suivante. Réessayez.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Impossible de mettre à jour les données depuis Telegram. Réessayez plus tard.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Impossible de confirmer la modification des favoris. Actualisez le profil.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Impossible de confirmer l’opération. Vérifiez l’état du compte avant de réessayer.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Impossible de confirmer l’enregistrement. Actualisez les paramètres avant de réessayer.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Impossible de confirmer la suppression du proche. Actualisez le profil.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Impossible d’obtenir une réponse. Réessayez : la demande reprendra avec la même clé.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Impossible de vérifier l’exportation. Actualisez la page : nous reprendrons l’opération en cours.",
  "Не удалось прочитать запись.": "Impossible de lire l’enregistrement.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Impossible de créer la voix. Ouvrez la fiche pour vérifier son statut ou relancer le traitement.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Impossible de créer la voix. Vérifiez les données et les échantillons.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Impossible d’enregistrer la consultation. Vous pouvez fermer et revenir plus tard.",
  "Неверная почта или пароль": "Adresse e-mail ou mot de passe incorrect",
  "Нет работ": "Aucune création",
  "Новая выгрузка": "Nouvelle exportation",
  "Новости": "Actualités",
  "Новый вариант": "Nouvelle variante",
  "Новый голос": "Nouvelle voix",
  "Новых публикаций пока нет.": "Aucune nouvelle publication pour le moment.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "La durée totale des enregistrements doit être comprise entre 2 secondes et 1,5 minutes.",
  "О приложении": "À propos de l’application",
  "Обновить": "Actualiser",
  "Обновить варианты": "Actualiser les variantes",
  "Обновить из Telegram": "Actualiser depuis Telegram",
  "Обновить настройки": "Actualiser les paramètres",
  "Обновить профиль": "Actualiser le profil",
  "Обновить работы": "Actualiser les créations",
  "Обновления": "Mises à jour",
  "Обновляем вход…": "Actualisation de la connexion…",
  "Обрабатывается": "En cours de traitement",
  "Образ готов": "Apparence prête",
  "Образ ещё не собран": "Apparence pas encore créée",
  "Образец {0}": "Échantillon {0}",
  "Образец голоса": "Échantillon vocal",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "L’échantillon n’a pas encore été vérifié. Patientez, puis poursuivez l’envoi.",
  "Образец не прошёл проверку. Выберите другую запись.": "L’échantillon n’a pas passé la vérification. Choisissez un autre enregistrement.",
  "Образцы готовы к повторной обработке.": "Les échantillons sont prêts pour un nouveau traitement.",
  "Образцы для «": "Échantillons pour «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Les échantillons ont été mis à jour. Appuyez sur « Relancer le traitement » pour entraîner à nouveau la voix.",
  "Обучаем голос": "Entraînement de la voix",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "La durée totale des échantillons ne doit pas dépasser 1,5 minutes.",
  "Объединение STEOS ID": "Fusion des STEOS ID",
  "Объединяем аккаунты": "Fusion des comptes",
  "Объём образцов": "Durée des échantillons",
  "Один аккаунт для бота и сайта STEOS": "Un seul compte pour le bot et le site STEOS",
  "Озвучить текст голосом «": "Faire lire le texte avec la voix «",
  "Операции": "Opérations",
  "Операции в токенах STEOS ID": "Opérations en jetons STEOS ID",
  "Операции временно недоступны.": "Les opérations sont temporairement indisponibles.",
  "Операций пока нет.": "Aucune opération pour le moment.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "L’opération n’est pas confirmée. Une nouvelle tentative utilisera la même clé.",
  "Описание": "Description",
  "Описание и согласие": "Description et consentement",
  "Остановить запись ·": "Arrêter l’enregistrement ·",
  "Остаток Circle недоступен": "Le solde Circle est indisponible",
  "Отклик": "Retour haptique",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Ouvrez le lien reçu par e-mail et définissez un nouveau mot de passe sur id.steos.io. Connectez-vous ensuite ici.",
  "Откройте ссылку подтверждения для": "Ouvrez le lien de confirmation pour",
  "Открыть id.steos.io": "Ouvrir id.steos.io",
  "Открыть историю": "Ouvrir l’historique",
  "Отмена": "Annuler",
  "Отметьте согласие с условиями": "Cochez la case pour accepter les conditions",
  "Отправить ссылку": "Envoyer le lien",
  "Отправляем…": "Envoi en cours…",
  "Оформить подписку": "S’abonner",
  "Оформление": "Apparence",
  "Очистить историю": "Effacer l’historique",
  "Очистить историю?": "Effacer l’historique ?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "L’effacement n’est pas confirmé. Une nouvelle tentative vérifiera l’opération précédente.",
  "Очищаем…": "Effacement en cours…",
  "Ошибка": "Erreur",
  "Папа": "Papa",
  "Пароль": "Mot de passe",
  "Переименовать вариант": "Renommer la variante",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Le transfert n’est pas encore confirmé. Le reçu a été enregistré ; la vérification se poursuivra.",
  "Перенос завершён, обновляем вход…": "Transfert terminé, actualisation de la connexion…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Transfert des données vers un STEOS ID existant. Après le transfert, l’application actualisera la session. Ne lancez pas une nouvelle fusion.",
  "Письмо отправлено": "E-mail envoyé",
  "Питомец": "Animal de compagnie",
  "Повторить загрузку": "Réessayer le chargement",
  "Повторить обработку": "Relancer le traitement",
  "Подготовить ZIP для скачивания": "Préparer le ZIP à télécharger",
  "Поддержка": "Assistance",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "La connexion à STEOS ID est actuellement indisponible. Réessayez plus tard ou ouvrez le site STEOS ID.",
  "Подключён": "Connecté",
  "Подключён:": "Connecté :",
  "Подруга": "Amie",
  "Подтвердите почту": "Confirmez votre adresse e-mail",
  "Подтвердите согласие перед отправкой образцов.": "Confirmez votre consentement avant d’envoyer les échantillons.",
  "Подтвердить очистку истории": "Confirmer l’effacement de l’historique",
  "Подтвердить удаление": "Confirmer la suppression",
  "Подтвердить удаление аккаунта": "Confirmer la suppression du compte",
  "Подтвердить удаление близкого": "Confirmer la suppression du proche",
  "Подтвердить удаление варианта": "Confirmer la suppression de la variante",
  "Поиск голоса": "Rechercher une voix",
  "Поиск по имени": "Rechercher par nom",
  "Пока нет своих голосов": "Vous n’avez pas encore créé de voix",
  "Показать ещё": "Afficher plus",
  "Показать ещё голоса": "Afficher plus de voix",
  "Показать пароль": "Afficher le mot de passe",
  "Пополнить": "Recharger",
  "Попробовать": "Essayer",
  "Портрет": "Portrait",
  "Пост": "Publication",
  "Потрачено Circle:": "Circle dépensés :",
  "Почта": "Adresse e-mail",
  "Почта уже занята": "Cette adresse e-mail est déjà utilisée",
  "Почта уже занята, войдите с ней": "Cette adresse e-mail est déjà utilisée. Connectez-vous avec cette adresse.",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Bonjour ! Cet enregistrement servira à créer ma voix. Je parle calmement, à un rythme naturel, comme lors d’une conversation avec un ami. Je vais raconter ma journée, ce qui m’a fait plaisir et ce que je prévois pour demain. Continuez à parler avec vos propres mots pendant au moins trente secondes.",
  "Приглашайте друзей": "Invitez des amis",
  "Пример голоса {0}": "Exemple de voix {0}",
  "Принимаю": "J’accepte",
  "Присылать готовые работы в чат": "Envoyer les créations terminées dans le chat",
  "Проверен": "Vérifié",
  "Проверить выгрузку": "Vérifier l’exportation",
  "Проверить подтверждение": "Vérifier la confirmation",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "La vérification de la voix a échoué. Enregistrez un échantillon sans musique ni autres personnes.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "La vérification des échantillons a échoué. Essayez un enregistrement propre avec une seule voix.",
  "Проверьте адрес": "Vérifiez l’adresse",
  "Проверяем запись": "Vérification de l’enregistrement",
  "Проверяем образец {0} из {1}…": "Vérification de l’échantillon {0} sur {1}…",
  "Проверяем состояние переноса…": "Vérification de l’état du transfert…",
  "Проверяем…": "Vérification…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Consultez votre solde dans le profil et récupérez les récompenses disponibles.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Nous poursuivrons la vérification de la demande précédente sans la relancer.",
  "Продолжим сохранённый запрос с теми же данными.": "Nous reprendrons la demande enregistrée avec les mêmes données.",
  "Продолжить отправку": "Continuer l’envoi",
  "Продолжить проверку": "Poursuivre la vérification",
  "Продолжить создание голоса": "Continuer la création de la voix",
  "Продолжить сохранение": "Continuer l’enregistrement",
  "Прослушать {0}": "Écouter {0}",
  "Профиль": "Profil",
  "Профиль «Вы» пока недоступен.": "Le profil « Vous » est actuellement indisponible.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Le profil a déjà été modifié. Fermez le formulaire et ouvrez la version à jour.",
  "Работ в этом списке пока нет.": "Aucune création dans cette liste pour le moment.",
  "Работа №": "Création n°",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Les créations et les paramètres des commandes disparaîtront de l’historique. Les voix, les variantes « Vous » et les proches seront conservés. Les reçus financiers seront conservés. L’historique ne peut pas être restauré.",
  "Работы по неделям": "Créations par semaine",
  "Раздел профиля": "Section du profil",
  "Разделы профиля": "Sections du profil",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "La taille de chaque échantillon doit être comprise entre 1 octet et 20 Mo.",
  "Ребёнок": "Enfant",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Le résultat du traitement est en cours de vérification. Il n’est pas encore possible de relancer le traitement.",
  "Русский": "Русский",
  "С": "Depuis",
  "Сбросить голос по умолчанию": "Réinitialiser la voix par défaut",
  "Светлая": "Clair",
  "Свой аватар": "Avatar personnalisé",
  "Сгорят {0}, если не потратить": "Expirent le {0} s’ils ne sont pas dépensés",
  "Сделать кружок": "Créer un message vidéo",
  "Серия:": "Série :",
  "Сестра": "Sœur",
  "Скачать ZIP": "Télécharger le ZIP",
  "Скопировать Telegram ID": "Copier l’ID Telegram",
  "Скорость речи": "Vitesse de parole",
  "Скрыть пароль": "Masquer le mot de passe",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Trop de requêtes. Patientez un instant et réessayez.",
  "Слишком много попыток. Попробуйте позже.": "Trop de tentatives. Réessayez plus tard.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Photographiez le visage sans filtres ni lunettes de soleil foncées, avec un éclairage uniforme. Ajoutez différents angles de vue. Une seule personne doit apparaître dans le cadre.",
  "Снять голос": "Enregistrer la voix",
  "Снять фото": "Prendre une photo",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Le consentement a changé avant le début de l’entraînement. Actualisez la page et confirmez la version à jour avant de relancer le traitement.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Créez des vidéos circulaires parlantes avec le personnage sélectionné ou votre propre apparence.",
  "Создание": "Création",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "La création de voix est temporairement indisponible. Les échantillons sont conservés dans cette fenêtre.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "La création de nouvelles voix est actuellement indisponible. Les voix déjà créées sont accessibles ci-dessous.",
  "Создано:": "Créé le :",
  "Создан {0}": "Créé le {0}",
  "Создать аккаунт": "Créer un compte",
  "Создать голос": "Créer une voix",
  "Создаём голос…": "Création de la voix…",
  "Сохранение настроек создания сейчас выключено.": "L’enregistrement des paramètres de création est actuellement désactivé.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "L’enregistrement n’est pas confirmé. Fermez le formulaire et vérifiez le profil à jour.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "L’enregistrement n’est pas confirmé. Une nouvelle tentative de création utilisera la demande précédente.",
  "Сохранение недоступно.": "Enregistrement indisponible.",
  "Сохранено": "Enregistré",
  "Сохранить": "Enregistrer",
  "Сохранить близкого": "Enregistrer le proche",
  "Сохранить вариант": "Enregistrer la variante",
  "Сохранить голос по умолчанию": "Enregistrer la voix par défaut",
  "Сохранить мои фото": "Enregistrer mes photos",
  "Сохранить образцы": "Enregistrer les échantillons",
  "Сохраняем образцы…": "Enregistrement des échantillons…",
  "Сохраняем…": "Enregistrement…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Les variantes de votre apparence enregistrées sont disponibles dans le profil et les outils de création.",
  "Сохранённых вариантов пока нет.": "Aucune variante enregistrée pour le moment.",
  "Сроки партий Circle временно недоступны": "Les dates d’expiration des lots Circle sont temporairement indisponibles",
  "Старший": "Aîné",
  "Статистика": "Statistiques",
  "Статистика по неделям временно недоступна.": "Les statistiques hebdomadaires sont temporairement indisponibles.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Le statut de suppression est temporairement indisponible. Le reçu a été enregistré dans cet onglet.",
  "Сторис": "Stories",
  "Сын": "Fils",
  "Тариф": "Offre",
  "Текст для чтения": "Texte à lire",
  "Тема": "Thème",
  "Тема сохраняется на этом устройстве.": "Le thème est enregistré sur cet appareil.",
  "Тёмная": "Sombre",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "J’ai le droit d’utiliser ces photos et le consentement des personnes représentées.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Réduction du bruit",
  "Убрать": "Retirer",
  "Убрать {0}": "Retirer {0}",
  "Убрать из избранного": "Retirer des favoris",
  "Убрать фоновый шум": "Supprimer le bruit de fond",
  "Убрать фото": "Supprimer la photo",
  "Уведомления": "Notifications",
  "Уведомления недоступны.": "Les notifications sont indisponibles.",
  "Уведомления пока недоступны.": "Les notifications sont actuellement indisponibles.",
  "Удаление аккаунта Mini App": "Suppression du compte Mini App",
  "Удаление:": "Suppression :",
  "Удалить": "Supprimer",
  "Удалить «": "Supprimer «",
  "Удалить «{0}»?": "Supprimer « {0} » ?",
  "Удалить аккаунт Mini App": "Supprimer le compte Mini App",
  "Удалить близкого": "Supprimer le proche",
  "Удалить вариант": "Supprimer la variante",
  "Удалить голос": "Supprimer la voix",
  "Удаляем…": "Suppression en cours…",
  "Удаляется": "En cours de suppression",
  "Українська": "Українська",
  "Условия использования": "Conditions d’utilisation",
  "Файл": "Fichier",
  "Формат": "Format",
  "Фото Telegram": "Photo Telegram",
  "Фото {0}": "Photo {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "La photo et le nom proviennent de votre profil Telegram. Si vous les avez modifiés, actualisez les données ici.",
  "Фото и фотосессия": "Photo et séance photo",
  "Фото перед загрузкой": "Photo avant l’importation",
  "Фото профиля": "Photo de profil",
  "Фото профиля Telegram": "Photo de profil Telegram",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Les photos, les voix, les proches et les données de la Mini App seront supprimés de tous les services. Le STEOS ID et les reçus financiers seront conservés. La suppression est irréversible.",
  "Фото:": "Photo :",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Une partie du profil est temporairement indisponible. Essayez d’actualiser.",
  "Читаем аудиофайлы…": "Lecture des fichiers audio…",
  "Что нового": "Quoi de neuf",
  "Что нового пока не опубликовано или временно недоступно.": "Aucune nouveauté n’a été publiée pour le moment ou cette section est temporairement indisponible.",
  "Что нового пока не опубликовано.": "Aucune nouveauté n’a été publiée pour le moment.",
  "Шаблоны": "Modèles",
  "Шаблоны и рилс": "Modèles et Reels",
  "Эта неделя": "Cette semaine",
  "Этот голос используется:": "Cette voix est utilisée :",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Ce traitement ne peut pas encore être relancé. Actualisez le statut de la voix.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Ce format n’est pas pris en charge. Choisissez MP3, WAV, M4A, OGG ou WebM.",
  "Язык аккаунта": "Langue du compte",
  "готова": "prête",
  "готова частично": "partiellement prête",
  "дата недоступна": "date indisponible",
  "для переозвучки": "pour le doublage",
  "до {0}, потом {1}": "jusqu’au {0}, puis {1}",
  "другой тариф": "autre offre",
  "закончится {0}": "expire le {0}",
  "и": "et",
  "из": "sur",
  "из 1:30 · минимум 0:02": "sur 1:30 · minimum 0:02",
  "лимит уточняется": "limite en cours de vérification",
  "не задан": "non défini",
  "не назначен": "non attribué",
  "новых": "nouveaux",
  "образец": "échantillon",
  "образца": "échantillon",
  "образцов": "échantillons",
  "оплачено до {0}": "payé jusqu’au {0}",
  "подарок до {0}": "cadeau jusqu’au {0}",
  "пока недоступно": "indisponible pour le moment",
  "политику конфиденциальности STEOS": "politique de confidentialité de STEOS",
  "продлится {0}": "renouvelé le {0}",
  "речи.": "de parole.",
  "токенов": "jetons",
  "условия": "conditions",
  "уточняется": "en cours de vérification",
  "Қазақша": "Қазақша",
  "← Профиль": "← Profil",
  "▶ Прослушать": "▶ Écouter",
  "Озвучка": "Voix off",
  "Клон": "Clone",
  "Студия": "Studio",
  "Баланс": "Solde",
  "История": "Historique",
  "Ещё": "Plus",
  "Клонирование голоса": "Clonage vocal",
  "Партнёрство": "Partenariat",
  "Добавить в чат": "Ajouter au chat",
  "Разделы": "Rubriques",
  "Главное меню": "Menu principal",
  "Выберите": "Choisir",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Toutes les photos ont été conservées après la fusion. Gardez-en jusqu’à cinq pour modifier votre apparence.",
  "Абзацы": "Paragraphes",
  "Альбом": "Album",
  "Аудио": "Audio",
  "Без изменения": "Inchangé",
  "Бесплатно по текущему тестовому dev-тарифу.": "Gratuit avec le tarif de développement de test actuel.",
  "Бесплатно по тестовому dev-тарифу": "Gratuit avec le tarif de développement de test",
  "В избранном пока пусто": "Les favoris sont encore vides",
  "В очереди": "Dans la file d'attente",
  "Вариант {0}": "Variante {0}",
  "Введите текст до 1000 символов": "Saisissez un texte de 1 000 caractères maximum",
  "Вернули": "Remboursé",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Impossible de restaurer l'élément dans l'historique. Le fichier restera dans le chat.",
  "Видео": "Vidéo",
  "Виды работ": "Types de travaux",
  "Все": "Tout",
  "Вчера": "Hier",
  "Выбранный вариант": "Option sélectionnée",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "L’option sélectionnée est indisponible. Revenez au profil et actualisez la liste.",
  "Выполняется": "En cours",
  "Высота голоса": "Hauteur de la voix",
  "Говорящее видео": "Vidéo parlante",
  "Голоса": "Voix",
  "Дата неизвестна": "Date inconnue",
  "Длительность": "Durée",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Aucun outil publié n’est disponible pour cette action pour le moment.",
  "Дополнительное поле": "Champ supplémentaire",
  "Заголовок": "Titre",
  "Загружаем историю…": "Chargement de l'historique…",
  "Загружаем работу…": "Chargement du travail…",
  "Загружаем результат…": "Chargement du résultat…",
  "Загружаем…": "Chargement…",
  "Загружено": "Chargé",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Le chargement n'est pas confirmé. Poursuivez la vérification de ce fichier.",
  "Заказ": "Commande",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "La commande n'est pas confirmée. La reprise vérifiera la requête précédente avec la même clé.",
  "Заменить файл": "Remplacer le fichier",
  "Избранное: {0}": "Favoris : {0}",
  "Инструмент обновляется. Обновите форму позже.": "L'outil est en cours de mise à jour. Actualisez le formulaire plus tard.",
  "Искать в {0} работах": "Rechercher parmi {0} travaux",
  "Искать в истории": "Rechercher dans l'historique",
  "Использовать фото выбранного варианта": "Utiliser la photo de la variante sélectionnée",
  "Используется выбранный голос.": "La voix sélectionnée est utilisée.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Le résultat de la génération est en cours de vérification. Aucun nouveau travail ne sera lancé automatiquement.",
  "К инструментам": "Accéder aux outils",
  "Кавер": "Reprise",
  "Карусель": "Carrousel",
  "Ключевые слова": "Mots-clés",
  "Коллаж": "Collage",
  "Кратко": "Résumé",
  "Кружки": "Messages vidéo",
  "Кружок": "Message vidéo",
  "Кто в кадре": "Personne dans le cadre",
  "Название": "Nom",
  "Не получилось": "Échec",
  "Не удалось выполнить": "Échec de l'exécution",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Impossible d'effectuer cette action sur ce travail. Actualisez-le et réessayez.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Impossible de terminer la création. Essayez de modifier les paramètres.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Impossible de charger l'historique. Réessayez.",
  "Не удалось загрузить студию.": "Impossible de charger le studio.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Impossible de charger la photo de la variante. Actualisez le profil.",
  "Не удалось обработать запись": "Impossible de traiter l'enregistrement",
  "Не удалось озвучить текст": "Impossible de doubler le texte",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Impossible d'ouvrir l'outil. Essayez d'actualiser la page.",
  "Не удалось открыть результат. Попробуйте снова.": "Impossible d'ouvrir le résultat. Réessayez.",
  "Не удалось отправить результат. Повторите отправку.": "Impossible d'envoyer le résultat. Réessayez l'envoi.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Impossible de contacter le service. Réessayez.",
  "Не удалось скопировать. Выделите текст вручную.": "Copie impossible. Sélectionnez le texte manuellement.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Impossible d'enregistrer l'envoi. Autorisez le stockage de l'onglet et réessayez.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Certains fichiers de la répétition ne sont plus disponibles. Téléversez-les à nouveau.",
  "Ничего не нашли": "Aucun résultat",
  "Нужно разных фото": "Photos différentes requises",
  "Обрабатываем запись": "Traitement de l'enregistrement",
  "Озвучиваем текст": "Doublage du texte",
  "Озвучить": "Doubler",
  "Озвучка готова": "Doublage prêt",
  "Озвучка проекта": "Doublage du projet",
  "Оплата": "Paiement",
  "Оплачено донатом": "Payé par don",
  "Определить автоматически": "Détecter automatiquement",
  "Основа": "Base",
  "Открыть результат": "Ouvrir le résultat",
  "Отменено": "Annulé",
  "Отправить в чат": "Envoyer dans le chat",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Envoi refusé. Consultez le message d'erreur.",
  "Отправка принята. Бот доставит результат в чат.": "Envoi accepté. Le bot livrera le résultat dans le chat.",
  "Отправлено": "Envoyé",
  "Переозвучить запись": "Redoubler l'enregistrement",
  "Переозвучка": "Redoublage",
  "Персонаж": "Personnage",
  "Площадка": "Plateforme",
  "Повтори движения": "Reproduire les mouvements",
  "Повторить": "Réessayer",
  "Подпись": "Légende",
  "Подтверждаю право использовать загружаемые материалы": "Je confirme avoir le droit d'utiliser les contenus téléversés",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Je confirme avoir le droit d'utiliser ces photos et avoir obtenu le consentement des personnes représentées pour créer une variante",
  "Поиск в истории": "Recherche dans l'historique",
  "Показатели истории": "Statistiques de l'historique",
  "Показатели истории временно недоступны": "Les statistiques de l'historique sont temporairement indisponibles",
  "Показать все работы": "Afficher tous les travaux",
  "Показать текст": "Afficher le texte",
  "Порядок": "Ordre",
  "Почистить запись": "Nettoyer l'enregistrement",
  "Прежний голос недоступен. Выберите другой голос.": "L'ancienne voix n'est plus disponible. Choisissez une autre voix.",
  "Преимущества": "Avantages",
  "Проверьте заполненные поля. Заказ не создан.": "Vérifiez les champs remplis. La commande n'a pas été créée.",
  "Проверяем итог операции": "Vérification du résultat de l'opération",
  "Проверяем отправку…": "Vérification de l'envoi…",
  "Проверяем результат": "Vérification du résultat",
  "Проверяем списание токенов": "Vérification du débit de jetons",
  "Продолжить проверку озвучки": "Poursuivre la vérification du doublage",
  "Работ пока нет": "Aucun travail pour le moment",
  "Работ: {0}": "Travaux : {0}",
  "Работа": "Travail",
  "Работа больше не найдена. Обновите историю.": "Travail introuvable. Actualisez l'historique.",
  "Работа из истории": "Travail issu de l'historique",
  "Работа не прошла проверку.": "Le travail n'a pas passé la vérification.",
  "Работа обновилась. Загрузите её ещё раз.": "Le travail a été mis à jour. Chargez-le à nouveau.",
  "Распознавание": "Reconnaissance",
  "Распознанный текст": "Texte reconnu",
  "Распознать речь": "Reconnaître la parole",
  "Расшифровка": "Transcription",
  "Режим озвучки": "Mode de doublage",
  "Результат": "Résultat",
  "Результат больше недоступен": "Le résultat n'est plus disponible",
  "Результат операции уточняется. Повторный запуск отключён.": "Le résultat de l'opération est en cours de vérification. Le nouveau lancement est désactivé.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Le résultat de l'envoi est encore inconnu. Relancez la vérification.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Le résultat de l'envoi est encore inconnu. Réessayez avec la même clé.",
  "Результат переозвучки": "Résultat du redoublage",
  "Результат работы": "Résultat du travail",
  "Реплики": "Répliques",
  "Речевая запись": "Enregistrement vocal",
  "Рилс": "Reel",
  "Сегодня": "Aujourd'hui",
  "Сейчас создаётся": "Création en cours",
  "Сервис сейчас недоступен.": "Le service est actuellement indisponible.",
  "Сессия истекла. Откройте приложение заново.": "La session a expiré. Rouvrez l'application.",
  "Синтез": "Synthèse",
  "Скачать": "Télécharger",
  "Скачать все файлы": "Télécharger tous les fichiers",
  "Скачать набор": "Télécharger le lot",
  "Скопировано": "Copié",
  "Скопировать": "Copier",
  "Слайды": "Diapositives",
  "Слишком много запросов. Подождите немного.": "Trop de requêtes. Veuillez patienter un instant.",
  "Слушать результат": "Écouter le résultat",
  "Смена голоса": "Changement de voix",
  "Сначала новые": "Du plus récent au plus ancien",
  "Сначала старые": "Du plus ancien au plus récent",
  "Создать": "Créer",
  "Создаётся": "Création en cours",
  "Списано": "Débité",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Le statut n'est pas encore confirmé. Vérification de la commande précédente.",
  "Статус текущих заказов временно недоступен": "Le statut des commandes en cours est temporairement indisponible",
  "Стиль": "Style",
  "Стоимость": "Coût",
  "Сцена": "Scène",
  "Съёмка": "Séance photo",
  "Текст": "Texte",
  "Текст для озвучки": "Texte à doubler",
  "Текст песни": "Paroles de la chanson",
  "Текст поста": "Texte de la publication",
  "Товар": "Produit",
  "Удалить из истории": "Supprimer de l'historique",
  "Удалить из истории?": "Supprimer de l'historique ?",
  "Уточняем результат": "Vérification du résultat",
  "Уточняем состояние сохранённого заказа…": "Vérification de l'état de la commande enregistrée…",
  "Файл в чате останется": "Le fichier restera dans le chat",
  "Файлов: {0}": "Fichiers : {0}",
  "Форма недоступна.": "Formulaire indisponible.",
  "Формат отправки": "Format d'envoi",
  "Фото": "Photo",
  "Фотосессии": "Séances photo",
  "Фотосессия": "Séance photo",
  "Фотосессия товара": "Séance photo du produit",
  "Части": "Parties",
  "Шаблон": "Modèle",
  "Эта работа недоступна вашему аккаунту.": "Ce travail n'est pas accessible à votre compte.",
  "Это вся история": "C'est tout pour l'historique",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Cet outil est actuellement indisponible. Essayez d'actualiser le formulaire.",
  "Язык записи": "Langue de l'enregistrement",
  "MP3 · пауза между репликами 0,6 с": "MP3 · pause de 0,6 s entre les répliques",
  "{0} / 1 000 знаков": "{0} / 1 000 caractères",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 caractères · version {1}",
  "{0} реплик": "{0} répliques",
  "{0} ролей · {1} новых реплик": "{0} rôles · {1} nouvelles répliques",
  "Аудио больше недоступно. Обновите статус проекта.": "L’audio n’est plus disponible. Mettez à jour le statut du projet.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Presse-papiers indisponible. Collez le texte manuellement dans le champ.",
  "В проекте должно быть от 1 до 50 ролей.": "Le projet doit comporter entre 1 et 50 rôles.",
  "В проекте может быть не больше 500 реплик.": "Le projet ne peut pas comporter plus de 500 répliques.",
  "Вставить из буфера": "Coller depuis le presse-papiers",
  "Вставить сценарий": "Coller le scénario",
  "Выберите голос для каждой непустой роли.": "Sélectionnez une voix pour chaque rôle non vide.",
  "Выше": "Plus haut",
  "Голос {0}": "Voix {0}",
  "Голос роли": "Voix du rôle",
  "Готовим аудио…": "Préparation de l’audio…",
  "Добавить {0} реплик": "Ajouter {0} répliques",
  "Добавьте реплику или вставьте сценарий.": "Ajoutez une réplique ou collez un scénario.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Attendez le chargement du fichier partagé, puis réessayez.",
  "Дублировать": "Dupliquer",
  "Загружаем аудио…": "Chargement de l’audio…",
  "Загружаем проекты…": "Chargement des projets…",
  "Загрузить версию сервера": "Charger la version du serveur",
  "Закрыть раздел без сохранения изменений?": "Fermer la section sans enregistrer les modifications ?",
  "Заменить текущие роли и реплики?": "Remplacer les rôles et les répliques actuels ?",
  "Заменить текущий сценарий": "Remplacer le scénario actuel",
  "Изменить сценарий": "Modifier le scénario",
  "Имя роли": "Nom du rôle",
  "Кто говорит": "Qui parle",
  "Мои проекты": "Mes projets",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Appuyez sur Lecture dans le lecteur pour activer le son.",
  "Название проекта": "Nom du projet",
  "Название слишком длинное.": "Le nom est trop long.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Impossible de récupérer les opérations. Ne relancez pas la synthèse vocale ; consultez l’historique.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Action impossible. Les modifications restent affichées à l’écran.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Impossible de charger l’audio. Vérifiez votre connexion et réessayez.",
  "Не удалось озвучить проект": "Impossible de générer la voix du projet",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Impossible de préparer l’audio. Vérifiez la réplique et la voix sélectionnée.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Impossible de vérifier le propriétaire du projet. Actualisez la page.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Solde Circle insuffisant. Rechargez votre solde et réessayez.",
  "Ниже": "Plus bas",
  "Новый дубль реплики": "Nouvelle prise de la réplique",
  "Общий файл · MP3": "Fichier partagé · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "L’une des voix n’est plus disponible. Sélectionnez une autre voix.",
  "Озвучено реплик: {0} из {1}": "Répliques synthétisées : {0} sur {1}",
  "Озвучиваем проект": "Synthèse vocale du projet",
  "Озвучить · {0} Circle": "Synthétiser · {0} Circle",
  "Озвучить проект": "Synthétiser le projet",
  "Озвучка проектов": "Voix off de scripts",
  "Озвучка уже выполняется. Дождитесь результата.": "Une synthèse vocale est déjà en cours. Attendez le résultat.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "L’opération a déjà été acceptée ou son état est inconnu. Vérifiez la requête précédente.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Abandonner les modifications locales et charger la version du serveur ?",
  "Открыть в истории": "Ouvrir dans l’historique",
  "Отменить изменения": "Annuler les modifications",
  "Отменить несохранённые изменения?": "Annuler les modifications non enregistrées ?",
  "Перед озвучкой дождитесь сохранения изменений.": "Attendez l’enregistrement des modifications avant de lancer la synthèse vocale.",
  "Переозвучить": "Régénérer la voix",
  "Переозвучить реплику": "Régénérer la voix de la réplique",
  "Повторить проверку": "Vérifier à nouveau",
  "Подтвердить и запустить": "Confirmer et lancer",
  "Подтверждение озвучки": "Confirmation de la synthèse vocale",
  "Проверить прежний запрос": "Vérifier la requête précédente",
  "Проверить статус": "Vérifier le statut",
  "Проверьте роли, голоса и длину реплик.": "Vérifiez les rôles, les voix et la longueur des répliques.",
  "Проект больше недоступен.": "Le projet n’est plus disponible.",
  "Проект длиннее 20 000 знаков.": "Le projet dépasse 20 000 caractères.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Le projet a été modifié dans une autre fenêtre. Comparez votre version et chargez la version la plus récente.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Le projet a été modifié. Enregistrez-le et vérifiez à nouveau le prix.",
  "Проект или результат больше недоступен.": "Le projet ou le résultat n’est plus disponible.",
  "Проект озвучен": "Projet synthétisé",
  "Проекты {0}": "Projets {0}",
  "Прослушать": "Écouter",
  "Прослушать реплику": "Écouter la réplique",
  "Прослушать текущую версию": "Écouter la version actuelle",
  "Прослушивание в очереди": "Écoute en attente",
  "Прослушивание реплики": "Écoute de la réplique",
  "Результат изменился. Загрузите его актуальную версию.": "Le résultat a changé. Chargez sa version la plus récente.",
  "Результат озвучки проекта": "Résultat de la synthèse vocale du projet",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Le résultat est en cours de vérification. Aucune nouvelle génération ne sera lancée automatiquement.",
  "Реплика {0}": "Réplique {0}",
  "Реплика длиннее 1 000 знаков.": "La réplique dépasse 1 000 caractères.",
  "Реплики · {0}": "Répliques · {0}",
  "Реплику {0} выше": "Monter la réplique {0}",
  "Реплику {0} ниже": "Descendre la réplique {0}",
  "Роли и голоса": "Rôles et voix",
  "Роль {0}": "Rôle {0}",
  "Роль реплики": "Rôle de la réplique",
  "Скачать MP3": "Télécharger le MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Trop de demandes. Patientez, puis relancez la vérification.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Créez un projet, puis collez un scénario ou ajoutez des rôles et des répliques.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Le coût a été confirmé par le serveur. Vérifier à nouveau cette même requête n’entraîne aucun nouveau débit.",
  "Стоимость: {0} Circle": "Coût : {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "Les lignes « Nom : réplique » deviendront des rôles et des répliques. Vous pouvez conserver les codes temporels.",
  "Сценарий": "Scénario",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Le scénario a changé. Cette piste correspond à une version précédente du projet.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Scénario avec rôles — chaque rôle utilise sa propre voix.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Le texte ou la voix a changé. Une nouvelle écoute est nécessaire pour la version actuelle.",
  "Текст реплики": "Texte de la réplique",
  "Удалить проект": "Supprimer le projet",
  "Удалить реплику {0}": "Supprimer la réplique {0}",
  "Удалить реплику?": "Supprimer la réplique ?",
  "Удалить роль {0}": "Supprimer le rôle {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Supprimer le rôle « {0} » ainsi que ses répliques ({1}) ?",
  "Удалить этот проект?": "Supprimer ce projet ?",
  "Укажите имя каждой роли.": "Saisissez le nom de chaque rôle.",
  "Уточняем результат озвучки": "Vérification du résultat de la synthèse vocale",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Le prix a changé. Vérifiez le nouveau prix avant de lancer l’opération.",
  "есть несохранённые изменения": "modifications non enregistrées",
  "сохранено": "enregistré",
  "＋ Новый проект": "＋ Nouveau projet",
  "＋ Реплика": "＋ Réplique",
  "＋ Роль": "＋ Rôle",
  "Circle из пакетов без срока действия.": "Cercles issus de packs sans date d’expiration.",
  "Circle каждый месяц": "Cercles chaque mois",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Les cercles sont crédités tous les {0} jours, le premier lot immédiatement.",
  "Circle этой партии действуют до {0}": "Les cercles de ce lot sont valables jusqu’au {0}",
  "{0} Circle каждый месяц": "{0} cercles par mois",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} cercles par mois · jusqu’à {1} de vos propres voix",
  "{0} мес.": "{0} mois",
  "Баланс и профиль": "Solde et profil",
  "В текущем месяце осталось {0} из {1} Circle": "Il reste {0} cercles sur {1} pour le mois en cours",
  "Ваш текущий тариф": "Votre forfait actuel",
  "Включить тестовое продление": "Activer le renouvellement de test",
  "Выбор тарифа": "Choisir un forfait",
  "Действует до {0}": "Valable jusqu’au {0}",
  "Для этой подписки продление пока недоступно.": "Le renouvellement n’est pas encore disponible pour cet abonnement.",
  "До {0} своих голосов": "Jusqu’à {0} de vos propres voix",
  "До {0} сохраняется текущий тариф.": "Le forfait actuel est conservé jusqu’au {0}.",
  "Докупить Circle": "Acheter des cercles supplémentaires",
  "Доступные сроки": "Durées disponibles",
  "Загружаем подписку…": "Chargement de l’abonnement…",
  "Запланировать переход": "Planifier le changement",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "La demande ne correspond pas à l’opération enregistrée. Ne relancez pas l’achat ; contactez l’assistance.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Le résultat de la demande précédente doit être vérifié. Tout nouvel achat est temporairement bloqué.",
  "Начислить {0} тестовых Circle": "Créditer {0} cercles de test",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Impossible de récupérer l’opération. Vérifiez votre abonnement avant tout nouvel achat.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Opération confirmée. Actualisez les données ; il n’est pas nécessaire de renouveler l’achat.",
  "Оставить текущий тариф": "Conserver le forfait actuel",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "L’annulation du renouvellement conserve le forfait et les limites jusqu’à la fin de la période payée.",
  "Отменить продление": "Annuler le renouvellement",
  "Оформить dev-подписку": "Souscrire un abonnement dev",
  "Пакет Circle начислен.": "Pack de cercles crédité.",
  "Пакеты Circle доступны с активной подпиской.": "Les packs de cercles sont disponibles avec un abonnement actif.",
  "Перейти на выбранный тариф": "Passer au forfait sélectionné",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Le changement prendra effet à la fin de l’abonnement actuel. Aucun paiement n’est requis pour le moment.",
  "Подписка": "Abonnement",
  "Подписка временно недоступна. Попробуйте обновить данные.": "L’abonnement est temporairement indisponible. Essayez d’actualiser les données.",
  "Подписка не продлится": "L’abonnement ne sera pas renouvelé",
  "Подписка обновлена.": "Abonnement mis à jour.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "L’abonnement est déjà actif. Actualisez les données et choisissez une action disponible.",
  "Подписка уже закончилась. Обновите данные.": "L’abonnement a déjà expiré. Actualisez les données.",
  "Подтвердить": "Confirmer",
  "Подтверждение подписки": "Confirmation de l’abonnement",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "L’achat est actuellement indisponible. Les paiements réels ne sont pas activés.",
  "Получить dev-пакет бесплатно": "Obtenir gratuitement un pack dev",
  "Потом: {0}": "Ensuite : {0}",
  "Предыдущая подписка закончилась {0}": "L’abonnement précédent a expiré le {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Lors du renouvellement d’une période payée, le nouveau lot sera crédité pendant la période suivante.",
  "Проверка операции": "Vérification de l’opération",
  "Продление включено": "Renouvellement activé",
  "Продлить подписку": "Renouveler l’abonnement",
  "Свои голоса": "Vos propres voix",
  "Свои голоса: {0} из {1}": "Vos propres voix : {0} sur {1}",
  "Сравнить тарифы": "Comparer les forfaits",
  "Срок": "Durée",
  "Срок подписки": "Durée de l’abonnement",
  "Срок: {0} мес.": "Durée : {0} mois",
  "Тариф останется до конца срока. Следующего продления не будет.": "Le forfait restera actif jusqu’à la fin de la période. Il n’y aura pas de renouvellement suivant.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Les forfaits sont temporairement indisponibles. Essayez d’actualiser les données plus tard.",
  "Текущий тариф": "Forfait actuel",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Catalogue dev de test. Aucun paiement réel ; des cercles de test sont crédités.",
  "Управление подпиской": "Gestion de l’abonnement",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Les conditions du forfait ont changé. Actualisez les données avant de confirmer.",
  "Что входит": "Inclus",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Il s’agit d’une opération dev gratuite. Aucun argent ni Telegram Stars ne sera débité.",
  "Этот переход между тарифами недоступен.": "Ce changement de forfait n’est pas disponible.",
  "Этот тариф больше недоступен. Обновите список.": "Ce forfait n’est plus disponible. Actualisez la liste.",
  "QR-код": "Code QR",
  "QR-код приглашения": "Code QR d’invitation",
  "{0} из {1} · {2} Circle": "{0} sur {1} · {2} Circle",
  "Виды заданий": "Types de missions",
  "Выполнение этого задания пока недоступно.": "L’exécution de cette mission n’est pas encore disponible.",
  "Готовим материал…": "Préparation du contenu…",
  "Действие подтверждено. Обновляем задания.": "Action confirmée. Mise à jour des missions.",
  "День {0}": "Jour {0}",
  "День {0} из {1}": "Jour {0} sur {1}",
  "Дней подряд: {0}": "Jours consécutifs : {0}",
  "Друзья": "Amis",
  "Ежедневная серия": "Série quotidienne",
  "Ежедневные": "Quotidiennes",
  "Есть награды": "Récompenses disponibles",
  "Забрать {0} Circle": "Récupérer {0} Circle",
  "Загружаем награды…": "Chargement des récompenses…",
  "Задание ещё не выполнено. Обновите прогресс.": "Mission non terminée. Actualisez votre progression.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "La mission valide l’ouverture de l’écran de publication d’une story. Telegram ne confirme pas sa publication.",
  "Заданий в этой группе пока нет.": "Aucune mission dans ce groupe pour le moment.",
  "Задания дня": "Missions du jour",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Revenez chaque jour. Un jour manqué remet la série à zéro.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Le résultat de la requête précédente doit être vérifié. Les nouveaux crédits sont temporairement bloqués.",
  "Копирование недоступно. Выделите текст вручную.": "La copie n’est pas disponible. Sélectionnez le texte manuellement.",
  "Материал для сторис": "Contenu pour la story",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Récompense confirmée. Actualisez les données ; inutile de demander un nouveau crédit.",
  "Награда получена": "Récompense reçue",
  "Награда получена. Завтра +{0} Circle": "Récompense reçue. Demain : +{0} Circle",
  "Награда уже получена. Обновите данные.": "Récompense déjà reçue. Actualisez les données.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Récompenses temporairement indisponibles. Essayez d’actualiser les données.",
  "Награды за друзей": "Récompenses pour les amis",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Les récompenses sont créditées en Circle : utilisables pour payer dans STEOS, elles ne peuvent pas être retirées.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Crédit non confirmé. Vérifiez la requête précédente ; la nouvelle récompense reste temporairement bloquée.",
  "Начисления приостановлены.": "Les crédits sont suspendus.",
  "Начислено {0} Circle": "{0} Circle crédités",
  "Начислено: {0} Circle": "Montant crédité : {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Impossible de récupérer la requête de récompense. Vérifiez votre solde et contactez l’assistance.",
  "Не удалось загрузить QR-код.": "Impossible de charger le code QR.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Impossible d’ouvrir l’écran de publication de la story. Aucune récompense n’a été créditée.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Impossible de préparer la story. Réessayez.",
  "Новый день: {0}": "Nouveau jour : {0}",
  "Обновить награды": "Actualiser les récompenses",
  "Обновятся: {0}": "Mises à jour prévues : {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Ouvrez la Mini App dans une version de Telegram compatible avec les stories.",
  "Открыть STEOS ID в профиле": "Ouvrir STEOS ID dans le profil",
  "Открыть сторис": "Ouvrir la story",
  "Отправить в сторис": "Publier en story",
  "Партнёрские данные временно недоступны.": "Les données du partenaire sont temporairement indisponibles.",
  "Партнёрство · Статистика, материалы и вывод": "Partenariat · Statistiques, contenus et retraits",
  "Первые шаги": "Premières étapes",
  "Перейти к заданию": "Accéder à la mission",
  "Получить ежедневную награду": "Recevoir la récompense quotidienne",
  "Приглашено: {0} · Покупателей: {1}": "Invités : {0} · Acheteurs : {1}",
  "Прогресс задания": "Progression de la mission",
  "Прогресс задания временно недоступен.": "La progression de la mission est temporairement indisponible.",
  "Промокод": "Code promo",
  "Разовые": "Ponctuelles",
  "Скопировать приглашение": "Copier l’invitation",
  "Скопировать промокод": "Copier le code promo",
  "Ссылка приглашения": "Lien d’invitation",
  "Сторис в Telegram": "Stories Telegram",
  "Челленджи недели": "Défis de la semaine",
  "Circle используются внутри STEOS": "Les Circle sont utilisés au sein de STEOS",
  "Telegram подтвердил отправку сообщения.": "Telegram a confirmé l’envoi du message.",
  "Без покупок": "Sans achats",
  "В этом списке пока нет друзей.": "Cette liste ne contient pas encore d’amis.",
  "Возможен вывод по условиям программы": "Le retrait est possible selon les conditions du programme",
  "Вопросы": "Questions",
  "Всё время": "Depuis toujours",
  "Вы здесь": "Vous êtes ici",
  "Выберите PDF, JPG или PNG.": "Choisissez un fichier PDF, JPG ou PNG.",
  "Выберите плательщика": "Choisir le payeur",
  "Выбрать чат в Telegram": "Choisir un chat dans Telegram",
  "Выбрать чат для отправки": "Choisir un chat pour l’envoi",
  "Вывод": "Retrait",
  "Вывод недоступен на текущем уровне.": "Le retrait n’est pas disponible au niveau actuel.",
  "Вывод сейчас недоступен.": "Le retrait est actuellement indisponible.",
  "Вывод средств": "Retrait de fonds",
  "Выплачен": "Payé",
  "Выставьте счёт на": "Facturer à",
  "Для вывода войдите в STEOS ID.": "Connectez-vous à STEOS ID pour effectuer un retrait.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Les niveaux et les tarifs publiés sont nécessaires au calcul.",
  "До уровня «{0}»: ещё {1} покупателей": "Encore {1} acheteurs avant le niveau « {0} »",
  "Доступно к выводу": "Montant disponible au retrait",
  "Доступных шаблонов пока нет.": "Aucun modèle n’est disponible pour le moment.",
  "Доход": "Revenus",
  "Если купят {0} друзей": "Si {0} amis effectuent un achat",
  "Есть покупки": "Achats effectués",
  "За этот период начислений пока нет.": "Aucun montant n’a encore été crédité pour cette période.",
  "Загружаем QR-код…": "Chargement du code QR…",
  "Загружаем друзей…": "Chargement des amis…",
  "Загружаем материалы…": "Chargement des ressources…",
  "Загружаем партнёрские данные…": "Chargement des données de partenariat…",
  "Загрузите проверенный счёт на оплату.": "Téléversez une facture vérifiée.",
  "Заказать материал в чат": "Commander une ressource dans le chat",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Demande acceptée. La livraison dans le chat n’est pas encore confirmée.",
  "Заявка принята. Статус выплаты появится в истории.": "Demande acceptée. Le statut du paiement apparaîtra dans l’historique.",
  "Заявок на вывод пока нет.": "Aucune demande de retrait pour le moment.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "La modification des coordonnées est bloquée jusqu’à ce que le résultat de cette demande soit disponible.",
  "Имя получателя": "Nom du bénéficiaire",
  "История выводов": "Historique des retraits",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Le résultat de la demande doit être vérifié. La nouvelle ressource reste bloquée.",
  "Как определяется уровень?": "Comment le niveau est-il déterminé ?",
  "Как это работает": "Comment ça marche",
  "Калькулятор станет доступен после публикации расчётной политики.": "Le calculateur sera disponible après la publication de la politique de calcul.",
  "Количество друзей": "Nombre d’amis",
  "Материалы": "Ressources",
  "Материалы временно недоступны. Попробуйте обновить список.": "Les ressources sont temporairement indisponibles. Essayez d’actualiser la liste.",
  "Материалы пока недоступны.": "Les ressources sont actuellement indisponibles.",
  "Месяц": "Mois",
  "Минимальная сумма": "Montant minimum",
  "На рассмотрении": "En cours d’examen",
  "Налоговый номер": "Numéro fiscal",
  "Начисления за период": "Crédits pour la période",
  "Начислено Circle": "Circle crédités",
  "Начислено за период: {0} Circle": "Crédité pour la période : {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Impossible d’enregistrer la demande en toute sécurité ou de vérifier son propriétaire. L’envoi n’a pas été effectué.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Impossible de rétablir l’envoi. Contactez le support avant de soumettre une nouvelle demande.",
  "Не удалось загрузить друзей.": "Impossible de charger les amis.",
  "Не удалось загрузить историю выводов.": "Impossible de charger l’historique des retraits.",
  "Не удалось загрузить тарифы.": "Impossible de charger les tarifs.",
  "Не удалось открыть отправку в Telegram.": "Impossible d’ouvrir l’envoi dans Telegram.",
  "Не удалось проверить владельца. Обновите страницу.": "Impossible de vérifier le propriétaire. Actualisez la page.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Impossible de lire la demande enregistrée. Tout nouveau retrait est bloqué.",
  "Не удалось сохранить состояние отправки.": "Impossible d’enregistrer l’état de l’envoi.",
  "Неделя": "Semaine",
  "Нет данных": "Aucune donnée",
  "Новая заявка": "Nouvelle demande",
  "Новая заявка на вывод сейчас недоступна.": "Il est actuellement impossible de soumettre une nouvelle demande de retrait.",
  "О программе": "À propos du programme",
  "Обзор": "Vue d’ensemble",
  "Обновите страницу или обратитесь в поддержку.": "Actualisez la page ou contactez le support.",
  "Обновить историю выводов": "Actualiser l’historique des retraits",
  "Обновить материалы": "Actualiser les ressources",
  "От {0} покупателей": "À partir de {0} acheteurs",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Aucune réponse reçue. Vérifiez cette même demande : ses données et sa clé sont conservées.",
  "Отклонён": "Rejeté",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Ouvrez la Mini App dans Telegram avec la prise en charge de l’envoi de ressources.",
  "Открыть сторис в Telegram": "Ouvrir une story dans Telegram",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "L’envoi n’est pas confirmé. Une nouvelle tentative vérifiera la demande précédente sans effectuer un nouvel envoi.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Envoi annulé. Vous pouvez rouvrir la sélection du chat.",
  "Оценка дохода": "Estimation des revenus",
  "Оценка за {0} месяцев: {1} Circle": "Estimation sur {0} mois : {1} Circle",
  "Оценка за месяц: {0} Circle": "Estimation mensuelle : {0} Circle",
  "Переходы": "Clics",
  "Период обзора": "Période d’aperçu",
  "Плательщик": "Payeur",
  "Подать заявку на вывод": "Soumettre une demande de retrait",
  "Подготовить QR-код": "Générer un code QR",
  "Подготовить другой материал": "Préparer une autre ressource",
  "Подготовить материал": "Préparer une ressource",
  "Поделитесь своей ссылкой или промокодом.": "Partagez votre lien ou votre code promo.",
  "Поделиться": "Partager",
  "Пока без покупок": "Aucun achat pour le moment",
  "Пока недоступно": "Pas encore disponible",
  "Покупатели": "Acheteurs",
  "Покупки друзей учитывает сервер STEOS ID.": "Les achats des amis sont comptabilisés par le serveur STEOS ID.",
  "Полные условия программы": "Conditions complètes du programme",
  "Пользователь": "Utilisateur",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Essayez STEOS : {0}\nCode promo : {1}",
  "Привязка до: {0}": "Association jusqu’au : {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "L’association d’un ami invité est valable pendant {0} mois.",
  "Приглашён: {0}": "Invité : {0}",
  "Проверить загрузку счёта": "Vérifier le téléversement de la facture",
  "Проверить ту же заявку": "Vérifier cette même demande",
  "Проверьте налоговый номер получателя.": "Vérifiez le numéro fiscal du bénéficiaire.",
  "Проверьте реквизиты и счёт.": "Vérifiez les coordonnées et la facture.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Vérifiez le montant du retrait : il doit s’agir d’un nombre entier dans la plage autorisée.",
  "Проверяем владельца…": "Vérification du propriétaire…",
  "Проверяем заявку или счёт…": "Vérification de la demande ou de la facture…",
  "Процент и доступность вывода определяет опубликованная программа.": "Le pourcentage et la disponibilité des retraits sont définis par le programme publié.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Les pourcentages, les délais et les restrictions sont indiqués d’après les données publiées par le serveur.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "La taille de la facture doit être comprise entre 1 octet et 10 Mo.",
  "Регистрации": "Inscriptions",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Le résultat du téléversement de la facture est inconnu. Vérifiez le téléversement sans renvoyer le fichier.",
  "Скачать PNG": "Télécharger le PNG",
  "Сколько действует привязка друга?": "Combien de temps l’association d’un ami reste-t-elle valable ?",
  "Скопировать текст": "Copier le texte",
  "Сохранена неподтверждённая заявка": "Demande non confirmée enregistrée",
  "Срок рассмотрения, дней": "Délai d’examen, en jours",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Le lien et le code promo sont ajoutés par le serveur. Choisissez une ressource disponible.",
  "Ссылка на полный документ условий пока не опубликована.": "Le lien vers le document complet des conditions n’a pas encore été publié.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "La story est ouverte dans Telegram. Vous devez confirmer la publication dans l’éditeur.",
  "Сумма в Circle": "Montant en Circle",
  "Сумма меньше минимальной суммы вывода.": "Le montant est inférieur au montant minimum de retrait.",
  "Сумма превышает доступный остаток.": "Le montant dépasse le solde disponible.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Facture à payer · PDF, JPG ou PNG, jusqu’à 10 Mo",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Le téléversement ou la vérification de la facture a échoué. Choisissez un fichier PDF, JPG ou PNG de 10 Mo maximum.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "La facture n’est pas encore confirmée. Réessayez de la vérifier ou choisissez un autre fichier.",
  "Счёт проверен": "Facture vérifiée",
  "Текст приглашения": "Texte d’invitation",
  "Текст сообщения": "Texte du message",
  "Тексты": "Textes",
  "Тестовая заявка": "Demande de test",
  "Тестовая программа dev. Реальные выплаты выключены.": "Programme de test dev. Les paiements réels sont désactivés.",
  "Тестовая программа: реальные выплаты отключены.": "Programme de test : les paiements réels sont désactivés.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Calcul de test dev. Il s’agit d’une estimation, aucun crédit n’est effectué.",
  "Укажите имя получателя: до 200 символов.": "Indiquez le nom du bénéficiaire : 200 caractères maximum.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Le serveur affiche le niveau en fonction des acheteurs comptabilisés. Consultez l’onglet « Niveaux ».",
  "Уровни": "Niveaux",
  "Условия начислений пока не опубликованы.": "Les conditions de crédit n’ont pas encore été publiées.",
  "Условия программы": "Conditions du programme",
  "Учёт переходов по ссылке пока недоступен.": "Le suivi des clics sur le lien est actuellement indisponible.",
  "Фильтр друзей": "Filtrer les amis",
  "Что делать, если данные не обновились?": "Que faire si les données ne sont pas actualisées ?",
  "Шаги": "Étapes",
  "Баннер": "Bannière",
  "QR-постер": "Affiche QR",
  "{0} / 300 знаков": "{0} / 300 caractères",
  "· до 20 МБ": "· jusqu’à 20 Mo",
  "Агент готовит ответ…": "L’agent prépare une réponse…",
  "Аудиозапись": "Enregistrement audio",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Gratuit uniquement en dev. Jusqu’à 30 secondes et 10 Mo. Le texte peut être modifié avant l’envoi.",
  "Ваш вопрос": "Votre question",
  "Вопрос или название инструмента": "Question ou nom de l’outil",
  "Вопросов: {0}": "Questions : {0}",
  "Вопросы · {0}": "Questions · {0}",
  "Восстанавливаем чат…": "Restauration de la conversation…",
  "Все сервисы работают": "Tous les services fonctionnent",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Choisissez un fichier MP3, WAV ou M4A de 20 Mo maximum.",
  "Выберите инструкцию к нужному инструменту или странице.": "Choisissez les instructions correspondant à l’outil ou à la page souhaités.",
  "Диктовать вопрос": "Dicter une question",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "La dictée n’a pas été confirmée. Vérifiez à nouveau la requête ou le téléversement précédent.",
  "До": "Jusqu’à",
  "Ещё спрашивают": "Questions fréquentes",
  "Загружаем справку…": "Chargement de l’aide…",
  "Загружаем статус…": "Chargement du statut…",
  "Закрыть чат": "Fermer la conversation",
  "ИИ-агент поддержки": "Agent d’assistance IA",
  "ИИ-агент сейчас недоступен.": "L’agent IA est actuellement indisponible.",
  "Инструкции": "Instructions",
  "Инструкции · {0}": "Instructions · {0}",
  "Инструкции пока не опубликованы.": "Aucune instruction n’a encore été publiée.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Le résultat de la requête est encore inconnu. Aucune nouvelle question n’est envoyée.",
  "Как пользоваться STEOS": "Comment utiliser STEOS",
  "Кружки и говорящие видео": "Messages vidéo ronds et vidéos parlantes",
  "Медленнее обычного": "Plus lent que d’habitude",
  "Написать агенту": "Écrire à l’agent",
  "Начать": "Commencer",
  "Начать новую диктовку": "Commencer une nouvelle dictée",
  "Не помогло": "Cela n’a pas aidé",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Impossible de restaurer la dictée. Toute nouvelle requête est bloquée.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Impossible de restaurer la conversation. Contactez l’assistance.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Impossible de charger l’assistance. Réessayez.",
  "Не удалось загрузить статус сервисов.": "Impossible de charger le statut des services.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Impossible de confirmer la réponse. Vous pouvez démarrer une nouvelle conversation ou contacter l’assistance.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Impossible d’obtenir une réponse. Vérifiez à nouveau la requête précédente sans poser de nouvelle question.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Impossible de vérifier le propriétaire de la conversation. Réessayez de l’ouvrir.",
  "Не удалось сохранить новый чат.": "Impossible d’enregistrer la nouvelle conversation.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Impossible d’enregistrer votre évaluation. Réessayez.",
  "Недоступен": "Indisponible",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Certains services fonctionnent plus lentement que d’habitude. Consulter le statut",
  "Нет подтверждённых данных": "Aucune donnée confirmée",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Aucun résultat. Essayez d’autres mots ou posez votre question à l’agent IA.",
  "Новый чат": "Nouvelle conversation",
  "Обзор приложения": "Présentation de l’application",
  "Обновить справку": "Actualiser l’aide",
  "Обновить статус": "Actualiser le statut",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Vérification publiée. Aucune surveillance automatique n’est annoncée.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "La réponse n’a pas été confirmée. Vérifiez la requête précédente ou contactez l’assistance.",
  "Отвечает по опубликованной справке STEOS": "Répond à partir de l’aide publiée de STEOS",
  "Открыть инструкции": "Ouvrir les instructions",
  "Открыть инструкцию": "Ouvrir les instructions",
  "Открыть инструмент": "Ouvrir l’outil",
  "Открыть ответ справки": "Ouvrir la réponse de l’aide",
  "Открыть раздел": "Ouvrir la section",
  "Отправить вопрос": "Envoyer la question",
  "Оценка ответа": "Évaluation de la réponse",
  "Очистить поиск": "Effacer la recherche",
  "Поиск по справке": "Rechercher dans l’aide",
  "Полезно": "Utile",
  "Помощь": "Aide",
  "Популярные вопросы": "Questions populaires",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "La dernière vérification est obsolète. L’état actuel est inconnu.",
  "Посмотреть короткий обзор": "Voir une brève présentation",
  "Предыдущая": "Précédent",
  "Проверено: {0}": "Vérifié : {0}",
  "Проверить диктовку": "Vérifier la dictée",
  "Пропустить": "Ignorer",
  "Работает": "Fonctionnel",
  "Распознать вопрос": "Reconnaître la question",
  "Распознаём вопрос…": "Reconnaissance de la question…",
  "Результаты поиска": "Résultats de recherche",
  "Следующая": "Suivant",
  "Советы": "Conseils",
  "Справка пока не опубликована.": "L’aide n’a pas encore été publiée.",
  "Спросите что угодно": "Posez votre question",
  "Спросить ИИ-агента": "Interroger l’agent IA",
  "Спросить ИИ-агента поддержки": "Interroger l’agent d’assistance IA",
  "Статус": "Statut",
  "Статус сервисов": "Statut des services",
  "Статус сервисов пока не публикуется.": "Le statut des services n’est pas encore publié.",
  "Статья недоступна": "Article indisponible",
  "Темы": "Sujets",
  "Темы пока не опубликованы.": "Aucun sujet n’a encore été publié.",
  "Точного ответа в справке нет.": "Aucune réponse exacte dans l’aide.",
  "Чат не отправляет сообщения человеку автоматически.": "La conversation n’envoie pas automatiquement de messages à une personne.",
  "Читаем запись…": "Lecture de l’enregistrement…",
  "Эта статья больше не входит в опубликованную справку.": "Cet article ne fait plus partie de l’aide publiée.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Sélectionnez un fichier MP3, WAV ou M4A de {0} Mo maximum.",
  "До {0} · до {1} МБ": "Jusqu’à {0} · jusqu’à {1} Mo",
  "Нужна запись от 1 секунды до {0}.": "L’enregistrement doit durer entre 1 seconde et {0}.",
  "Остановить запись · {0}": "Arrêter l’enregistrement · {0}",
  "{0} C/сек": "{0} i/s",
  "Все инструменты": "Tous les outils",
  "Все шаблоны": "Tous les modèles",
  "Вся подборка": "Toute la sélection",
  "Выбрать, кто играет": "Choisir qui joue",
  "Голос и музыка": "Voix et musique",
  "Двое": "Deux",
  "Дети": "Enfants",
  "Дешевле": "Moins cher",
  "Для бизнеса": "Pour les entreprises",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Plusieurs modèles sont disponibles pour cette action. Choisissez celui qui vous convient dans le catalogue.",
  "Загружаем шаблон…": "Chargement du modèle…",
  "Закрыть поиск": "Fermer la recherche",
  "Закрыть превью": "Fermer l’aperçu",
  "Инструменты": "Outils",
  "Искать во всех шаблонах": "Rechercher dans tous les modèles",
  "Короче": "Plus court",
  "Кто играет": "Qui joue",
  "Найти инструмент или шаблон": "Trouver un outil ou un modèle",
  "Не удалось загрузить выбранный вариант.": "Impossible de charger l’option sélectionnée.",
  "Не удалось загрузить шаблон. Обновите превью.": "Impossible de charger le modèle. Actualisez l’aperçu.",
  "Не удалось открыть инструмент.": "Impossible d’ouvrir l’outil.",
  "Несколько": "Plusieurs",
  "Новые": "Nouveaux",
  "Один": "Un",
  "от {0} C": "À partir de {0} C",
  "от {0} C/сек": "À partir de {0} C/s",
  "От {0} Circle": "À partir de {0} Circle",
  "От А до Я": "De A à Z",
  "Очистить": "Effacer",
  "Питомцы": "Animaux de compagnie",
  "По желанию": "Facultatif",
  "Подборка пока недоступна.": "La sélection est temporairement indisponible.",
  "Подборки": "Sélections",
  "Поиск": "Recherche",
  "Пока нет доступных шаблонов": "Aucun modèle disponible pour le moment",
  "Популярные": "Populaires",
  "После": "Après",
  "Превью шаблона": "Aperçu du modèle",
  "Пример результата пока не опубликован.": "L’exemple de résultat n’a pas encore été publié.",
  "Пример сейчас недоступен.": "L’exemple est actuellement indisponible.",
  "Рекомендуем": "Recommandés",
  "Смотреть все": "Tout voir",
  "Сначала": "Trier",
  "Сравнить до и после": "Comparer avant et après",
  "Стилей: {0}. Выбор на следующем шаге.": "{0} styles. Choisissez à l’étape suivante.",
  "Удерживайте для просмотра": "Maintenez pour prévisualiser",
  "Цена уточняется в форме создания.": "Le prix sera précisé dans le formulaire de création.",
  "Частые вопросы": "Questions fréquentes",
  "Что нужно": "Ce qu’il faut",
  "Что хотите сделать?": "Que souhaitez-vous faire ?",
  "Шаблоны и подборки": "Modèles et sélections",
  "Это действие пока недоступно.": "Cette action est temporairement indisponible.",
  "е": "e",
  "за секунду": "par seconde",
  "ё": "ё",
  "{0} C в минуту": "{0} € par minute",
  "{0} C за 100 знаков": "{0} € pour 100 caractères",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Le propriétaire de la session a changé. Revenez au studio après avoir actualisé la page.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Impossible de restaurer la demande enregistrée. Toute nouvelle génération est bloquée.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Impossible de mettre à jour la demande enregistrée. Toute nouvelle génération est bloquée.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Impossible de vérifier le propriétaire. Toute nouvelle génération est bloquée.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Impossible d’enregistrer la demande. L’envoi n’a pas été effectué.",
  "от {0} C в минуту": "À partir de {0} € par minute",
  "от {0} C за 100 знаков": "À partir de {0} € pour 100 caractères",
  "Проверить статус заказа": "Vérifier le statut de la commande",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Le statut n’est pas encore confirmé. Vérifiez à nouveau cette même commande plus tard.",
  "в минуту": "par minute",
  "за 100 знаков": "pour 100 caractères",
  "Анимация звука": "Animation sonore",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "La vidéo conservera la voix d’origine. Sélectionnez un extrait d’une minute maximum.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "La vidéo conservera les paroles d’origine. Vous pouvez modifier la voix. Sélectionnez un extrait d’une minute maximum.",
  "Вид персонажа": "Apparence du personnage",
  "Видео готово": "Vidéo prête",
  "Видео не создано": "Échec de la création de la vidéo",
  "Волна": "Onde",
  "Выберите, кто говорит": "Choisissez qui parle",
  "Выбранное фото": "Photo sélectionnée",
  "Движение": "Mouvement",
  "Добавьте видео": "Ajouter une vidéo",
  "Дополнительная настройка": "Paramètres supplémentaires",
  "Другой голос для записи": "Autre voix pour l’enregistrement",
  "Ещё вариант": "Une autre variante",
  "Ещё настройки": "Plus de paramètres",
  "Изменить данные": "Modifier les données",
  "Источник": "Source",
  "Источник лица": "Source du visage",
  "Источник речи": "Source vocale",
  "Кадр по вертикали": "Cadrage vertical",
  "Кадр по горизонтали": "Cadrage horizontal",
  "Каких движений избегать": "Mouvements à éviter",
  "Конец фрагмента, секунды": "Fin de l’extrait, en secondes",
  "Кружком": "En message vidéo",
  "Кружок готов": "Vidéo ronde prête",
  "Кружок не создан": "Échec de la création de la vidéo ronde",
  "Люди и персонажи": "Personnes et personnages",
  "Напишите текст или добавьте запись": "Saisissez du texte ou ajoutez un enregistrement",
  "Начало фрагмента, секунды": "Début de l’extrait, en secondes",
  "Не удалось загрузить виды персонажа.": "Impossible de charger les apparences des personnages.",
  "Не удалось загрузить людей и персонажей.": "Impossible de charger les personnes et les personnages.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Impossible de confirmer la fin de la commande. Aucune nouvelle génération n’a été lancée.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Impossible de vérifier la livraison. Ouvrez l’historique de la commande.",
  "Оставить голос записи": "Conserver la voix de l’enregistrement",
  "Открыть в чате": "Ouvrir dans le chat",
  "Отправлено в чат": "Envoyé dans le chat",
  "По умолчанию": "Par défaut",
  "Подтвердите право использовать материалы": "Confirmez que vous avez le droit d’utiliser ces contenus",
  "Полосы": "Bandes",
  "Портретное": "Format portrait",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "La commande précédente n’est pas encore terminée. Vérifiez d’abord son résultat.",
  "Приближение": "Zoom avant",
  "Проверка отклонила материал. Измените исходные данные.": "La vérification a rejeté le contenu. Modifiez les données source.",
  "Продолжить проверку отправки": "Poursuivre la vérification de l’envoi",
  "Результат недоступен. Проверьте историю заказа.": "Résultat indisponible. Consultez l’historique de la commande.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "L’envoi n’est pas encore confirmé. Poursuivez la vérification avec la même clé.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Le résultat n’est pas encore confirmé. Vérifiez cette commande avant d’en créer une nouvelle.",
  "Своё видео": "Votre vidéo",
  "Своё фото": "Votre photo",
  "Создание сейчас недоступно": "La création est temporairement indisponible",
  "Создать кружок": "Créer un message vidéo",
  "Создаём видео": "Création de la vidéo en cours",
  "Списание возвращено": "Débit remboursé",
  "Тестовый заказ без списания": "Commande de test sans débit",
  "Файлом": "En tant que fichier",
  "Фоновый звук": "Son d’arrière-plan",
  "Фото с лицом": "Photo avec visage",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Le prix ou la version de l’outil a changé. Actualisez le formulaire et vérifiez le coût.",
  "Человек или персонаж": "Personne ou personnage",
  "Что скажет?": "Que dira-t-il ?",
  "Напишите не меньше {0} знаков": "Écrivez au moins {0} caractères",
  "Текст отклонён проверкой. Измените текст.": "Le texte a été refusé lors de la vérification. Modifiez-le.",
  "В видео прозвучат новые слова.": "De nouveaux mots seront prononcés dans la vidéo.",
  "Если речь длиннее видео, ролик повторится.": "Si le discours est plus long que la vidéo, celle-ci sera répétée.",
  "Исходная речь": "Discours original",
  "Новая запись": "Nouvel enregistrement",
  "Новые слова текстом": "Nouveaux mots sous forme de texte",
  "Речь в видео": "Discours dans la vidéo",
  "Размер файла не должен превышать {0} МБ.": "La taille du fichier ne doit pas dépasser {0} Mo.",
  "До {0} МБ": "Jusqu’à {0} Mo",
  "Альбомное": "Paysage",
  "Альбомом": "En format paysage",
  "Без стиля": "Sans style",
  "В новом стиле": "Dans un nouveau style",
  "Вариант": "Variante",
  "Во весь экран": "Plein écran",
  "Восстановить фото": "Restaurer la photo",
  "Все стили": "Tous les styles",
  "Все темы": "Tous les thèmes",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Sélectionnez un outil dans le catalogue, puis confirmez l’utilisation de la photo.",
  "Выберите подходящее фото до {0} МБ.": "Choisissez une photo adaptée de {0} Mo maximum.",
  "Выберите стиль или свой референс": "Choisissez un style ou votre propre référence",
  "Выбран свой референс": "Votre propre référence est sélectionnée",
  "Выбрать стиль": "Choisir un style",
  "Двигайте картинку, чтобы выбрать кадр": "Déplacez l’image pour choisir le cadrage",
  "Диафрагма": "Ouverture",
  "Добавить человека": "Ajouter une personne",
  "Добавьте описание, от 10 знаков": "Ajoutez une description d’au moins 10 caractères",
  "Загрузите фото": "Télécharger une photo",
  "Заполните обязательные поля": "Remplissez les champs obligatoires",
  "Изменить фото": "Modifier la photo",
  "Использовать выбранное фото результата": "Utiliser la photo du résultat sélectionné",
  "Кадр": "Cadre",
  "Кадрирование": "Recadrage",
  "Как у фото": "Comme sur la photo",
  "Камера": "Appareil photo",
  "Найти настройку съёмки": "Trouver un réglage de prise de vue",
  "Найти стиль": "Trouver un style",
  "Настройки съёмки недоступны.": "Les réglages de prise de vue sont indisponibles.",
  "Начать новое улучшение": "Commencer une nouvelle amélioration",
  "Не выбран": "Non sélectionné",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Impossible de restaurer l’amélioration. Un nouvel envoi est bloqué.",
  "Не удалось загрузить режимы фото.": "Impossible de charger les modes photo.",
  "Не удалось загрузить фото.": "Impossible de charger la photo.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Impossible d’utiliser la photo du résultat. Ouvrez la commande d’origine et réessayez.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Impossible d’ouvrir le mode. Réessayez.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Impossible de transmettre la photo sélectionnée. Réessayez.",
  "Не удалось проверить владельца.": "Impossible de vérifier le propriétaire.",
  "Не удалось прочитать фото.": "Impossible de lire la photo.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Impossible d’améliorer le texte. Le texte d’origine a été conservé.",
  "О стиле": "À propos du style",
  "Объектив": "Objectif",
  "Оживить фото": "Animer la photo",
  "Описание во весь экран": "Description en plein écran",
  "Описание длиннее допустимого": "La description dépasse la longueur autorisée",
  "По вертикали": "Verticalement",
  "По горизонтали": "Horizontalement",
  "По описанию": "À partir d’une description",
  "Повторить прежнее улучшение": "Répéter l’amélioration précédente",
  "Подтвердите права на материалы": "Confirmez que vous disposez des droits sur les contenus",
  "Пример": "Exemple",
  "Проверить улучшение": "Vérifier l’amélioration",
  "Проверяем фото…": "Vérification de la photo…",
  "Ракурс": "Angle de vue",
  "Раскрасить чёрно-белое": "Coloriser une photo en noir et blanc",
  "Режим фото": "Mode photo",
  "Референс должен быть не меньше 256 × 256 пикселей.": "La référence doit mesurer au moins 256 × 256 pixels.",
  "Свернуть": "Réduire",
  "Свет": "Lumière",
  "Свой референс": "Votre propre référence",
  "Свой референс сейчас недоступен": "Votre propre référence est actuellement indisponible",
  "Сделать рилс": "Créer un Reel",
  "Сколько фото": "Nombre de photos",
  "Создать фото": "Créer une photo",
  "Создаём фото": "Création de la photo",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Le délai de vérification de l’amélioration a expiré. Le texte d’origine a été conservé.",
  "Тема стиля": "Thème du style",
  "Убрать из кадра": "Retirer du cadre",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "L’amélioration n’a pas encore été confirmée. Le texte d’origine a été conservé.",
  "Улучшить": "Améliorer",
  "Формат файла": "Format du fichier",
  "Фото готовы": "Photos prêtes",
  "Фото на аватарку": "Photo de profil",
  "Фото не создано": "Photo non créée",
  "Цвет": "Couleur",
  "Что дальше": "Étape suivante",
  "Что делает в кадре": "Action dans le cadre",
  "Выберите разных людей в кадре": "Choisissez des personnes différentes pour la scène",
  "Измените описание и попробуйте улучшить его снова.": "Modifiez la description et réessayez de l’améliorer.",
  "Использовать референс": "Utiliser la référence",
  "Авто": "Auto",
  "Без движения": "Sans mouvement",
  "Видео должно длиться не меньше секунды": "La vidéo doit durer au moins une seconde",
  "Выберите главное фото": "Choisissez la photo principale",
  "Выберите один исходный файл": "Choisissez un seul fichier source",
  "Выберите файл подходящего формата и размера": "Choisissez un fichier au format et à la taille acceptés",
  "Выберите фрагмент от 1 до 10 секунд": "Choisissez un extrait de 1 à 10 secondes",
  "Главное фото": "Photo principale",
  "Длительность исходника: {0} с": "Durée de la source : {0} s",
  "Добавить речь": "Ajouter de la parole",
  "Загрузите видео": "Importez une vidéo",
  "Загрузите фото или видео": "Importez une photo ou une vidéo",
  "Загрузить": "Importer",
  "Загрузить видео": "Importer une vidéo",
  "Загрузить фото": "Importer une photo",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Le son original n’est pas conservé : le modèle en crée un nouveau.",
  "Звук от модели": "Son généré par le modèle",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Le modèle crée l’ambiance sonore, les bruits et la musique. Vous pourrez ajouter de la parole ensuite.",
  "Использовать видео результата": "Utiliser la vidéo obtenue",
  "Исходное видео": "Vidéo source",
  "Исходный файл": "Fichier source",
  "Как двигаться": "Quel mouvement",
  "Конец фрагмента, мс": "Fin de l’extrait, ms",
  "Конец, секунды": "Fin, secondes",
  "Люди в кадре недоступны для этого режима": "Les personnes à l’image ne sont pas disponibles dans ce mode",
  "Начало фрагмента, мс": "Début de l’extrait, ms",
  "Начало, секунды": "Début, secondes",
  "Не удалось загрузить режимы видео.": "Impossible de charger les modes vidéo.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Impossible d’utiliser la vidéo obtenue. Ouvrez la commande d’origine et réessayez.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Impossible de transférer la vidéo. Ouvrez la commande d’origine et réessayez.",
  "Новое": "Nouveau",
  "Объёмное фото создаётся без звука": "La photo en relief est créée sans son",
  "Первый кадр": "Première image",
  "Продолжить загрузку": "Poursuivre l’import",
  "Разрешение": "Résolution",
  "Режим видео": "Mode vidéo",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Nous utiliserons la photo principale. Sélectionnez-la pour la recadrer.",
  "Снять": "Prendre",
  "Снять видео": "Filmer",
  "Создать видео": "Créer une vidéo",
  "Темп": "Rythme",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Format fixe : portrait 3:4, vidéo de 5 secondes",
  "Фото товара": "Photos du produit",
  "Фрагмент от 1 до 10 секунд": "Extrait de 1 à 10 secondes",
  "Хит": "Populaire",
  "Что изменить": "Que modifier",
  "Этот режим видео пока недоступен": "Ce mode vidéo est indisponible pour le moment",
  "Как у исходника": "Comme la source",
  "Со звуком": "Avec son",
  "Без звука": "Sans son",
  "5 секунд": "5 secondes",
  "10 секунд": "10 secondes",
  "Не удалось прочитать файл.": "Impossible de lire le fichier.",
  "1. Видео с вами": "1. Vidéo de vous",
  "1. Видео с движениями": "1. Vidéo des mouvements",
  "2. Кем стать": "2. Qui devenir",
  "2. Кто повторит": "2. Qui reproduira les mouvements",
  "Видео должно длиться не меньше {0} секунд": "La vidéo doit durer au moins {0} secondes",
  "Водяной знак — недоступен": "Filigrane — indisponible",
  "Вы, близкий или персонаж": "Vous, un proche ou un personnage",
  "Выберите допустимый фрагмент видео": "Choisissez un extrait de durée autorisée",
  "Выберите одного героя": "Choisissez un seul protagoniste",
  "Выберите фон": "Choisissez un arrière-plan",
  "Выберите, кто повторит движения": "Choisissez qui reproduira les mouvements",
  "Голос героя — недоступен": "Voix du personnage — indisponible",
  "Другой голос — недоступен": "Autre voix — indisponible",
  "Загрузите видео с движениями": "Importez une vidéo des mouvements",
  "Из видео": "De la vidéo",
  "Изменить людей и свои фото": "Gérer les personnes et vos photos",
  "Источник героя": "Source du protagoniste",
  "Исходный звук сохраняется, если он есть в ролике.": "Le son original est conservé si la vidéo en contient.",
  "Кадр, ракурс и фон берутся с фото героя.": "Le cadrage, l’angle et l’arrière-plan viennent de la photo du protagoniste.",
  "Кто повторит движения": "Qui reproduira les mouvements",
  "На фото должны быть видны голова, плечи и корпус.": "La tête, les épaules et le buste doivent être visibles sur la photo.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Une seule personne doit être à l’image. La tête, les épaules et le buste doivent être visibles dans la photo et la vidéo.",
  "Подтвердите права и согласие человека": "Confirmez les droits et le consentement de la personne",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Je confirme mes droits sur les contenus et le consentement de la personne à l’utilisation de son image",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "La conversion en vidéo ronde est indisponible : aucune piste audio n’est confirmée dans le résultat.",
  "Режим движения": "Mode de mouvement",
  "С героя": "Du protagoniste",
  "Смена голоса пока недоступна": "Le changement de voix est indisponible pour le moment",
  "Снять выбор": "Effacer la sélection",
  "Сохранение исходного звука не подтверждено.": "La conservation du son original n’est pas confirmée.",
  "Стать персонажем": "Devenir un personnage",
  "Сцена и движения берутся из видео; внешность может отличаться.": "La scène et les mouvements viennent de la vidéo ; l’apparence peut varier.",
  "Только свои фото или с согласием человека на фото": "Uniquement vos photos ou avec le consentement de la personne photographiée",
  "Фон": "Arrière-plan",
  "Фото героя": "Photo du protagoniste",
  "Фрагмент от {0} до {1} секунд": "Extrait de {0} à {1} secondes",
  "{0} символов": "{0} caractères",
  "Авито": "Avito",
  "Английский": "Anglais",
  "Выберите аудио или видео": "Choisissez un audio ou une vidéo",
  "Выбрать": "Choisir",
  "Гарантия": "Garantie",
  "Да": "Oui",
  "Для чего нужен промпт": "Usage du prompt",
  "Для этого инструмента сократите текст до 500 символов.": "Réduisez le texte à 500 caractères pour cet outil.",
  "Добавьте текст": "Ajoutez du texte",
  "Добавьте файл": "Ajoutez un fichier",
  "Дополнительные варианты": "Variantes supplémentaires",
  "Дополнительные варианты пока не подтверждены.": "Les variantes supplémentaires ne sont pas encore confirmées.",
  "Дружелюбный": "Amical",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Importez un enregistrement ou enregistrez votre voix. La transcription commence après confirmation.",
  "Исходное фото": "Photo source",
  "Как изменить текст": "Comment modifier le texte",
  "Комплект": "Contenu du lot",
  "Короткий": "Court",
  "Материал": "Matériau",
  "Музыка": "Musique",
  "На весь экран": "Plein écran",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Impossible d’ouvrir l’outil. Vérifiez le compte et la longueur du texte.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Impossible de confirmer les variantes. Vérifiez la même demande.",
  "Не удалось скачать текст.": "Impossible de télécharger le texte.",
  "Не удалось скопировать текст.": "Impossible de copier le texte.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Impossible d’enregistrer le brouillon. La création est bloquée pour éviter toute perte de données.",
  "Нейтральный": "Neutre",
  "Нет": "Non",
  "Объём описания": "Longueur de la description",
  "Описание товара": "Description du produit",
  "Повторить запрос с тем же ключом": "Réessayer avec la même clé",
  "Подарочный": "Cadeau",
  "Подробнее": "Plus détaillé",
  "Подробный": "Détaillé",
  "Подтверждаю права на материалы": "Je confirme mes droits sur les contenus",
  "Пожелания": "Préférences",
  "Показать время": "Afficher les horodatages",
  "Показать всё": "Tout afficher",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Vérifier la même demande",
  "Продающий": "Commercial",
  "Промпт из видео пока недоступен.": "Le prompt à partir d’une vidéo est indisponible pour le moment.",
  "Промпт из фото": "Prompt à partir d’une photo",
  "Разделить по собеседникам": "Séparer les interlocuteurs",
  "Размеры": "Dimensions",
  "Распознавание по ссылке YouTube пока недоступно.": "La transcription via un lien YouTube est indisponible pour le moment.",
  "Распознать": "Transcrire",
  "Редактировать текст": "Modifier le texte",
  "Сайт": "Site web",
  "Сбросить сохранённый черновик": "Réinitialiser le brouillon enregistré",
  "Скачать TXT": "Télécharger TXT",
  "Скопировать весь текст": "Copier tout le texte",
  "Собеседник {0}": "Interlocuteur {0}",
  "Создать промпт": "Créer un prompt",
  "Создать сценарий": "Créer un scénario",
  "Создаём текст": "Création du texte",
  "Сократите пожелания": "Raccourcissez vos préférences",
  "Сократите текст": "Raccourcissez le texte",
  "Список": "Liste",
  "Текст готов": "Le texte est prêt",
  "Текст из аудио и видео": "Texte à partir d’audio et de vidéo",
  "Текст не создан": "Le texte n’a pas été créé",
  "Тестовый режим без списания": "Mode test sans débit",
  "Тон описания": "Ton de la description",
  "Улучшить промпт": "Améliorer un prompt",
  "Уход": "Entretien",
  "Что добавить в описание": "Que faut-il ajouter à la description",
  "Экспертный": "Expert",
  "Язык": "Langue",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Ajoutez une photo dans l’outil ouvert.",
  "Не удалось открыть фото.": "Impossible d’ouvrir la photo.",
  "Текст для видео": "Texte pour la vidéo",
  "Цена этого выбора пока не подтверждена": "Le prix de ce choix n’est pas encore confirmé",
  "C за фото": "C par photo",
  "C за секунду": "C par seconde",
  "Обычный": "Normal",
  "Кто повторил": "Reproduit par",
  "Человек с фото": "Personne de la photo",
  "Сменить фон": "Changer l’arrière-plan",
  "Убрать лишнее": "Retirer le superflu",
  "Добавить очки": "Ajouter des lunettes",
  "Причёска": "Coiffure",
  "Улыбка": "Sourire",
  "Деловой образ": "Look professionnel",
  "Летний фон": "Arrière-plan d’été",
  "Машет рукой": "Fait signe de la main",
  "Ветер": "Vent",
  "Плавнее": "Plus fluide",
  "Ярче": "Plus lumineux",
  "День в ночь": "Du jour à la nuit",
  "Снег": "Neige",
  "Очки": "Lunettes",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Que doit montrer la photo ? Par exemple : une fille avec un parapluie dans une rue mouillée, le soir, les lumières des vitrines",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Que modifier sur la photo ? Par exemple : remplacer l’arrière-plan par une ville de nuit, ajouter des lunettes",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Qu’ajouter ou modifier ? Par exemple : un costume d’affaires, un léger sourire",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Que se passe-t-il dans la vidéo ? Par exemple : la caméra survole lentement une ville de nuit, des lumières et l’asphalte mouillé",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Quel mouvement ? Par exemple : sourit et fait signe de la main, du vent dans les cheveux",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Que modifier dans la vidéo ? Par exemple : remplacer l’arrière-plan par une ville de nuit, ajouter de la neige",
  "Что добавить? Например: движения плавнее, ярче": "Qu’ajouter ? Par exemple : des mouvements plus fluides, plus de luminosité",
  "Сменить голос в записи": "Changer la voix d’un enregistrement",
  "Загрузите запись": "Importez un enregistrement",
  "Ваша речь зазвучит выбранным голосом": "Vos paroles prendront la voix choisie",
  "Голосовое, интервью или заметку: уберём шум": "Message vocal, interview ou note : nous retirerons le bruit",
  "Библиотека и ваши клоны": "Bibliothèque et vos clones",
  "Без переозвучки, выберите другой": "Pas de conversion vocale, choisissez-en une autre",
  "· Мой голос": "· Ma voix",
  "· ещё {0}+ голосов": "· {0}+ autres voix",
  "Убрать шум": "Supprimer le bruit",
  "Перед сменой голоса уберём фон и эхо": "Avant de changer la voix, nous retirerons le fond et l’écho",
  "Оставим только голос, без фона и эха": "Nous ne garderons que la voix, sans fond ni écho",
  "Голосовым или файлом: выберете, когда запись будет готова": "En message vocal ou en fichier : vous choisirez quand l’enregistrement sera prêt",
  "Сменить голос": "Changer la voix",
  "Сделать голосовым": "Transformer en message vocal",
  "{0} · от {1} C": "{0} · à partir de {1} C",
  "Сначала остановите запись": "Arrêtez d’abord l’enregistrement",
  "Загрузите или запишите аудио": "Importez ou enregistrez un audio",
  "Читаем запись, секунду": "Lecture de l’enregistrement, un instant",
  "Запись длиннее {0}, загрузите короче": "L’enregistrement dépasse {0}, importez-en un plus court",
  "Выберите голос, которым зазвучит запись": "Choisissez la voix que prendra l’enregistrement",
  "Этот голос не умеет переозвучку, выберите другой": "Cette voix ne prend pas en charge la conversion, choisissez-en une autre",
  "Пауза": "Pause",
  "Длиннее {0}": "Plus de {0}",
  "Звучит запись": "Enregistrement en cours de lecture",
  "Прослушать запись": "Écouter l’enregistrement",
  "Загрузите запись короче": "Importez un enregistrement plus court",
  "Запись с микрофона": "Enregistrement du micro",
  "Без шума": "Sans bruit",
  "Как в записи": "Comme dans l’enregistrement",
  "Слушать": "Écouter",
  "Отправить голосовым": "Envoyer en message vocal",
  "Отправить файлом": "Envoyer en fichier",
  "Голосовое в чате": "Message vocal dans le chat",
  "Файл в чате": "Fichier dans le chat",
  "Голосовое в чате, в отдельной теме": "Message vocal dans le chat, dans un sujet à part",
  "Файл в чате, в отдельной теме": "Fichier dans le chat, dans un sujet à part",
  "Тут откроется тема чата, куда бот прислал голосовое": "Ici s’ouvrira le sujet du chat où le bot a envoyé le message vocal",
  "Тут откроется тема чата, куда бот прислал запись": "Ici s’ouvrira le sujet du chat où le bot a envoyé l’enregistrement",
  "Меняем голос": "Changement de voix",
  "Собираем запись": "Assemblage de l’enregistrement",
  "Шум убран": "Bruit supprimé",
  "Запись готова": "L’enregistrement est prêt",
  "Голос изменён": "Voix changée",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Vous pouvez quitter l’écran : le bot vous écrira quand l’enregistrement sera prêt.",
  "Голос ваш, шума больше нет.": "Votre voix, sans plus aucun bruit.",
  "Голос ваш, запись готова стать голосовым.": "Votre voix, et l’enregistrement est prêt à devenir un message vocal.",
  "Слова и интонация ваши, голос новый.": "Vos mots et votre intonation, une nouvelle voix.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Nous l’enverrons dans le chat en message vocal ou en fichier, comme vous préférez.",
  "Запись ещё собирается": "L’enregistrement est encore en cours d’assemblage",
  "Заставить говорить": "Faire parler",
  "Заменить запись": "Remplacer l’enregistrement",
  "Загружаем запись": "Import de l’enregistrement",
  "Запись загружена": "Enregistrement importé",
  "Запись собрана": "Enregistrement assemblé",
  "Запись не прошла проверку": "L’enregistrement n’a pas passé la vérification",
  "запись не собрана": "l’enregistrement n’a pas été assemblé",
  "голос не изменён": "la voix n’a pas été changée",
  "Не получилось убрать шум": "Impossible de supprimer le bruit",
  "Не получилось собрать запись": "Impossible d’assembler l’enregistrement",
  "Не получилось сменить голос": "Impossible de changer la voix",
  "Обновить форму": "Actualiser le formulaire",
  "Запись {0}": "Enregistrement {0}",
  "Проверяем доступность": "Vérification de la disponibilité",
  "Загрузите запись заново": "Importez à nouveau l’enregistrement",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Impossible de sélectionner la voix. Réessayez.",
  "Запись здесь недоступна, загрузите файл": "L’enregistrement n’est pas disponible ici, importez un fichier",
  "Не удалось прочитать запись, попробуйте ещё раз": "Impossible de lire l’enregistrement, réessayez",
  "Ваш голос": "Votre voix",
  "в аудио": "dans l’audio",
  "со скидкой, {0} водяной знак": "avec remise, filigrane {0}",
  "Запись ещё загружается": "L’enregistrement est encore en cours de chargement",
  "Проверяем отправку": "Vérification de l’envoi",
  "Этот способ отправки сейчас недоступен": "Ce mode d’envoi n’est pas disponible pour le moment",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "L’envoi n’est pas encore confirmé. Appuyez à nouveau : nous vérifierons la même demande.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Impossible de transmettre l’enregistrement. Ouvrez le travail dans « Historique » et réessayez.",
  "Попробовать ещё раз": "Réessayer",
  "Проверить ещё раз": "Vérifier à nouveau",
  "К настройкам": "Retour aux réglages",
  "Заказ не создан": "Commande non créée",
  "Заказ не подтверждён": "Commande non confirmée",
  "остаток": "solde",
  "Права на материалы": "Droits sur les contenus",
  "Только свои файлы или с согласия владельца": "Uniquement vos fichiers ou avec l’accord du propriétaire",
  "Загружаем файл": "Import du fichier",
  "Создаём": "Création",
  "Файл больше {0} МБ, загрузите меньше": "Le fichier dépasse {0} Mo, importez-en un plus petit",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "La photo fait moins de {0} × {1} pixels, importez-en une plus grande",
  "Видео длиннее {0}, загрузите короче": "La vidéo dépasse {0}, importez-en une plus courte",
  "Запись короче {0}, загрузите длиннее": "L’enregistrement dure moins de {0}, importez-en un plus long",
  "Видео короче {0}, загрузите длиннее": "La vidéo dure moins de {0}, importez-en une plus longue",
  "Не удалось открыть фото. Загрузите его заново.": "Impossible d’ouvrir la photo. Importez-la à nouveau.",
  "Не удалось открыть видео. Загрузите его заново.": "Impossible d’ouvrir la vidéo. Importez-la à nouveau.",
  "Можно до {0} фото": "Jusqu’à {0} photos",
  "Этот человек не участвует": "Cette personne ne participe pas",
  "Добавьте фото": "Ajoutez des photos",
  "Файл не читается, загрузите другой": "Le fichier est illisible, importez-en un autre",
  "Запись слишком короткая": "L’enregistrement est trop court",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Impossible d’ouvrir l’enregistrement pour l’écouter. Importez-le à nouveau.",
  "Файл не прошёл проверку. Выберите другой файл.": "Le fichier n’a pas passé la vérification. Choisissez un autre fichier.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Trop d’imports d’affilée. Attendez une minute et choisissez à nouveau le fichier.",
  "Файл не принят. Выберите его снова.": "Le fichier n’a pas été accepté. Choisissez-le à nouveau.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Le personnage, la voix ou le modèle choisi n’est plus disponible. Choisissez-en un autre — la commande n’a pas été créée.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "La création est indisponible pour le moment. La commande n’a pas été créée, aucun Circle n’a été débité.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Le travail précédent est encore en cours de création. Quand il sera prêt, renvoyez la commande.",
  "Политику и запрещённые темы не пропускаем.": "Nous n’acceptons ni la politique ni les sujets interdits.",
  "{0} C списаны, {1}.": "{0} C ont été débités, {1}.",
  "{0} C вернулись на баланс.": "{0} C ont été recrédités sur votre solde.",
  ", на шаге «{0}»": ", à l’étape « {0} »",
  "Сбой на нашей стороне": "Panne de notre côté",
  "{0} или {1}": "{0} ou {1}",
  "до {0}": "jusqu’à {0}",
  "Записать": "Enregistrer",
  "Заменить": "Remplacer",
  "Нужна запись: MP3, WAV или M4A": "Un enregistrement est requis : MP3, WAV ou M4A",
  "Нужно фото: JPG или PNG": "Une photo est requise : JPG ou PNG",
  "Нужно видео: MP4 или MOV": "Une vidéo est requise : MP4 ou MOV",
  "Нужен файл PDF, DOCX или TXT": "Un fichier PDF, DOCX ou TXT est requis",
  "Нужно фото или видео": "Une photo ou une vidéo est requise",
  "Файл больше {0} МБ": "Le fichier dépasse {0} Mo",
  "Остановить запись": "Arrêter l’enregistrement",
  "Запрашиваем микрофон": "Demande d’accès au micro",
  "Отменить запись": "Annuler l’enregistrement",
  "{0} КБ": "{0} Ko",
  "{0} МБ": "{0} Mo",
  "Не хватает {0} C · Пополнить": "Il manque {0} C · Recharger",
  "Не хватает Circle": "Pas assez de Circle",
  "Не хватает {0} C": "Il manque {0} C",
  "На балансе {0} C, нужно {1} C": "Solde : {0} C, il faut {1} C",
  "Создать за {0} вместо {1} C": "Créer pour {0} au lieu de {1} C",
  "Создать за {0} C вместо {1} C": "Créer pour {0} C au lieu de {1} C",
  "Со скидкой всё равно не хватает {0}": "Même avec la remise, il manque {0}",
  "Со скидкой всё равно не хватает {0} C": "Même avec la remise, il manque {0} C",
  "Для этой работы скидки нет": "Pas de remise pour ce travail",
  "Сделать дешевле на {0}%, с водяным знаком": "{0} % moins cher, avec filigrane",
  "Сделать дешевле на 10%, с водяным знаком": "10 % moins cher, avec filigrane",
  "Назад в студию": "Retour au studio",
  "Работа ещё создаётся": "Le travail est encore en cours de création",
  "Ваше фото": "Votre photo",
  "Ваши фото": "Vos photos",
  "Ваш текст": "Votre texte",
  "Ваша тема": "Votre sujet",
  "Тема поста": "Sujet de la publication",
  "Готовые кадры": "Clichés prêts",
  "Готовый кружок": "Vidéo ronde prête",
  "Готовый ролик": "Vidéo prête",
  "Готовое фото": "Photo prête",
  "Готовая аватарка": "Avatar prêt",
  "Готовые слайды": "Diapositives prêtes",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Une histoire prête avec vous : montage et musique sont déjà dans le modèle",
  "Пост в стиле шаблона, {0} на выбор": "Une publication dans le style du modèle, {0} au choix",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Un avatar pour les réseaux sociaux et les messageries, {0} au choix",
  "Фотосессия из {0} кадра в стиле шаблона": "Une séance de {0} cliché dans le style du modèle",
  "Фотосессия из {0} кадров в стиле шаблона": "Une séance de {0} clichés dans le style du modèle",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Votre photo prend vie dans une courte vidéo, {0} au choix",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Un personnage dira votre texte dans une vidéo ronde Telegram, {0} au choix",
  "Карусель слайдов для поста, {0} на выбор": "Un carrousel de diapositives pour la publication, {0} au choix",
  "{0} стиль": "{0} style",
  "{0} стиля": "{0} styles",
  "{0} стилей": "{0} styles",
  "{0}, выберете на следующем шаге": "{0}, à choisir à l’étape suivante",
  "Что скажет герой, до 250 знаков": "Ce que dira le personnage, jusqu’à 250 caractères",
  "1 фото": "1 photo",
  "Любое, где хорошо видно лицо": "N’importe laquelle où le visage est bien visible",
  "Лицо крупно и при хорошем свете": "Visage en gros plan, sous une bonne lumière",
  "Селфи, лицо крупно": "Un selfie, visage en gros plan",
  "Снимок оживёт в ролике": "La photo prendra vie dans une vidéo",
  "Или фото, из которых сделаем слайды": "Ou des photos dont nous ferons des diapositives",
  "Стиль кружка": "Style de la vidéo ronde",
  "1 человек": "1 personne",
  "Вы, близкие или персонаж": "Vous, un proche ou un personnage",
  "Ваши дети, до {0}": "Vos enfants, jusqu’à {0}",
  "Ребёнок, одно фото": "Un enfant, une photo",
  "Питомец, одно фото": "Un animal de compagnie, une photo",
  "Вы или близкие, одно фото": "Vous ou un proche, une photo",
  "По желанию: вы, близкие или персонаж": "Facultatif : vous, un proche ou un personnage",
  "По желанию: ваши дети, до {0}": "Facultatif : vos enfants, jusqu’à {0}",
  "По желанию: ребёнок, одно фото": "Facultatif : un enfant, une photo",
  "По желанию: питомец, одно фото": "Facultatif : un animal de compagnie, une photo",
  "По желанию: вы или близкие, одно фото": "Facultatif : vous ou un proche, une photo",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} cliché",
  "{0} кадра": "{0} clichés",
  "{0} кадров": "{0} clichés",
  "Выбрать, кто играет: {0}": "Choisir qui joue : {0}",
  "Сравнить: {0} и {1}": "Comparer : {0} et {1}",
  "Поровну": "Moitié-moitié",
  "Пример результата пока не опубликован": "L’exemple de résultat n’est pas encore publié",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Le résultat est enregistré dans « Historique ». Nous ne l’envoyons pas dans le chat : c’est votre choix dans les réglages.",
  "Результат сохранён в «Истории».": "Le résultat est enregistré dans « Historique ».",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Le fichier du résultat n’est pas encore disponible. Vérifiez le travail dans « Historique ».",
  ", голос для: {0}": ", voix pour : {0}",
  ", играет: {0}": ", joue : {0}",
  ": добавьте свои фото": " : ajoutez vos photos",
  ": добавьте фото": " : ajoutez des photos",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> sur <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG ou PNG, jusqu’à 10 Mo",
  "JPG, PNG · до {0} снимков": "JPG, PNG · jusqu’à {0} photos",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV ou M4A, jusqu’à 50 Mo",
  "MP4 или MOV, до 200 МБ": "MP4 ou MOV, jusqu’à 200 Mo",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX ou TXT, jusqu’à 20 Mo",
  "{0} и {1}": "{0} et {1}",
  "{0} фото": "{0} photos",
  "{0} фото · как в жизни": "{0} photos · comme dans la vraie vie",
  "{0}, персонаж": "{0}, personnage",
  "Анфас, вполоборота, с улыбкой и без": "De face, de trois quarts, avec et sans sourire",
  "Без модели": "Sans modèle",
  "Без сильных теней и фильтров": "Sans ombres marquées ni filtres",
  "Было": "Avant",
  "В близких": "Dans les proches",
  "В кадре {0}": "Dans le cadre : {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Déjà {0} sur {1} dans le cadre : retirez une sélection",
  "В кадре: {0}": "Dans le cadre : {0}",
  "В роли «{0}» не больше {1}": "Pas plus de {1} dans le rôle « {0} »",
  "В роль «{0}» персонажи не входят": "Les personnages ne peuvent pas jouer le rôle « {0} »",
  "В роль «{0}» подходят {1}": "Le rôle « {0} » convient à {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Les variantes sont créées à partir de vos photos dans « Avatar personnalisé ». Celle choisie apparaît dans « Personne dans le cadre » sur tous les écrans.",
  "Ваш питомец из близких": "Votre animal parmi vos proches",
  "Ваш ребёнок из близких": "Votre enfant parmi vos proches",
  "Ваши фото: один раз для всех инструментов": "Vos photos : une seule fois pour tous les outils",
  "Вкл": "Oui",
  "Впишите имя": "Saisissez un prénom",
  "Все <span class=\"mono\">{0}</span>": "Tous <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Toutes les options sont visibles",
  "Все персонажи": "Tous les personnages",
  "Вы и персонажи": "Vous et des personnages",
  "Вы или персонаж": "Vous ou un personnage",
  "Вы, близкие и персонажи": "Vous, vos proches et des personnages",
  "Вы, свои фото": "Vous, vos photos",
  "Вы: добавьте свои фото": "Vous : ajoutez vos photos",
  "Выберите вариант": "Choisissez une variante",
  "Выберите вариант для поля «{0}»": "Choisissez une option pour le champ « {0} »",
  "Выберите ниже": "Choisissez ci-dessous",
  "Выберите одного": "Choisissez une personne",
  "Выберите, кто играет: {0}": "Choisissez qui joue : {0}",
  "Выберите, кто это для вас": "Choisissez qui c’est pour vous",
  "Выбирать во всех инструментах без загрузки": "Choisir dans tous les outils sans importer à nouveau",
  "Выбор встанет во все инструменты": "Le choix s’applique à tous les outils",
  "Выбрать «{0}»": "Choisir « {0} »",
  "Выбрать вариант": "Choisir une variante",
  "Выбрать: {0}": "Choisir : {0}",
  "Выкл": "Non",
  "Выключится, когда выберете вариант": "Se désactive quand vous choisissez une option",
  "Группы": "Groupes",
  "Добавить": "Ajouter",
  "Добавить в кадр": "Ajouter au cadre",
  "Добавьте свои фото": "Ajoutez vos photos",
  "Добавьте свои фото или вариант": "Ajoutez vos photos ou une variante",
  "Добавьте фото: {0}": "Ajoutez des photos : {0}",
  "Другой голос": "Autre voix",
  "Ещё {0}: {1}": "{0} de plus : {1}",
  "Заготовки": "Modèles",
  "Загрузите файл": "Importez un fichier",
  "Загрузить ещё": "Importer d’autres",
  "Закрыть камеру": "Fermer la caméra",
  "Запись недоступна. Загрузите видео.": "L’enregistrement n’est pas disponible. Importez une vidéo.",
  "Здесь подходят {0}": "Ici conviennent {0}",
  "Здесь только персонажи своей подборки": "Ici, seulement les personnages de sa collection",
  "Играет: {0}": "Joue : {0}",
  "Из ваших фото": "À partir de vos photos",
  "Из каталога": "Du catalogue",
  "Изменить ваши фото": "Modifier vos photos",
  "Изменить свои фото": "Modifier vos photos",
  "Изменить: {0}": "Modifier : {0}",
  "Иллюстрация": "Illustration",
  "Имя": "Prénom",
  "Имя и фото · роли выбираются в ряду": "Prénom et photos · les rôles se choisissent dans la rangée",
  "Искать стиль": "Rechercher un style",
  "Каким вы будете": "Comment vous apparaîtrez",
  "Камера · лицо в кадр": "Caméra · visage dans le cadre",
  "Камера · селфи в кадр": "Caméra · selfie dans le cadre",
  "Камера недоступна · имитация": "Caméra indisponible · simulation",
  "Камера недоступна. Загрузите файл.": "La caméra n’est pas disponible. Importez un fichier.",
  "Каталог 2 400+ голосов, подборки": "Catalogue de plus de 2 400 voix, collections",
  "Ко всем стилям": "Vers tous les styles",
  "Кто будет моделью на фото": "Qui sera le modèle sur la photo",
  "Кто играет: <b>{0}</b>": "Qui joue : <b>{0}</b>",
  "Кто играет: {0}": "Qui joue : {0}",
  "Кто это для вас": "Qui est-ce pour vous",
  "Лицо в круг, смотрите в камеру": "Visage dans le cercle, regardez la caméra",
  "Люди": "Personnes",
  "Можно близких или персонажа": "Des proches ou un personnage",
  "Можно ваших близких": "Vos proches",
  "Можно до {0} видео": "Jusqu’à {0} vidéos",
  "Можно до {0} записей": "Jusqu’à {0} enregistrements",
  "Можно до {0} записи": "Jusqu’à {0} enregistrements",
  "Можно до {0} запись": "Jusqu’à {0} enregistrement",
  "Можно до {0} файл": "Jusqu’à {0} fichier",
  "Можно до {0} файла": "Jusqu’à {0} fichiers",
  "Можно до {0} файлов": "Jusqu’à {0} fichiers",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Ça marche, mais 3 photos ou plus donnent une ressemblance plus fidèle",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Ça marche, mais 3 photos ou plus donnent une ressemblance plus fidèle",
  "Можно себя или близких": "Vous-même ou vos proches",
  "Можно себя, близких или персонажа": "Vous-même, vos proches ou un personnage",
  "На этом экране вы в кадре всегда": "Sur cet écran, vous êtes toujours dans le cadre",
  "Навсегда, вместе с фото": "Définitivement, avec les photos",
  "Нажмите, чтобы выбрать": "Touchez pour choisir",
  "Найти": "Rechercher",
  "Напишите пару слов, и мы предложим варианты": "Écrivez quelques mots et nous proposerons des options",
  "Например: Барсик": "Par exemple : Max",
  "Например: Лёша": "Par exemple : Alex",
  "Нашли": "Trouvés",
  "Не получилось подготовить файл": "Impossible de préparer le fichier",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Impossible d’améliorer. Essayez d’ajouter quelques mots",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Trop long<span class=\"nfx\"> : jusqu’à {0} caractères</span>",
  "Необязательно: всё уже настроено": "Facultatif : tout est déjà réglé",
  "Ничего не нашлось": "Rien trouvé",
  "Нужно выбрать": "À choisir",
  "Объём": "Relief",
  "Один раз для всех инструментов": "Une seule fois pour tous les outils",
  "Отменить свой вариант": "Annuler votre option",
  "Отметьте, кто будет в кадре · {0}": "Indiquez qui sera dans le cadre · {0}",
  "Персонажи": "Personnages",
  "Подберём сами": "Nous choisissons pour vous",
  "Подбираем варианты": "Recherche d’options",
  "Пожилой": "Âgé",
  "Поиск стилей": "Recherche de styles",
  "Пока нечего сохранять": "Rien à enregistrer pour l’instant",
  "Попробуйте другое слово": "Essayez un autre mot",
  "Порядок здесь один": "Un seul ordre ici",
  "Примеры": "Exemples",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Sera retiré {0} avec les photos. Impossible de revenir en arrière.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Sera retiré des proches avec les photos. Impossible de revenir en arrière.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Sera retiré des proches et {0} avec les photos. Impossible de revenir en arrière.",
  "Профиль близкого": "Profil du proche",
  "Разные ракурсы и выражения": "Différents angles et expressions",
  "Реалистичный": "Réaliste",
  "Реалистичный, иллюстрация или 3D": "Réaliste, illustration ou 3D",
  "Роли": "Rôles",
  "Роль «{0}»": "Rôle « {0} »",
  "Роль «{0}» для женского персонажа": "Le rôle « {0} » est pour un personnage féminin",
  "Роль «{0}» для мужского персонажа": "Le rôle « {0} » est pour un personnage masculin",
  "Роль «{0}» для персонажей своей подборки": "Le rôle « {0} » est pour les personnages de sa collection",
  "Свой вариант": "Votre option",
  "Скачать здесь не получится": "Impossible de télécharger ici",
  "Создайте новый вариант": "Créez une nouvelle variante",
  "Сортировка": "Trier",
  "Сохранится в близких": "Sera enregistré dans les proches",
  "Сохранить в близких": "Enregistrer dans les proches",
  "Стало": "Après",
  "Только для этой фотосессии": "Uniquement pour ce shooting",
  "Удаление": "Suppression",
  "Удалить «{0}» {1}?": "Retirer « {0} » {1} ?",
  "Удалить «{0}» из близких?": "Retirer « {0} » des proches ?",
  "Удалить из близких": "Retirer des proches",
  "Удалить из фотосессии": "Retirer du shooting",
  "Удерживайте, чтобы посмотреть примеры": "Maintenez pour voir des exemples",
  "Управление": "Gestion",
  "Файл готов. Нажмите ещё раз": "Le fichier est prêt. Appuyez à nouveau",
  "Фото до 10 МБ, видео до 200 МБ": "Photos jusqu’à 10 Mo, vidéos jusqu’à 200 Mo",
  "Фрагмент": "Extrait",
  "Что делает? Например: поправляет шарф": "Que fait-il ? Par exemple : ajuste son écharpe",
  "Что делают в кадре": "Ce qu’ils font dans le cadre",
  "Эта настройка здесь закреплена": "Ce réglage est fixé ici",
  "Этот голос не умеет переозвучку записи": "Cette voix ne peut pas redoubler un enregistrement",
  "вариант «{0}»": "variante « {0} »",
  "взрослая": "adulte",
  "взрослый": "adulte",
  "всё видео умещается": "toute la vidéo tient",
  "выберите": "à choisir",
  "до <span class=\"mono\">{0}</span>": "jusqu’à <span class=\"mono\">{0}</span>",
  "до {0} человек": "jusqu’à {0} personnes",
  "до {0} человека": "jusqu’à {0} personnes",
  "ещё {0} из {1}": "encore {0} sur {1}",
  "женская роль": "rôle féminin",
  "из фотосессии": "du shooting",
  "из этой фотосессии": "de ce shooting",
  "камера": "caméra",
  "максимум {0} секунд": "{0} secondes maximum",
  "максимум {0} секунда": "{0} seconde maximum",
  "максимум {0} секунды": "{0} secondes maximum",
  "можно до <span class=\"mono\">{0}</span>": "jusqu’à <span class=\"mono\">{0}</span>",
  "мужская роль": "rôle masculin",
  "не из подборки этой роли": "pas de la collection de ce rôle",
  "не подходит по возрасту": "l’âge ne convient pas",
  "не участвует в этой фотосессии": "ne participe pas à ce shooting",
  "необязательно": "facultatif",
  "нет фото": "pas de photos",
  "нужно выбрать": "à choisir",
  "нужно: Вы": "requis : vous",
  "персонажи в эту роль не входят": "les personnages ne peuvent pas jouer ce rôle",
  "питомец": "animal",
  "по желанию": "au choix",
  "пожилая": "âgée",
  "пожилой": "âgé",
  "ребёнок": "enfant",
  "роль для взрослого": "rôle pour un adulte",
  "роль для женщины": "rôle pour une femme",
  "роль для мужчины": "rôle pour un homme",
  "роль для питомца": "rôle pour un animal",
  "роль для ребёнка": "rôle pour un enfant",
  "роль для человека": "rôle pour une personne",
  "Попробуйте другое слово или сбросьте тему": "Essayez un autre mot ou retirez le thème",
  "Искать среди {n}+ голосов": "Rechercher parmi {n}+ voix",
  "Голосов: {n}": "Voix : {n}",
  "Персонажей: {n}": "Personnages : {n}",
  "Голосов: {0}": "Voix : {0}",
  "Прослушать {n}": "Écouter {n}",
  "Загружаем ещё {n}": "Chargement de {n} de plus",
  "{a} из {b}": "{a} sur {b}",
  "Подборка": "Sélection",
  "Закрыть подборку": "Fermer la sélection",
  "По имени": "Par nom",
  "Загружаем подборки…": "Chargement des sélections…",
  "Не удалось загрузить голоса": "Impossible de charger les voix",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Impossible de lire l'extrait. Réessayez.",
  "Мой голос": "La mienne",
  "Мои": "Mes voix",
  "Своих голосов пока нет": "Pas encore de voix à vous",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Clonez votre voix, elle apparaîtra ici.",
  "Клонировать голос": "Cloner ma voix",
  "Открыть персонажа {0}": "Ouvrir {0}",
  "От": "Dès",
  "Тренды недели": "Tendances de la semaine",
  "Голоса, которые быстрее всего набирают заказы": "Les voix les plus demandées en ce moment",
  "Мужские": "Masculines",
  "Все мужские голоса библиотеки": "Toutes les voix masculines",
  "Женские": "Féminines",
  "Все женские голоса библиотеки": "Toutes les voix féminines",
  "Детские": "Enfants",
  "Детские и мультяшные голоса": "Voix d'enfants et de dessins animés",
  "меню: Озвучка": "Voix",
  "Системная": "Système",
  "Для аватарки и ленты": "Pour l’avatar et le fil",
  "Как снимок с телефона": "Comme une photo au téléphone",
  "Для ленты": "Pour le fil",
  "На весь экран телефона": "Plein écran du téléphone",
  "Для обложки и экрана": "Pour la couverture et l’écran",
  "Станет голосом по умолчанию для озвучки.": "Deviendra la voix par défaut des voix off.",
  "Когда генерация закончится": "Quand la génération est terminée",
  "Награды и серия": "Récompenses et série",
  "Напомним о награде за день": "Rappel de la récompense du jour",
  "Новые шаблоны и стили": "Nouveaux modèles et styles",
  "Не чаще раза в неделю": "Au plus une fois par semaine",
  "Новости STEOS": "Actualités STEOS",
  "Только крупные обновления": "Mises à jour majeures uniquement",
  "Тут откроется документ в браузере": "Le document s'ouvrira dans le navigateur",
  "Язык и валюта": "Langue et devise",
  "Интерфейс и цены картой": "Interface et prix par carte",
  "новое|новых|новых": "nouveau|nouveaux",
  "работа|работы|работ": "création|créations",
  "заказ|заказа|заказов": "commande|commandes",
  "Счётчики недоступны": "Compteurs indisponibles",
  "История пуста": "L'historique est vide",
  "Не задан": "Non défini",
  "Недоступны": "Indisponibles",
  "Срок истёк": "Expiré",
  "Не удалась": "Échec",
  "Готовится": "En préparation",
  "Запрошено": "Demandé",
  "Запрошено {0}": "Demandé {0}",
  "Недоступно": "Indisponible",
  "Пусто": "Vide",
  "Данные Mini App удалены": "Données de la Mini App supprimées",
  "Удаление данных не удалось": "Échec de la suppression des données",
  "Данные удалены частично": "Données partiellement supprimées",
  "Удаление требует проверки": "La suppression doit être vérifiée",
  "Запрос удаления принят": "Demande de suppression reçue",
  "Удаляем данные Mini App": "Suppression des données de la Mini App",
  "Удаление данных в очереди": "Suppression en file d'attente",
  "STEOS ID сохранён": "STEOS ID conservé",
  "Финансовые квитанции сохранены": "Reçus financiers conservés",
  "Статус удаления не подтверждён": "Statut de suppression non confirmé",
  "Удаление аккаунта": "Suppression du compte",
  "Удалить данные Mini App?": "Supprimer les données de la Mini App ?",
  "Удалить аккаунт?": "Supprimer le compte ?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Vos créations, voix et looks dans la Mini App seront supprimés. Votre STEOS ID et vos reçus seront conservés.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Vos créations, voix, looks et Circle seront supprimés. C'est irréversible.",
  "Удалить данные Mini App": "Supprimer les données de la Mini App",
  "Удалить аккаунт": "Supprimer le compte",
  "Данные Mini App. STEOS ID сохранится": "Données de la Mini App. STEOS ID reste",
  "Все данные удалятся навсегда": "Toutes les données seront supprimées définitivement",
  "В прототипе аккаунт не удаляется": "Le prototype ne supprime pas le compte",
  "Автовоспроизведение": "Lecture auto",
  "Пример при выборе голоса": "Extrait au choix d'une voix",
  "Присылать в чат": "Envoyer dans le chat",
  "Готовые работы от бота": "Créations prêtes du bot",
  "Уведомления и отклик": "Notifications et retour haptique",
  "Данные": "Données",
  "Выгрузить данные": "Exporter les données",
  "Настройки создания сейчас только для чтения": "Les réglages de création sont en lecture seule",
  "Формат по умолчанию": "Format par défaut",
  "Для новых фото и видео": "Pour les nouvelles photos et vidéos",
  "На экране создания их можно поменять для одной работы.": "Vous pouvez le changer pour une création sur l'écran de création.",
  "Сообщения приходят в чат с ботом": "Les messages arrivent dans le chat avec le bot",
  "Бот напишет только в ответ на действия": "Le bot répondra seulement à vos actions",
  "Уведомления пока недоступны": "Les notifications ne sont pas encore disponibles",
  "Вибрация": "Vibration",
  "Лёгкий отклик на нажатия": "Léger retour au toucher",
  "Выгрузка данных": "Export des données",
  "Выгрузка запрошена": "Export demandé",
  "Пришлём архив в чат в течение суток": "Nous enverrons l'archive dans le chat sous 24 h",
  "Настройки и доступные текстовые данные аккаунта": "Réglages et données texte disponibles du compte",
  "Ссылка на архив придёт в чат с ботом": "Le lien de l'archive arrivera dans le chat avec le bot",
  "Готовые работы и заказы": "Créations et commandes",
  "Клоны и записи образцов": "Clones et enregistrements d'échantillons",
  "Ваши фото и варианты себя": "Vos photos et looks",
  "Люди и питомцы из фотосессий": "Personnes et animaux des séances photo",
  "Запросить выгрузку": "Demander l'export",
  "Готовим архив": "Préparation de l'archive",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Cela prend quelques minutes. Vous pouvez fermer, l'export continuera",
  "Срок хранения архива истёк": "L'archive a expiré",
  "Запросите новую выгрузку данных": "Demandez un nouvel export",
  "Архив не собрался": "L'archive n'a pas pu être créée",
  "Запросите выгрузку ещё раз": "Redemandez l'export",
  "Не вошли: {0}": "Non inclus : {0}",
  "Вошли частично: {0}": "Partiellement inclus : {0}",
  "Не входят в выгрузку: {0}": "Hors export : {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Certaines données manquent. Le contenu exact est dans manifest.json de l'archive",
  "Архив готов, но не полностью": "Archive prête, mais incomplète",
  "Архив готов": "Archive prête",
  "Скачать можно до {0}": "Téléchargeable jusqu'au {0}",
  "Архив в формате ZIP": "Archive ZIP",
  "Скачать архив": "Télécharger l'archive",
  "Счётчики истории не загрузились": "Les compteurs n'ont pas chargé",
  "Загружаем историю": "Chargement de l'historique",
  "Проверьте связь и повторите загрузку": "Vérifiez la connexion et réessayez",
  "История очищена": "Historique effacé",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Vos voix, looks, proches et Circle sont toujours là",
  "Здесь появятся работы, когда вы что-то создадите": "Vos créations apparaîtront ici",
  "Раздел «История»": "Section Historique",
  "Работы": "Créations",
  "Фото, видео, кружки и озвучки": "Photos, vidéos, cercles et voix off",
  "Заказы": "Commandes",
  "Параметры и статусы генераций": "Paramètres et statuts des générations",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Vos voix, looks, proches et Circle restent.",
  "Удалить работы и заказы": "Supprimer créations et commandes",
  "Без возможности восстановления": "Action irréversible",
  "Подтверждение удаления": "Confirmer la suppression",
  "Попробовать: {0}": "Essayer : {0}",
  "Обновление": "Mise à jour",
  "Загружаем «Что нового»": "Chargement des nouveautés",
  "Новых обновлений пока нет": "Pas encore de nouveautés",
  "Уведомления сейчас не сохранить": "Impossible d'enregistrer les notifications pour l'instant",
  "Настройки сейчас только для чтения": "Les réglages sont en lecture seule",
  "Выгрузка не запросилась. Попробуйте ещё раз": "La demande d'export a échoué. Réessayez",
  "Удалить всю историю?": "Supprimer tout l'historique ?",
  "{0}. Вернуть не получится.": "{0}. C'est irréversible.",
  "История не очистилась. Попробуйте ещё раз": "L'historique n'a pas été effacé. Réessayez",
  "Удаление не началось. Попробуйте ещё раз": "La suppression n'a pas démarré. Réessayez",
  "Не удалось загрузить настройки": "Impossible de charger les réglages",
  "«Что нового» не загрузилось": "Les nouveautés n'ont pas chargé",
  "Сохранение настроек сейчас недоступно": "L'enregistrement est indisponible pour l'instant",
  "Настройки уже изменились, показываем актуальные": "Les réglages ont changé, voici les actuels",
  "Не удалось сохранить. Попробуйте ещё раз": "Échec de l'enregistrement. Réessayez",
  "Настройки, ресурсы и история": "Réglages, ressources et historique",
  "Данные Mini App": "Données de la Mini App",
  "Учётная запись и финансовые данные STEOS ID": "Compte et données financières STEOS ID",
  "Переписка с ботом": "Conversation avec le bot",
  "Фото, аудио, видео и модели": "Photos, audio, vidéos et modèles",
  "Данные других продуктов STEOS": "Données des autres produits STEOS",
  "Рубли": "Roubles",
  "Драмы": "Drams",
  "Евро": "Euros",
  "Доллары": "Dollars",
  "Другие языки": "Autres langues",
  "Интерфейс и сообщения бота": "Interface et messages du bot",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Les prix par carte s'affichent dans cette devise. Les Telegram Stars sont partout les mêmes.",
  "сегодня, {0}": "aujourd'hui, {0}",
  "вчера, {0}": "hier, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Carte ou SBP",
  "СБП только для РФ": "SBP uniquement en Russie",
  "1 месяц": "1 mois",
  "3 месяца": "3 mois",
  "6 месяцев": "6 mois",
  "Год": "Année",
  "год": "un an",
  "С днём рождения": "Joyeux anniversaire",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Joyeux anniversaire. Que tout réussisse du premier coup",
  "Просто так": "Juste comme ça",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Juste comme ça. Pour plus de cercles et de voix drôles",
  "Спасибо": "Merci",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Merci d'être là. Un petit cadeau de ma part",
  "С праздником": "Bonnes fêtes",
  "С праздником. Твори, снимай и удивляй": "Bonnes fêtes. Crée, filme et surprends",
  "Для блога": "Pour ton blog",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Pour ton blog : plus de vidéos, moins d'efforts",
  "Удачи": "Bonne chance",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Bonne chance pour ton nouveau projet. Que la voix et l'image soient comme prévu",
  "картой": "par carte",
  "оплата картой каждый месяц": "paiement par carte chaque mois",
  "оплата картой за {0}": "paiement par carte pour {0}",
  "{0} в месяц": "{0} par mois",
  "{0} за {1}": "{0} pour {1}",
  "кружок|кружка|кружков": "message vidéo|messages vidéo",
  "рилс|рилса|рилсов": "reel|reels",
  "свой голос|своих голоса|своих голосов": "voix perso|voix perso",
  "своего голоса|своих голосов|своих голосов": "voix perso|voix perso",
  "день|дня|дней": "jour|jours",
  "звезда|звезды|звёзд": "étoile|étoiles",
  "Подписаться на {0}": "S'abonner pour {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Renouvelé chaque mois, résiliable à tout moment",
  "Без автопродления, Circle приходят каждый месяц": "Sans renouvellement auto, les Circle arrivent chaque mois",
  "Перейти на {0}": "Passer à {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C arrivent tout de suite, et {1} ne sera plus renouvelé",
  "Сразу придут {0} C": "{0} C arrivent tout de suite",
  "Перейти на {0} с {1}": "Passer à {0} le {1}",
  "До {0} остаётся {1}, потом {2}": "{1} reste jusqu'au {0}, puis {2}",
  "Продлить на {0}": "Prolonger de {0}",
  "Ещё {0} после {1}, без автопродления": "{0} de plus après le {1}, sans renouvellement",
  "Следующее списание {0}, {1}": "Prochain prélèvement le {0}, {1}",
  "Способ оплаты": "Moyen de paiement",
  "Звёздами": "En étoiles",
  "Тестовая оплата": "Paiement test",
  "Звёзды и деньги не списываются": "Ni étoiles ni argent ne sont débités",
  "Оплата картой скоро": "Paiement par carte bientôt",
  "Ваш тариф": "Votre forfait",
  "выгоднее на {0}%": "{0} % plus avantageux",
  "{0} C в месяц": "{0} C par mois",
  "или": "ou",
  "Что сотворим в этом месяце?": "Qu'allez-vous créer ce mois-ci ?",
  "Готовы творить без пауз?": "Prêt à créer sans pause ?",
  "Ваш тариф {0}": "Votre forfait : {0}",
  "{0} C каждый месяц": "{0} C chaque mois",
  "До {0} {1}": "Jusqu'à {0} {1}",
  "Пакеты Circle, если не хватит": "Packs Circle si besoin",
  "{0} включает": "{0} comprend",
  "Сравнить": "Comparer",
  "Помесячно": "Mensuel",
  "Выгода {0}": "Économisez {0}",
  "Одним платежом": "En une fois",
  "{0} с {1}": "{0} à partir du {1}",
  "Оставить {0}": "Garder {0}",
  "Продлить {0}": "Renouveler {0}",
  "Продлить": "Renouveler",
  "Включить продление": "Activer le renouvellement",
  "Возобновить {0}": "Reprendre {0}",
  "Возобновить": "Reprendre",
  "Оплата пока не подключена": "Paiement pas encore connecté",
  "Сейчас недоступно": "Indisponible pour l'instant",
  "Переход на {0} на {1}": "Passage à {0} pour {1}",
  "Переход на {0}": "Passage à {0}",
  "Продление {0} на {1}": "Prolonger {0} de {1}",
  "Подписка {0} на {1}": "{0} pour {1}",
  "Как удобнее оплатить": "Choisissez comment payer",
  "Подарок друга": "Cadeau d'un ami",
  "{0} на первый пакет {1} после подписки": "{0} sur votre premier pack pendant {1} après l'abonnement",
  "Не загрузилось": "Échec du chargement",
  "Прошлую операцию не проверить": "Impossible de vérifier la dernière opération",
  "разрешите хранение данных и откройте раздел снова": "autorisez le stockage des données et rouvrez la section",
  "Оплата требует проверки": "Le paiement doit être vérifié",
  "Исход подтверждения оплаты ещё неизвестен": "Le résultat de la confirmation est encore inconnu",
  "Исход отмены счёта неизвестен": "Résultat de l'annulation de la facture inconnu",
  "Ждём подтверждения оплаты": "En attente de confirmation du paiement",
  "Исход прошлой операции неизвестен": "Résultat de la dernière opération inconnu",
  "проверьте его перед новой покупкой": "vérifiez-le avant un nouvel achat",
  "Проверить": "Vérifier",
  "Открыть оплату": "Ouvrir le paiement",
  "Отменить счёт": "Annuler la facture",
  "Продление отменено": "Renouvellement annulé",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Un message avec l'ancienne facture peut arriver. Il ne confirme pas un nouvel abonnement",
  "Продление требует проверки": "Le renouvellement doit être vérifié",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Facture non confirmée. Actualisez ou contactez le support",
  "Не удалось подготовить счёт": "Impossible de préparer la facture",
  "Сервер повторит проверку. Текущие права не меняются": "Le serveur revérifiera. Vos droits actuels ne changent pas",
  "Счёт отправлен": "Facture envoyée",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Le bot a envoyé une facture. L'abonnement démarre après paiement confirmé",
  "Счёт подготовлен": "Facture préparée",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Transmise au bot. Livraison et paiement pas encore confirmés",
  "Срок счёта истёк": "Facture expirée",
  "Продление не оплачено. Выберите тариф ещё раз": "Renouvellement non payé. Choisissez à nouveau un forfait",
  "Запланированное продление отменено": "Renouvellement prévu annulé",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Votre forfait reste le même. Un nouvel abonnement nécessite un paiement séparé",
  "Продление запланировано": "Renouvellement prévu",
  "Счёт на свою подписку придёт в конце подарочного месяца": "La facture de votre abonnement arrivera à la fin du mois offert",
  "Подарок ещё действует": "Le cadeau est encore actif",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "L'abonnement mensuel sera disponible ensuite. Pour l'instant, prolongez de 3 ou 12 mois",
  "выберите другой тариф или срок": "choisissez un autre forfait ou une autre durée",
  "−{0}% на первый пакет · ещё {1}": "−{0} % sur le premier pack · encore {1}",
  "Circle из пакетов не сгорают": "Les Circle des packs n'expirent pas",
  "Подарить другу": "Offrir à un ami",
  "С открыткой, без продления": "Avec carte, sans renouvellement",
  "Промокод {0}": "Code promo {0}",
  "{0} C, сгорят {1}": "{0} C, expirent le {1}",
  "Промокод применён": "Code promo appliqué",
  "{0} C и {1} на первый пакет": "{0} C et {1} sur le premier pack",
  "после подписки": "après l'abonnement",
  "Вы пришли по ссылке партнёра": "Vous êtes venu via un lien partenaire",
  "привязка уже действует": "le lien est déjà actif",
  "Есть промокод?": "Un code promo ?",
  "Загружаем тарифы": "Chargement des forfaits",
  "Счёт придёт {0}": "La facture arrivera le {0}",
  "Счёт придёт в конце текущего срока": "La facture arrivera à la fin de la période",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Le nouveau forfait démarre après paiement. Rien n'est débité maintenant.",
  "Оплата подтверждена": "Paiement confirmé",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "La période payée est déjà terminée. Les Circle des périodes passées ne sont pas crédités.",
  "Баланс пополнен": "Solde rechargé",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Votre solde est de {0} C. Les Circle des packs n'expirent pas",
  "следующие {0} C придут {1}": "les {0} C suivants arriveront le {1}",
  "До этой даты действует {0}": "{0} reste actif jusque-là",
  "{0} продлён до {1}": "{0} prolongé jusqu'au {1}",
  "Circle приходят каждый месяц, {0}": "Les Circle arrivent chaque mois, {0}",
  "Тариф {0} подключён": "Forfait {0} activé",
  "Подписка {0} оформлена": "Abonnement {0} souscrit",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Payé jusqu'au {0}. Les Circle arrivent chaque mois, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Abonnement test actif jusqu'au {0}. Rien n'est débité",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Les Circle sont valables jusqu'au {0}, prochain prélèvement ce jour-là : {1}",
  "Circle действуют до {0}, продление выключено": "Les Circle sont valables jusqu'au {0}, renouvellement désactivé",
  "В месяц": "Par mois",
  "Кружки или фото": "Cercles ou photos",
  "Видео говорит": "La vidéo parle",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Comparaison des forfaits",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Chaque forfait : {0} {1} au lieu de {2}, tous les outils du studio et les packs Circle",
  "Следующее списание": "Prochain prélèvement",
  "Сумма": "Montant",
  "Тестовая, без списаний": "Test, sans débit",
  "Картой": "Par carte",
  "Оплачено до": "Payé jusqu'au",
  "Действует до": "Actif jusqu'au",
  "Потом": "Ensuite",
  "Продление": "Renouvellement",
  "Счёт на {0} запланирован": "Facture {0} prévue",
  "подписку": "abonnement",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Arrive le {0}. Le nouveau forfait démarre après paiement",
  "Отменить": "Annuler",
  "Отменить подписку": "Résilier l'abonnement",
  "Тариф останется до {0}": "Le forfait reste jusqu'au {0}",
  "Потом тариф {0}": "Ensuite {0}",
  "Подарок на месяц": "Cadeau d'un mois",
  "Оплачено вперёд": "Payé d'avance",
  "Подписка {0}": "Abonnement {0}",
  "Условия тарифа уточняются": "Détails du forfait en cours de confirmation",
  "Сменить тариф": "Changer de forfait",
  "Отмена подписки": "Résiliation de l'abonnement",
  "Этот переход сейчас недоступен": "Ce changement est indisponible pour l'instant",
  "Переход уже назначен": "Changement déjà prévu",
  "Выберите другой тариф": "Choisissez un autre forfait",
  "С {0} начнётся этот тариф": "Ce forfait démarre le {0}",
  "Это ваш тариф": "C'est votre forfait",
  "К подписке": "Retour à l'abonnement",
  "Сейчас {0}, {1}": "Actuellement {0}, {1}",
  "Латиница, цифры и «_»": "Lettres latines, chiffres et _",
  "Ник начинается с буквы": "Doit commencer par une lettre",
  "Не короче 5 знаков": "Au moins 5 caractères",
  "Не длиннее 32 знаков": "32 caractères maximum",
  "Ник не кончается на _": "Ne peut pas finir par _",
  "Это ваш ник": "C'est votre pseudo",
  "Сначала проверьте прежнюю операцию": "Vérifiez d'abord l'opération précédente",
  "Подарок сейчас недоступен": "Le cadeau est indisponible pour l'instant",
  "Укажите ник друга в Telegram": "Indiquez le pseudo Telegram de votre ami",
  "Проверьте ник": "Vérifiez le pseudo",
  "Друг увидит: {0}": "Votre ami verra : {0}",
  "Подарок придёт без имени": "Le cadeau arrivera sans nom",
  "{0} дарит вам": "{0} vous offre",
  "вам подарили": "on vous offre",
  "Вам подарили": "On vous offre",
  "{0} подписку STEOS {1} на месяц.": "{0} un abonnement STEOS {1} d'un mois.",
  "Забрать подарок": "Récupérer le cadeau",
  "От друга": "D'un ami",
  "{0} C и {1} {2}": "{0} C et {1} {2}",
  "Подарить {0}": "Offrir {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Cadeau test : rien n'est débité",
  "На месяц, без продления": "Pour un mois, sans renouvellement",
  "Тариф подарка": "Forfait offert",
  "Кому": "Pour",
  "ник друга в Telegram": "pseudo Telegram",
  "Ник друга в Telegram": "Pseudo Telegram de votre ami",
  "Пожелание": "Message",
  "Пара тёплых слов, по желанию": "Quelques mots chaleureux, facultatif",
  "Подписать от меня": "Signer de ma part",
  "Так увидит друг": "Ce que verra votre ami",
  "Подарок оформлен для {0}": "Cadeau créé pour {0}",
  "Подарок отправлен {0}": "Cadeau envoyé à {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Le bot a envoyé une carte avec le lien « Récupérer le cadeau ».",
  "Месяц {0} начнётся, когда друг заберёт подарок": "Le mois {0} démarre quand votre ami le récupère",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Votre ami n'a pas encore lancé STEOS ? Transférez la carte vous-même",
  "Переслать": "Transférer",
  "Загружаем подарок": "Chargement du cadeau",
  "Вам подарок": "Un cadeau pour vous",
  "Подписка STEOS на месяц": "Abonnement STEOS d'un mois",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Ce cadeau est pour {0}. Transférez-lui la carte avec le lien.",
  "Подарок уже получен": "Cadeau déjà récupéré",
  "Подарок добавлен": "Cadeau ajouté",
  "Подписка {0} подключена": "Abonnement {0} activé",
  "Circle подарка сгорят {0}": "Les Circle du cadeau expirent le {0}",
  "Месяц без продления, Circle действуют до {0}": "Un mois sans renouvellement, Circle valables jusqu'au {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Vous avez déjà {0} : le cadeau ajoute {1} C qui expirent dans un mois",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Vous recevrez {0} C et {1} {2}. Pas de renouvellement automatique",
  "За последние 7 дней": "7 derniers jours",
  "Потрачено": "Dépensé",
  "Начислено": "Crédité",
  "Пакеты пока недоступны": "Les packs ne sont pas encore disponibles",
  "Пакет": "Pack",
  "Оплата пакетов пока не подключена": "Le paiement des packs n'est pas encore connecté",
  "Введите промокод": "Saisissez un code promo",
  "Применить": "Appliquer",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Les codes partenaires valent jusqu'au premier achat ; un code STEOS s'utilise une fois",
  "От партнёра или от STEOS": "D'un partenaire ou de STEOS",
  "Например, ANNA24": "Par exemple, ANNA24",
  "Не удалось загрузить операции": "Impossible de charger les opérations",
  "Начисление": "Crédit",
  "Списание": "Débit",
  "Загружаем операции": "Chargement des opérations",
  "Журнал STEOS ID": "Journal STEOS ID",
  "Операций пока нет": "Aucune opération pour l'instant",
  "Применение не подтверждено. Проверьте прежний запрос": "Non confirmé. Vérifiez la demande précédente",
  "Отменить подписку?": "Résilier l'abonnement ?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} reste jusqu'au {1}, puis ne sera pas renouvelé.",
  "Оставить": "Garder",
  "Не удалось подготовить открытку": "Impossible de préparer la carte",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Ouvrez la Mini App dans Telegram pour transférer la carte",
  "Отправка отменена": "Envoi annulé",
  "Ссылка на подарок скопирована": "Lien du cadeau copié",
  "Не получилось. Попробуйте ещё раз": "Ça n'a pas marché. Réessayez",
  "Счёт отменён": "Facture annulée",
  "Оплата не завершена": "Paiement non finalisé",
  "Подтверждение оплаты": "Confirmation du paiement",
  "Проверяем подтверждение оплаты": "Vérification de la confirmation",
  "Проверяем отмену счёта": "Vérification de l'annulation",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram confirme la facture. Le résultat est encore inconnu. Ne payez pas à nouveau : vérifiez cette facture ou contactez le support.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Le cadeau sera créé après confirmation du serveur. Le mois démarre quand votre ami le récupère. Revenir de la fenêtre de paiement ne signifie pas que le paiement est terminé.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Les Circle arriveront après confirmation du serveur. Revenir de la fenêtre de paiement ne signifie pas que le paiement est terminé.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Les Circle et l'abonnement apparaîtront après confirmation du serveur. Revenir de la fenêtre de paiement ne signifie pas que le paiement est terminé.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Impossible d'ouvrir le paiement. Vérifiez la demande précédente",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Ouvrez la Mini App dans Telegram pour payer en étoiles",
  "Оплата ещё не подтверждена сервером": "Le serveur n'a pas encore confirmé le paiement",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "La carte est prête. Ouvrez la Mini App dans Telegram pour la transférer",
  "Отменить счёт?": "Annuler la facture ?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Seule cette facture impayée est annulée. Votre abonnement reste. Si le paiement est déjà en confirmation, le serveur refusera l'annulation.",
  "Вернуться к оплате": "Retour au paiement",
  "{0} на первый пакет после подписки": "{0} sur le premier pack après l'abonnement",
  "{0} на первый пакет, ещё {1}": "{0} sur le premier pack, encore {1}",
  "{0} на первый пакет": "{0} sur le premier pack",
  "Промокод {0} применён": "Code promo {0} appliqué",
  "Circle сгорят {0}": "Les Circle expirent le {0}",
  "Circle начислены": "Circle crédités",
  "Привязка к партнёру подтверждена": "Lien partenaire confirmé",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Remise : {0}. Les Circle bonus expirent le {1}",
  "Привязка к партнёру действует": "Lien partenaire actif",
  "{0} C и {1}": "{0} C et {1}",
  "Открытка передана боту для доставки.": "La carte a été transmise au bot pour livraison.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Le bot prépare la livraison. Vous pouvez aussi la transférer vous-même.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "La livraison n'est pas confirmée. Vous pouvez la transférer vous-même.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Les Circle à durée limitée partent en premier (bonus et abonnement), puis les autres ; ceux qu'on peut retirer en dernier.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Destinataire introuvable parmi les utilisateurs STEOS. Vérifiez le pseudo ou demandez à votre ami de lancer le bot.",
  "Условия оплаты изменились. Обновите данные.": "Les conditions de paiement ont changé. Actualisez.",
  "Эту открытку может переслать только отправитель подарка.": "Seul l'expéditeur du cadeau peut transférer cette carte.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Ouvrez le chat avec le bot et réessayez.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Livraison au destinataire non confirmée. Transférez la carte vous-même.",
  "Предложение не найдено. Обновите данные.": "Offre introuvable. Actualisez.",
  "Такого промокода нет": "Ce code promo n'existe pas",
  "Срок действия промокода закончился": "Ce code promo a expiré",
  "Этот промокод пока не действует": "Ce code promo n'est pas encore actif",
  "Вы уже активировали этот промокод": "Vous avez déjà utilisé ce code",
  "Промокод больше не действует": "Ce code promo n'est plus valable",
  "Это ваш промокод": "C'est votre propre code",
  "Партнёрские промокоды работают только до первой покупки": "Les codes partenaires ne valent qu'avant le premier achat",
  "Промокод партнёра временно недоступен": "Ce code partenaire est temporairement indisponible",
  "Вы уже привязаны к партнёру": "Vous êtes déjà lié à un partenaire",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Le destinataire a changé. Annulez la facture impayée précédente et vérifiez le pseudo avant un nouvel achat.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Le message doit faire 200 caractères maximum, sans caractères de contrôle.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Vérifiez le pseudo : le destinataire doit avoir lancé STEOS, et vous ne pouvez pas vous offrir un cadeau",
  "Получатель сейчас занят. Повторите позже": "Le destinataire est occupé. Réessayez plus tard",
  "Подарок не найден": "Cadeau introuvable",
  "Этот подарок предназначен другому пользователю": "Ce cadeau est destiné à un autre utilisateur",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Impossible de confirmer les conditions de renouvellement. Actualisez les forfaits.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Votre abonnement a changé. Actualisez avant de renouveler.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Le renouvellement est déjà prévu. Vous pouvez l'annuler dans la gestion de l'abonnement.",
  "Запланированное продление отменено. Обновите данные.": "Renouvellement prévu annulé. Actualisez.",
  "Счёт будет доступен в конце текущего срока.": "La facture sera disponible à la fin de la période.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "L'abonnement mensuel sera disponible après le cadeau. Pour l'instant, prolongez de 3 ou 12 mois.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "La modification précédente est encore en vérification. Revérifiez-la.",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram n'a pas encore confirmé la modification.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Votre abonnement a changé. Actualisez et revérifiez.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "La remise est déjà liée à la facture précédente. Vérifiez son paiement.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "La facture est déjà en confirmation ou ne peut pas être annulée. Vérifiez le résultat du paiement.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Le paiement doit être vérifié. Le serveur l'a enregistré, mais l'accès n'est pas encore confirmé. Ne payez pas à nouveau : vérifiez plus tard ou contactez le support.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Facture annulée. Ni abonnement ni Circle n'ont été crédités. Vous pouvez relancer un paiement.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Paiement non finalisé. Argent et Circle non confirmés ; vous pouvez relancer un paiement.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "La carte est en préparation. Touchez « Vérifier » pour obtenir le résultat.",
  "Подарить подписку": "Offrir un abonnement",
  "Оплата подписки": "Paiement de l'abonnement",
  "Итог оплаты": "Résultat du paiement",
  "Подарок": "Cadeau",
  "Пакет Circle": "Pack Circle",
  "лента: Хит": "Top",
  "настройки: Очистить историю": "Effacer l'historique",
  "Разделы, которых нет в меню": "Sections hors menu",
  "Базовый": "Basique",
  "Продвинутый": "Avancé",
  "Амбассадор": "Ambassadeur",
  "задание ждёт|задания ждут|заданий ждут": "tâche en attente|tâches en attente",
  ", до +{0} C": ", jusqu'à +{0} C",
  "Серия {0}, задания на сегодня": "Série de {0}, tâches du jour",
  "Задания на каждый день": "Tâches quotidiennes",
  "Всё созданное в одном месте": "Toutes vos créations au même endroit",
  "Пока пусто: всё созданное будет здесь": "Vide pour l'instant : vos créations apparaîtront ici",
  "{0}, последняя {1}": "{0}, dernière {1}",
  "тариф {0}": "forfait {0}",
  "без подписки": "sans abonnement",
  "{0}, {1}% с покупок": "{0}, {1} % des achats",
  "{0} уровень, {1}% с покупок": "Niveau {0}, {1} % des achats",
  "До {0}% с покупок друзей": "Jusqu'à {0} % des achats de vos amis",
  "ИИ-агент ответит сразу": "L'agent IA répond tout de suite",
  "Черновики ролей и реплик": "Brouillons de rôles et répliques",
  "Тема, язык и валюта": "Thème, langue et devise",
  "{0} ждут": "{0} en attente",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Telegram ouvrira ici le choix du chat : le bot rejoindra le groupe et y fonctionnera",
  "голос {0}": "voix {0}",
  "Искать в {0} {1}": "Rechercher dans {0} {1}",
  "работе|работах|работах": "création|créations",
  "Не прошло модерацию": "Refusé par la modération",
  "Бесплатно": "Gratuit",
  "Цена недоступна": "Prix indisponible",
  "Не удалось загрузить историю": "Impossible de charger l'historique",
  "Проверьте написание или поищите по номеру заказа": "Vérifiez l'orthographe ou cherchez par numéro de commande",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Vérifiez l'orthographe ou cherchez par titre, voix ou personnage",
  "Сбросить поиск": "Effacer la recherche",
  "В этой вкладке пока пусто": "Rien ici pour l'instant",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Ajoutez un cœur à une création pour la retrouver vite ici",
  "Новые работы этого вида появятся здесь сами": "Les nouvelles créations de ce type apparaîtront ici",
  "Показать все": "Tout afficher",
  "Поиск по истории": "Rechercher dans l'historique",
  "Что показать": "Afficher",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Vidéos rondes, photos, vidéos, voix off et textes que vous créerez",
  "Открыть студию": "Ouvrir Studio",
  "{0}: шаг {1} из {2}. Открыть": "{0} : étape {1} sur {2}. Ouvrir",
  "Шаг {0} из {1}": "Étape {0} sur {1}",
  "{0}: {1}. Открыть": "{0} : {1}. Ouvrir",
  "Раскладка": "Mise en page",
  "Широкий": "Large",
  "Инструмент": "Outil",
  "голос|голоса|голосов": "voix|voix",
  "Как в оригинале": "Comme l'original",
  "фото|фото|фото": "photo|photos",
  "слайд|слайда|слайдов": "diapo|diapos",
  "снимок|снимка|снимков": "photo|photos",
  "кадр|кадра|кадров": "photo|photos",
  "Длительность записи": "Durée de l'enregistrement",
  "Цена": "Prix",
  "Списание не подтверждено": "Débit non confirmé",
  "Кадры": "Prises",
  "знак|знака|знаков": "caractère|caractères",
  "пункт|пункта|пунктов": "point|points",
  "фраза|фразы|фраз": "expression|expressions",
  "человек|человека|человек": "personne|personnes",
  "Смотреть видео": "Regarder la vidéo",
  "символ|символа|символов": "caractère|caractères",
  "Дорожка": "Piste",
  "фрагмент 1:00": "extrait de 1:00",
  "вся песня": "chanson entière",
  "образец|образца|образцов": "échantillon|échantillons",
  "Свой голос": "Votre voix",
  "{0} C списаны": "{0} C débités",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Création en cours. Le résultat apparaîtra ici et dans le chat",
  "Проверяем результат. Обычно это занимает пару минут": "Vérification du résultat. Cela prend généralement quelques minutes",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Refusé par la modération. La politique et les sujets interdits ne sont pas acceptés. {0}",
  "Не прошло модерацию. {0}": "Refusé par la modération. {0}",
  "Не получилось. {0}": "Échec de la création. {0}",
  "Не получилось. {0} C вернулись на баланс": "Échec de la création. {0} C remboursés sur votre solde",
  "Удалится только запись о заказе": "Seul l'enregistrement de la commande sera supprimé",
  "Удаление из истории": "Suppression de l'historique",
  "Смотреть: {0}": "Regarder : {0}",
  "В этой работе нет файлов для просмотра": "Cette création n'a aucun fichier à afficher",
  "Вернуть запись в историю не получится.": "Il ne sera pas possible de restaurer l'enregistrement.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Le fichier reste dans le chat. Impossible de restaurer la création.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "L'envoi n'est pas encore confirmé. Touchez à nouveau",
  "Принято": "Accepté",
  "Бот пришлёт результат в чат": "Le bot enverra le résultat dans le chat",
  "Возврат обрабатывается": "Remboursement en cours",
  "Не списано": "Non débité",
  "Circle не списаны": "Aucun Circle débité",
  "Circle вернулись на баланс": "Les Circle ont été remboursés sur votre solde",
  "Списание пока не подтверждено": "Débit pas encore confirmé",
  "Возврат не подтверждён": "Remboursement non confirmé",
  "Ожидаем подтверждения оплаты": "Paiement en attente",
  "история: Повторить": "Refaire",
  "история: Кружки": "Messages vidéo",
  "Фотосессия из селфи": "Séance photo à partir d’un selfie",
  "Рилс с вами": "Reels avec vous",
  "Фото говорит": "La photo parle",
  "Слайды с преимуществами": "Diapositives d’avantages",
  "Карусель для поста": "Carrousel pour un post",
  "Коллаж из фото": "Collage photo",
  "Карточка для маркетплейса": "Fiche pour marketplace",
  "шаг|шага|шагов": "étape|étapes",
  "вопрос|вопроса|вопросов": "question|questions",
  "Открыть": "Ouvrir",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "La réponse à cette question n’a pas été confirmée. Si elle est importante, écrivez à l’assistance : {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "La réponse à cette question n’a pas été confirmée. Si elle est importante, écrivez à l’assistance.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Pas encore de réponse. Nous vérifierons la même question, elle ne sera pas envoyée deux fois.",
  "Открыть профиль": "Ouvrir le profil",
  "Войти через STEOS ID": "Se connecter via STEOS ID",
  "Тут Telegram откроет выбор чата": "Ici, Telegram ouvrira le choix du chat",
  "Разделы поддержки": "Sections de l’assistance",
  "Ответит сразу": "Répond aussitôt",
  "Отвечает сразу": "Répond aussitôt",
  "Поддержка в Telegram, {0}": "Assistance sur Telegram, {0}",
  "Поддержка в Telegram": "Assistance sur Telegram",
  "Видео медленнее обычного": "Vidéo : ralentissements",
  "Видео работает медленнее обычного": "La vidéo fonctionne plus lentement que d’habitude",
  "Спросить ИИ‑агента поддержки": "Interroger l’agent d’assistance IA",
  "Отвечает сразу и знает всё о STEOS": "Répond aussitôt et connaît tout de STEOS",
  "Поиск по вопросам и инструкциям": "Chercher questions et instructions",
  "Шесть коротких сторис о главном": "Six stories courtes sur l’essentiel",
  "Попробуйте другие слова или спросите ИИ-агента": "Essayez d’autres mots ou interrogez l’agent IA",
  "Проверено в {0}": "Vérifié à {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Les commandes ne se perdent pas : le résultat arrivera dans le chat, et en cas d’échec, les Circle reviendront sur votre solde.",
  "Сервисы": "Services",
  "Загружаем статус сервисов": "Chargement de l’état des services",
  "Загружаем справку": "Chargement de l’aide",
  "Статус не загрузился": "Le statut n’a pas été chargé",
  "Статус сервисов пока не отслеживается": "L’état des services n’est pas encore suivi",
  "Если что-то не работает, напишите в поддержку": "Si quelque chose ne fonctionne pas, écrivez à l’assistance",
  "Часть сервисов работает с перебоями": "Certains services rencontrent des perturbations",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Consultez le statut de vos créations et les remboursements confirmés dans « Historique ».",
  "Справка не загрузилась": "L’aide n’a pas été chargée",
  "Справка пока не опубликована": "L’aide n’est pas encore publiée",
  "Вопрос можно задать поддержке в Telegram": "Vous pouvez poser votre question à l’assistance sur Telegram",
  "Инструкции появятся после публикации справки": "Les instructions apparaîtront après la publication de l’aide",
  "Назад к ИИ-агенту": "Retour à l’agent IA",
  "Инструкция · {0}": "Guide · {0}",
  "Вопрос · {0}": "Question · {0}",
  "Справка": "Aide",
  "Вопрос из Справки": "Question de l’Aide",
  "Подробнее из Справки": "Plus dans l’Aide",
  "Назад по таблице": "Tableau : colonne précédente",
  "Вперёд по таблице": "Tableau : colonne suivante",
  "Здравствуйте, {0}.": "Bonjour, {0}.",
  "Здравствуйте.": "Bonjour.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Je suis l’agent d’assistance IA de STEOS : je vous aide pour les forfaits et les Circle, les outils et modèles, les codes promo, STEOS ID et le programme partenaire. Posez votre question avec vos mots ou choisissez-en une.",
  "ИИ-агент печатает": "L’agent IA écrit",
  "ИИ-агент ещё отвечает": "L’agent IA répond encore",
  "Напишите вопрос": "Saisissez une question",
  "Диалог с ИИ-агентом": "Conversation avec l’agent IA",
  "Распознаём…": "Reconnaissance…",
  "Слушаю": "J’écoute",
  "Спросите о STEOS": "Une question sur STEOS ?",
  "Вопрос ИИ-агенту": "Question à l’agent IA",
  "Остановить диктовку": "Arrêter la dictée",
  "Сказать голосом": "Dicter",
  "Отправить": "Envoyer",
  "Не удалось начать новый чат": "Impossible de démarrer une nouvelle conversation",
  "Спасибо, учтём": "Merci, c’est noté",
  "Спасибо, передадим команде": "Merci, nous transmettrons à l’équipe",
  "Оценка не сохранилась": "La note n’a pas été enregistrée",
  "Чат ещё загружается": "La conversation est en cours de chargement",
  "В чате уже {0} вопросов. Начните новый": "Cette conversation compte déjà {0} questions. Démarrez-en une nouvelle",
  "Вопрос не сохранился. Попробуйте ещё раз": "La question n’a pas été enregistrée. Réessayez",
  "Некоторые сервисы работают медленнее обычного": "Certains services fonctionnent plus lentement que d’habitude",
  "{0} не работают": "{0} ne fonctionnent pas",
  "{0} не работает": "{0} ne fonctionne pas",
  "{0} медленнее обычного": "{0} : ralentissements",
  "{0} работают медленнее обычного": "{0} fonctionnent plus lentement que d’habitude",
  "{0} работает медленнее обычного": "{0} fonctionne plus lentement que d’habitude",
  "Микрофон здесь недоступен": "Le micro n’est pas disponible ici",
  "Нет доступа к микрофону": "Pas d’accès au micro",
  "Нужна запись от 1 до 30 секунд": "L’enregistrement doit durer de 1 à 30 secondes",
  "Не удалось разобрать запись": "Impossible de comprendre l’enregistrement",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "La dictée n’a pas été reconnue. Touchez le micro pour vérifier à nouveau",
  "Вопрос не подошёл. Сформулируйте иначе": "Cette question ne convient pas. Reformulez-la",
  "Ответ не подтвердился. Напишите в поддержку": "La réponse n’a pas été confirmée. Écrivez à l’assistance",
  "Ответ не пришёл. Проверьте ещё раз": "Aucune réponse reçue. Vérifiez à nouveau",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Vidéo ronde parlante, La vidéo parle, La photo parle, Reproduire les mouvements, avatar personnalisé",
  "Оживить фото, видео по описанию, рилсы и сцены": "Animer la photo, vidéo à partir d’une description, reels et scènes",
  "Фото, фотосессии, товары, карусели": "Photos, séances photo, produits, carrousels",
  "Голоса, клон, озвучка проектов, кавер": "Voix, clone, voix off de scripts, reprise",
  "Звёзды Telegram и карты": "Telegram Stars et cartes",
  "Не работает": "En panne",
  "Как сделать по шагам": "Étape par étape",
  "Полезный ответ": "Réponse utile",
  "Ответ не помог": "Pas utile",
  "Проверьте связь и попробуйте ещё раз": "Vérifiez la connexion et réessayez",
  "Не удалось проверить владельца чата": "Impossible de vérifier le propriétaire de la conversation",
  "Не удалось восстановить чат. Начните новый": "Impossible de restaurer la conversation. Démarrez-en une nouvelle",
  "Клоны для озвучки": "Clones pour les voix off",
  "Создайте первый голос": "Créez votre première voix",
  "Люди и питомцы для фото": "Personnes et animaux pour les photos",
  "Добавьте близких для фото": "Ajoutez des proches pour les photos",
  "Сохранённые работы": "Créations enregistrées",
  "Отмечайте работы сердцем": "Ajoutez un cœur à vos créations",
  "Ежедневная серия и бонусы": "Série quotidienne et bonus",
  "Частые вопросы и связь с нами": "FAQ et nous contacter",
  "Обучается": "En apprentissage",
  "Аккаунт недоступен": "Compte indisponible",
  "Эта неделя · {0}": "Cette semaine · {0}",
  "Неделя с {0} · {1}": "Semaine du {0} · {1}",
  "ID скопирован": "ID copié",
  "Скопировать ID": "Copier l’ID",
  "Баланс временно недоступен": "Solde temporairement indisponible",
  "Разбивка остатка временно недоступна": "Détail du solde temporairement indisponible",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Dont {0} C expire le {1}|Dont {0} C expirent le {1}",
  "Ближайшие {0} C сгорят {1}": "Les prochains {0} C expirent le {1}",
  "Circle каждый месяц от {0}": "Des Circle chaque mois dès {0}",
  "Circle каждый месяц с подпиской": "Des Circle chaque mois avec l’abonnement",
  "Тариф временно недоступен": "Offre temporairement indisponible",
  "Аккаунт, подписка и баланс": "Compte, abonnement et solde",
  "Статистика и моё": "Statistiques et Mon apparence",
  "{0} к прошлой неделе": "{0} vs semaine dernière",
  "Работы по неделям: на этой неделе {0}": "Créations par semaine : {0} cette semaine",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Créations par semaine : {0} cette semaine, {1} la semaine dernière",
  "Статистика пока недоступна": "Statistiques pas encore disponibles",
  "Дата регистрации недоступна": "Date d’inscription indisponible",
  "С {0}": "Depuis le {0}",
  "Создано": "Créé",
  "Серия": "Série",
  "день подряд|дня подряд|дней подряд": "jour d’affilée|jours d’affilée",
  "Общий аккаунт STEOS": "Compte STEOS commun",
  "Для вывода Circle": "Pour retirer des Circle",
  "До {0}% с их покупок": "Jusqu’à {0}% de leurs achats",
  "Обновлено {0}": "Mis à jour : {0}",
  "Действия": "Actions",
  "Сохранить имя": "Enregistrer le nom",
  "Новое имя": "Nouveau nom",
  "Больше голосов с подпиской": "Plus de voix avec l’abonnement",
  "Создание голосов пока недоступно": "Création de voix pas encore disponible",
  "Свободных мест нет": "Aucune place libre",
  "с подпиской до {0}": "jusqu’à {0} avec l’abonnement",
  "Пауза «{0}»": "Mettre « {0} » en pause",
  "Прослушать «{0}»": "Écouter « {0} »",
  "Переименовать": "Renommer",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Enregistrez 2 secondes de parole ou importez des fichiers : la voix sonnera comme vous",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Aucune place libre. Supprimez une voix pour en enregistrer une nouvelle",
  "Выбрать за «Вы»": "Utiliser comme « Vous »",
  "голос по умолчанию": "voix par défaut",
  "Сделать кружок с вариантом «{0}»": "Créer une vidéo ronde avec le look « {0} »",
  "Выбраны": "Sélectionnées",
  "{0} фото|{0} фото|{0} фото": "{0} photo|{0} photos",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} photo · pour tous les outils|{0} photos · pour tous les outils",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} look · vidéos rondes, photos, vidéos|{0} looks · vidéos rondes, photos, vidéos",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} look|{0} looks",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "La voix {0} a été supprimée : le look {1} utilise maintenant la voix par défaut.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Des voix ont été supprimées : les looks {0} utilisent maintenant la voix par défaut.",
  "Другой голос можно выбрать у каждого кружка": "Vous pouvez choisir une autre voix pour chaque vidéo ronde",
  "Вариантов пока нет": "Aucun look pour l’instant",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Importez vos photos : votre look parlera avec votre voix dans les vidéos rondes, photos et vidéos",
  "Вы: свои фото и варианты": "Vous : vos photos et looks",
  "добавьте фото": "ajoutez des photos",
  "Изменить «{0}»": "Modifier « {0} »",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} proche · pour photos et vidéos|{0} proches · pour photos et vidéos",
  "Люди и питомцы для фото и видео": "Personnes et animaux pour photos et vidéos",
  "Близких пока нет": "Aucun proche pour l’instant",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Ajoutez des personnes et des animaux avec photos : ils apparaîtront à vos côtés dans l’image",
  "Открыть в «Истории»": "Ouvrir dans l’Historique",
  "Вернуть в избранное": "Remettre dans les favoris",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} création avec cœur|{0} créations avec cœur",
  "Отмеченные сердцем работы": "Créations marquées d’un cœur",
  "Открыть «Историю»": "Ouvrir l’Historique",
  "Не удалось загрузить избранное": "Impossible de charger les favoris",
  "Закройте лист и откройте его ещё раз": "Fermez la fenêtre et rouvrez-la",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Ajoutez un cœur aux créations dans l’Historique : elles se retrouveront ici",
  "Не удалось обновить. Попробуйте позже": "Échec de la mise à jour. Réessayez plus tard",
  "Удалить голос «{0}»?": "Supprimer la voix « {0} » ?",
  "Голос пропадёт из списка. Вернуть его не получится.": "La voix disparaîtra de la liste. Impossible de la récupérer.",
  "Удалить вариант «{0}»?": "Supprimer le look « {0} » ?",
  "За «Вы» снова встанут ваши фото.": "Vos photos seront de nouveau utilisées comme « Vous ».",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Les vidéos rondes et photos créées restent dans l’Historique. Impossible de récupérer le look.",
  "Не удалось удалить голос": "Impossible de supprimer la voix",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Impossible de supprimer le look. Réessayez",
  "«{0}»": "« {0} »",
  "подписка: до {0}": "jusqu’au {0}",
  "варианты «Вы»: Новый вариант": "Nouveau look",
  "в очереди": "en file d’attente",
  "идёт": "en cours",
  "завершено": "terminé",
  "не удалось": "échec",
  "слово подтверждения: УДАЛИТЬ": "SUPPRIMER",
  "Выгрузка: {0}": "Export : {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Suppression : {0}. Le STEOS ID et les reçus financiers sont conservés.",
  "Введите {0}": "Saisissez {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Transfert pas encore confirmé. La vérification continue : rouvrez la fenêtre plus tard",
  "Этот STEOS ID уже связан с другим Telegram": "Ce STEOS ID est déjà lié à un autre compte Telegram",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Les deux comptes ont un abonnement. Contactez le support pour les fusionner",
  "Слишком много попыток. Попробуйте позже": "Trop de tentatives. Réessayez plus tard",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "Connexion STEOS ID indisponible pour le moment. Réessayez plus tard",
  "Не удалось создать аккаунт. Попробуйте позже": "Impossible de créer le compte. Réessayez plus tard",
  "Не удалось отправить письмо": "Impossible d’envoyer l’e-mail",
  "Фото не подошло. Выберите другое": "Cette photo ne convient pas. Choisissez-en une autre",
  "Загрузите фото заново": "Téléchargez la photo à nouveau",
  "Данные изменились. Откройте заново": "Les données ont changé. Rouvrez la fenêtre",
  "подряд": "d'affilée",
  "Начните {0}": "Lancez {0}",
  "серию": "une série",
  "Завтра +{0} C": "Demain +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Revenez chaque jour : la récompense augmente, {0} C le septième jour. Un jour manqué relance la série.",
  "Забрать {0} C": "Récupérer {0} C",
  "Прогресс": "Progression",
  "Заданий здесь пока нет": "Aucune mission ici pour l'instant",
  "Время обновления недоступно": "Heure de renouvellement indisponible",
  "Новые через {0}": "Nouvelles dans {0}",
  "Выполнено {0} из {1}": "{0} sur {1} terminées",
  "друг|друга|друзей": "ami|amis",
  "{0} с вами": "{0} avec vous",
  "Прогресс друзей недоступен": "Progression des amis indisponible",
  "Пригласить": "Inviter",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Comptent les amis venus par votre lien ou code promo qui ont fait leur première création",
  "Ещё {0} {1} до награды {2}": "Encore {0} {1} pour {2}",
  "Все ступени пройдены": "Tous les paliers sont atteints",
  "Получено {0} из {1}": "{0} sur {1} reçues",
  "Задания": "Missions",
  "покупатель|покупателя|покупателей": "acheteur|acheteurs",
  "Партнёрская программа": "Programme partenaire",
  "Партнёрам": "Partenaires",
  "До {0}% {1}": "Jusqu'à {0}% {1}",
  "с покупок друзей": "des achats de vos amis",
  "Заработано {0} с покупок {1} {2}": "{0} gagnés grâce aux achats de {1} {2}",
  "друга|друзей|друзей": "ami|amis",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "À vous de choisir : plus de possibilités dans STEOS ou des revenus de parrainage.",
  "Ещё {0} до уровня {1}": "Encore {0} pour {1}",
  "Максимальный уровень: вывод через STEOS ID": "Niveau maximal : retrait via STEOS ID",
  "Статистика, материалы и вывод": "Statistiques, supports et retraits",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "La demande de récompense précédente doit être vérifiée. Les nouveaux crédits sont bloqués pour l'instant",
  "Загружаем награды": "Chargement des récompenses",
  "Награды не загрузились": "Les récompenses n'ont pas chargé",
  "Создайте 3 работы": "Réalisez 3 créations",
  "Сделайте кружок": "Créez une vidéo ronde",
  "Персонаж или вы сами": "Un personnage ou vous-même",
  "Озвучьте текст": "Doublez un texte",
  "Голосом героя или клона": "Avec la voix d'un personnage ou d'un clone",
  "Улучшите описание": "Améliorez une description",
  "Бот допишет детали": "Le bot ajoute les détails",
  "Отправьте работу": "Envoyez une création",
  "Из «Истории» в любой чат": "De l'Historique vers un chat",
  "Неделя кружков": "Semaine des vidéos rondes",
  "Создайте 10 кружков за неделю": "Créez 10 vidéos rondes en une semaine",
  "Исследователь": "Explorateur",
  "Попробуйте 5 разных инструментов студии": "Essayez 5 outils différents du Studio",
  "Первый кружок": "Première vidéo ronde",
  "Видеокружок для Telegram": "Vidéo ronde pour Telegram",
  "Клон голоса": "Clone vocal",
  "Всего 2 секунды речи": "Seulement 2 secondes de parole",
  "Первое фото": "Première photo",
  "Портрет в любом стиле": "Un portrait dans le style de votre choix",
  "Первый рилс с вами": "Votre premier reel",
  "Шаблон одной кнопкой": "Modèle en un geste",
  "Первый кавер": "Première reprise",
  "Песня другим голосом": "Une chanson avec une autre voix",
  "Кружки и видео с вами": "Vidéos rondes et vidéos avec vous",
  "С вашей ссылкой": "Avec votre lien",
  "Бот в чате": "Bot dans un chat",
  "Добавьте бота в группу": "Ajoutez le bot à un groupe",
  "Вход в STEOS ID": "Connexion avec STEOS ID",
  "Один аккаунт с сайтом": "Un seul compte avec le site",
  "Первый друг": "Premier ami",
  "3 друга": "3 amis",
  "10 друзей": "10 amis",
  "25 друзей": "25 amis",
  "Первый покупатель": "Premier acheteur",
  "Первая оплата друга": "Premier paiement d'un ami",
  "{0} мин": "{0} min",
  "{0} ч": "{0} h",
  "Последний день": "Dernier jour",
  "Ещё {0} {1}": "Encore {0} {1}",
  "Это задание выполняется вне мини-приложения": "Cette mission se fait en dehors de la Mini App",
  "Задание пока недоступно": "Mission pas encore disponible",
  "Прогресс временно недоступен": "Progression momentanément indisponible",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Impossible de récupérer la demande de récompense précédente. Vérifiez votre solde et contactez le support",
  "Награды временно недоступны. Попробуйте обновить данные": "Les récompenses sont momentanément indisponibles. Essayez d'actualiser",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Récompense confirmée. Actualisez les données : inutile de la récupérer à nouveau",
  "Задание ещё не выполнено. Обновите прогресс": "Mission pas encore terminée. Actualisez la progression",
  "Награда уже получена. Обновите данные": "Récompense déjà reçue. Actualisez les données",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Crédit non confirmé. Vérifiez la demande précédente : les nouvelles récompenses sont bloquées",
  "Сначала обновите данные наград": "Actualisez d'abord les récompenses",
  "Сначала проверьте прежний запрос награды": "Vérifiez d'abord la demande de récompense précédente",
  "Рассказчик": "Narrateur",
  "Встреча на тракте": "Rencontre sur la route",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Il pleuvait depuis trois jours, et la route de la forteresse avait presque disparu sous la boue.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Tu es encore partie devant sans moi. Je t'avais demandé d'attendre au pont.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "J'ai attendu. Une heure entière. Puis je me suis dit que tu t'étais perdu.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Les sorceleurs ne se perdent pas. Parfois, on prend le chemin le plus long.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Alors la prochaine fois, choisis-le plus vite. J'ai froid.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Sans un mot, il ôta sa cape et la posa sur ses épaules. Devant, on voyait déjà les lumières de la forteresse.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Viens. Vesemir a sûrement déjà mis la soupe sur le feu.",
  "Опять ты?": "Encore toi ?",
  "Мне нужна помощь": "J'ai besoin d'aide",
  "Вставьте сценарий или начните с нуля": "Collez un scénario ou partez de zéro",
  "Напишите хотя бы одну реплику": "Écrivez au moins une réplique",
  "Сократите реплику: до {0} знаков": "Raccourcissez la réplique : {0} caractères max.",
  "Сократите проект: до {0} знаков": "Raccourcissez le projet : {0} caractères max.",
  "Озвучка проектов временно недоступна": "La voix off de scripts est momentanément indisponible",
  "Выберите голос для каждой роли": "Choisissez une voix pour chaque rôle",
  "Озвучить · {0} C": "Doubler · {0} C",
  "Без названия": "Sans titre",
  "Роль": "Rôle",
  "вчера": "hier",
  "Проекты": "Projets",
  "роль|роли|ролей": "rôle|rôles",
  "реплика|реплики|реплик": "réplique|répliques",
  "Нет реплик": "Aucune réplique",
  "{0} знаков": "{0} caractères",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Les lignes « Nom : réplique » deviennent des rôles et des voix",
  "Начать с нуля": "Partir de zéro",
  "Роли и реплики добавите сами": "Ajoutez vous-même rôles et répliques",
  "Открыть пример": "Ouvrir un exemple",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Les projets s'enregistrent tout seuls : revenez-y quand vous voulez",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Un rôle au nom d'un personnage reçoit sa voix : Geralt, Ciri, Yennefer",
  "Переименовать проект": "Renommer le projet",
  "Загрузить свежую": "Charger la dernière",
  "{0}: голос {1}. Сменить голос": "{0} : voix {1}. Changer la voix",
  "Действия с ролью": "Actions du rôle",
  "Озвучиваем": "Doublage en cours",
  "Действия с репликой": "Actions de la réplique",
  "Реплика: {0}": "Réplique : {0}",
  "Реплик пока нет": "Pas encore de répliques",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Touchez « Réplique » en bas ou collez un scénario prêt",
  "Реплика": "Réplique",
  "за проект": "par projet",
  "Цена — по числу знаков": "Prix selon le nombre de caractères",
  "Добавить реплику": "Ajouter une réplique",
  "проект|проекта|проектов": "projet|projets",
  "{0} {1} · сохраняются сами": "{0} {1} · enregistrés automatiquement",
  "Пока ни одного": "Aucun pour l'instant",
  "Новый проект": "Nouveau projet",
  "Вставить сценарий или начать с нуля": "Coller un scénario ou partir de zéro",
  "Удаление проекта": "Suppression du projet",
  "Новая роль": "Nouveau rôle",
  "Это первая реплика": "C'est la première réplique",
  "Это последняя реплика": "C'est la dernière réplique",
  "Удалить роль": "Supprimer le rôle",
  "Вместе с её репликами": "Avec ses répliques",
  "В проекте нужна хотя бы одна роль": "Un projet doit avoir au moins un rôle",
  "Удалить роль «{0}»?": "Supprimer le rôle « {0} » ?",
  "Вместе с ней уйдут {0} {1}.": "Cela supprimera aussi {0} {1}.",
  "Удалить проект?": "Supprimer le projet ?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Les rôles et répliques seront supprimés, le projet ne pourra pas être récupéré.",
  "Выбор голоса откроется в приложении": "Le choix de la voix s'ouvrira dans l'appli",
  "Не удалось удалить проект: {0}": "Impossible de supprimer le projet : {0}",
  "Не получилось открыть аудио": "Impossible d'ouvrir l'audio",
  "Не получилось включить звук": "Impossible de lancer le son",
  "Сначала напишите текст реплики": "Écrivez d'abord le texte de la réplique",
  "Аудио реплики пока недоступно": "L'audio de la réplique n'est pas encore disponible",
  "Готовим роли": "Préparation des rôles",
  "Роли готовы": "Rôles prêts",
  "Озвучиваем реплики": "Doublage des répliques",
  "Реплики озвучены": "Répliques doublées",
  "Собираем дорожку": "Assemblage de la piste",
  "Дорожка собрана": "Piste assemblée",
  "дубль {0}": "prise {0}",
  "Время реплики пока недоступно": "Le minutage de la réplique n'est pas encore disponible",
  "Общий файл · {0}": "Fichier complet · {0}",
  "Аудио пока недоступно": "Audio pas encore disponible",
  "Слушать дорожку": "Écouter la piste",
  "реплика {0} из {1}": "réplique {0} sur {1}",
  "Проект не озвучен": "Projet non doublé",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Vous pouvez quitter l'écran : le doublage continue, la piste apparaîtra ici et dans l'Historique.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Vous pouvez quitter l'écran : le bot vous écrira quand la piste sera prête.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Envoyez le fichier complet dans le chat ou téléchargez-le. Chaque réplique peut être redoublée séparément.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Le bot a déjà envoyé le fichier complet dans le chat, dans un sujet à part. Chaque réplique peut être redoublée séparément.",
  "Сценарий не прошёл проверку": "Le scénario n'a pas passé la vérification",
  "проект не озвучен": "projet non doublé",
  "Не получилось собрать дорожку": "Impossible d'assembler la piste",
  "К сценарию": "Retour au scénario",
  "Звук дорожки не загрузился: скачайте файл": "Le son de la piste n'a pas chargé : téléchargez le fichier",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Chaque réplique sur une nouvelle ligne : nom, deux-points, texte. Une ligne sans nom revient au rôle précédent",
  "голос персонажа": "voix du personnage",
  "Заменить сценарий": "Remplacer le scénario",
  "Сейчас {0} {1}, они уйдут": "Actuellement {0} {1}, elles seront retirées",
  "реплику|реплики|реплик": "réplique|répliques",
  "Заменить на {0} {1}": "Remplacer par {0} {1}",
  "Добавить {0} {1}": "Ajouter {0} {1}",
  "Заменить реплики": "Remplacer les répliques",
  "Добавить реплики": "Ajouter des répliques",
  "Не нашли реплик: имя, двоеточие, текст": "Aucune réplique trouvée : nom, deux-points, texte",
  "Вставьте сценарий в поле": "Collez le scénario dans le champ",
  "Роли и голоса появятся сами": "Les rôles et les voix apparaîtront d'eux-mêmes",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt : Encore toi. Qu'est-ce que c'est, cette fois ?\nCiri : J'ai besoin de ton aide.",
  "Сейчас нельзя": "Impossible pour l'instant",
  "Вставьте текст в поле": "Collez le texte dans le champ",
  "Загружаем проекты": "Chargement des projets",
  "Проекты не загрузились": "Les projets n'ont pas chargé",
  "Не хватает Circle: пополните баланс": "Pas assez de Circle : rechargez votre solde",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Prix : {0} C. Touchez encore pour doubler",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Impossible de calculer le prix. Réessayez",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Le scénario n'a pas passé la vérification. Modifiez le texte et réessayez.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Impossible d'assembler la piste. Si des Circle ont été débités, ils reviendront sur votre solde.",
  "Запуск не подтверждён": "Lancement non confirmé",
  "Не получилось собрать дорожку.": "Impossible d'assembler la piste.",
  "Повторная проверка не спишет Circle дважды.": "Une nouvelle vérification ne débitera pas les Circle deux fois.",
  "Отправили в чат": "Envoyé dans le chat",
  "Отправка принята: бот пришлёт дорожку в чат": "Envoi accepté : le bot enverra la piste dans le chat",
  "Прослушивание реплики пока недоступно": "L'écoute de la réplique n'est pas encore disponible",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Écouter la réplique : {0} C. Touchez encore",
  "Переозвучка реплики пока недоступна": "Le redoublage de la réplique n'est pas encore disponible",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Redoubler la réplique : {0} C. Touchez encore",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "L'enregistrement des projets est indisponible pour le moment. Actualisez les données.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "La modification des projets est indisponible pour le moment. Actualisez les données.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Le projet est encore en cours d'enregistrement. Réessayez dans une seconde.",
  "Результат больше недоступен.": "Le résultat n'est plus disponible.",
  "Не удалось проверить владельца проекта.": "Impossible de vérifier le propriétaire du projet.",
  "Операция не найдена. Проверьте историю.": "Opération introuvable. Vérifiez l'Historique.",
  "Проект ещё не сохранён.": "Le projet n'est pas encore enregistré.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "La voix off de scripts est indisponible pour le moment. Actualisez les données.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "L'écoute de la réplique est indisponible pour le moment. Actualisez les données.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Le redoublage de la réplique est indisponible pour le moment. Actualisez les données.",
  "Дорожка ещё не готова.": "La piste n'est pas encore prête.",
  "Аккаунт сменился. Обновите страницу.": "Le compte a changé. Rechargez la page.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Envoi pas encore confirmé. Touchez encore pour vérifier la demande précédente.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Le résultat du projet n'est pas encore disponible. Vérifiez à nouveau le statut.",
  "Не удалось открыть аудио проекта.": "Impossible d'ouvrir l'audio du projet.",
  "месяц|месяца|месяцев": "mois|mois",
  "покупателя|покупателей|покупателей": "acheteur|acheteurs",
  "рабочий день|рабочих дня|рабочих дней": "jour ouvré|jours ouvrés",
  "друг купит|друга купят|друзей купят": "ami achète|amis achètent",
  "покупателем|покупателями|покупателями": "acheteur|acheteurs",
  "Баннеры": "Bannières",
  "Постер": "Affiche",
  "Голос героя": "Voix du personnage",
  "Персонаж говорит": "Le personnage parle",
  "Было и стало": "Avant et après",
  "Подарок другу": "Cadeau pour un ami",
  "Кружок, который говорит": "Une vidéo ronde qui parle",
  "Персонаж читает ваш текст": "Un personnage lit votre texte",
  "Рилс с вами одной кнопкой": "Un reel avec vous en un geste",
  "Сюжет, монтаж и музыка в шаблоне": "Scénario, montage et musique inclus",
  "Герой говорит": "Le héros parle",
  "Герой говорит вашим текстом": "Un héros dit votre texte",
  "Голос и губы в такт": "Voix et lèvres synchronisées",
  "Старое фото как новое": "Vieilles photos comme neuves",
  "Цвет и резкость за минуту": "Couleurs et netteté en une minute",
  "Кавер любым голосом": "Une reprise avec toute voix",
  "Рок, джаз или lo-fi": "Rock, jazz ou lo-fi",
  "Фотосессия в любом образе": "Séance photo, tous les styles",
  "По паре своих фото": "À partir de quelques photos",
  "Друзьям": "Pour les amis",
  "Личное сообщение": "Message privé",
  "Подписчикам": "Pour les abonnés",
  "Пост в канал": "Post de chaîne",
  "Семье": "Pour la famille",
  "Сообщение родным": "Message à la famille",
  "Геймерам": "Pour les gamers",
  "Чат по интересам": "Chat thématique",
  "Для работы": "Pour le travail",
  "Коллегам и в рабочий чат": "Collègues et chat pro",
  "Авторам": "Pour les créateurs",
  "Блогерам и создателям роликов": "Blogueurs et vidéastes",
  "Подарок по моему промокоду": "Un cadeau avec mon code promo",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Vidéos rondes, photos et voix par IA dans Telegram",
  "Кружки с персонажами": "Vidéos rondes avec personnages",
  "Пишете текст, персонаж его говорит": "Vous écrivez, le personnage parle",
  "Озвучка любым голосом": "Voix off avec toute voix",
  "Из библиотеки или своим клоном": "Depuis la bibliothèque ou votre clone",
  "Фотосессия без студии": "Séance photo sans studio",
  "Пара своих фото, любой образ": "Quelques photos, tous les styles",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} à partir de l’inscription via votre lien ou du premier achat avec votre code. Pendant ce temps, vous touchez un pourcentage sur tous ses paiements. Le code ne fonctionne que jusqu’au premier achat ; si l’ami est venu par votre lien, le code ne change plus le rattachement.",
  "Что получает друг?": "Que reçoit l’ami ?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C tout de suite : non retirables, ils expirent au bout de {1}.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "La remise de {0} % sur le premier pack Circle vaut pendant {1} après l’abonnement, car les packs Circle ne sont vendus qu’avec un abonnement. Un cadeau par compte : via le lien ou le code.",
  "Что считается оплатой?": "Qu’est-ce qui compte comme paiement ?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Abonnements et packs Circle payés en Stars ou par carte. Le pourcentage porte sur le montant payé par l’ami, remise déduite. Les pièces bonus, récompenses de tâches et remboursements ne comptent pas.",
  "Какие бывают промокоды?": "Quels codes promo existent ?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Votre code partenaire offre un cadeau à l’ami et le rattache à vous ; il ne marche que jusqu’à son premier achat. Les codes STEOS sont publiés par l’équipe dans la chaîne et la communauté STEOS : ils donnent des Circle avec leur propre durée et marchent pour tous, une fois par compte.",
  "Когда приходят Circle?": "Quand arrivent les Circle ?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Juste après le paiement de l’ami, directement sur votre solde. Au niveau {0}, vous pouvez les retirer.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Juste après le paiement de l’ami, directement sur votre solde. Aux niveaux {0}, ils servent dans STEOS ; au niveau {1}, vous pouvez les retirer.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Juste après le paiement de l’ami, directement sur votre solde. Au niveau {0}, ils servent dans STEOS ; au niveau {1}, vous pouvez les retirer.",
  "Считаются ли друзья с истёкшей привязкой?": "Les amis au rattachement expiré comptent-ils ?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Oui. Vous ne touchez plus de pourcentage sur leurs paiements, mais ils comptent toujours pour le niveau : il se calcule sur tous les acheteurs depuis le début.",
  "Кто может выводить?": "Qui peut retirer ?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Les partenaires du niveau {0} (à partir de {1}) avec un statut d’entrepreneur individuel, d’auto-entrepreneur ou équivalent étranger, après connexion via STEOS ID. Retrait uniquement en argent sur un compte : ici ou sur {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Les ambassadeurs (à partir de {0}) avec un statut d’entrepreneur individuel, d’auto-entrepreneur ou équivalent étranger, après connexion via STEOS ID. Retrait uniquement en argent sur un compte : ici ou sur {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "Puis-je retirer les pièces gagnées avant la connexion ?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Oui. Les Circle gagnés au niveau {0} avant la connexion via STEOS ID restent sur votre solde et deviennent retirables après la connexion.",
  "Какие монеты тратятся первыми?": "Quelles pièces sont dépensées en premier ?",
  "Можно пригласить самого себя?": "Puis-je m’inviter moi-même ?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Non. Les achats depuis votre compte et depuis des comptes en double ne comptent pas.",
  "Международный": "International",
  "Self-employed, sole trader или компания вне РФ": "Indépendant, entreprise individuelle ou société hors de Russie",
  "Самозанятый в РФ": "Auto-entrepreneur en Russie",
  "Налог на профессиональный доход": "Impôt sur le revenu professionnel (NPD)",
  "ИП в РФ": "Entrepreneur individuel en Russie",
  "Индивидуальный предприниматель": "Entrepreneur individuel",
  "Имя или компания": "Nom ou société",
  "Как в документах": "Comme sur vos documents",
  "TIN или номер в вашей стране": "TIN ou numéro fiscal de votre pays",
  "ФИО": "Nom complet",
  "Как в паспорте": "Comme sur le passeport",
  "ИНН": "INN",
  "12 цифр": "12 chiffres",
  "Название ИП": "Nom de l’entreprise individuelle",
  "Как в выписке": "Comme sur l’extrait du registre",
  "ИНН или ОГРНИП": "INN ou OGRNIP",
  "От 10 до 15 цифр": "De 10 à 15 chiffres",
  "НДС": "TVA",
  "Плательщик НДС": "Assujetti à la TVA",
  "Адрес": "Adresse",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "Siège de STEOS",
  "Платёжный агент STEOS в России": "Agent de paiement de STEOS en Russie",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Ici s’ouvrira le choix d’un chat Telegram avec ce texte, le lien et le code",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Ici s’ouvrira le choix d’un chat Telegram : la bannière part avec une légende et un bouton «Ouvrir STEOS»",
  "Ещё <b>{0} {1}</b> до уровня {2}": "Encore <b>{0} {1}</b> pour {2}",
  "Максимальный уровень": "Niveau maximal",
  "До следующего уровня": "Jusqu’au niveau suivant",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Jusqu’à&nbsp;{0}&nbsp;% <span>sur les achats de vos amis</span>",
  "Период": "Période",
  "Кого показать": "Afficher",
  "Перешли": "Clics",
  "Зарегистрировались": "Inscrits",
  "Купили": "Achats",
  "Пока нет данных": "Pas encore de données",
  "{0} к прошлому периоду": "{0} vs période préc.",
  "за {0} {1}": "en {0} {1}",
  "Пока не считаем": "Pas encore suivi",
  "нет начислений": "aucun gain",
  "Пик <b>{0} C</b>": "Pic <b>{0} C</b>",
  "Начисления по месяцам": "Gains par mois",
  "Начисления по дням": "Gains par jour",
  "Здесь появятся начисления": "Vos gains apparaîtront ici",
  "Подписка Про": "Abonnement Pro",
  "Купила Circle": "A acheté des Circle",
  "Купил Circle": "A acheté des Circle",
  "Покупатель": "Acheteur",
  "по промокоду": "via code promo",
  "привязка истекла": "rattachement expiré",
  "Это весь список · {0}": "C’est toute la liste · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "L’ami reste rattaché à vous pendant {0} : dès l’inscription via le lien ou le premier achat avec le code. Le code ne marche que jusqu’à son premier achat.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Les acheteurs au rattachement expiré comptent toujours pour le niveau.",
  "Пока никого": "Personne pour l’instant",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Partagez votre lien ou code, vos premiers amis apparaîtront ici",
  "Картинка": "Image",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Le lien et le code sont déjà sur l’image. Touchez un modèle pour modifier la légende et publier.",
  "{0}, открыть и опубликовать": "{0}, ouvrir et publier",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Pour Reels, Shorts, TikTok et VK Clips. Le code et le lien sont déjà à l’image, le bot enverra la vidéo dans le chat.",
  "{0}, открыть": "{0}, ouvrir",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Le lien et le code sont déjà dans le texte. Copiez-le ou envoyez-le dans un chat.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "L’image part dans le chat avec une légende et un bouton «Ouvrir STEOS». Idéal pour groupes, chaînes et messages privés.",
  "Баннер «{0}» с вашим промокодом": "Bannière «{0}» avec votre code",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "Affiche QR : le code mène à votre lien, code promo {0}",
  "Кружки, фото и голос с ИИ": "Vidéos rondes, photos et voix par IA",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C pour commencer avec le code",
  "Начните по ссылке или промокоду": "Commencez via le lien ou le code",
  "Наведите камеру телефона": "Visez avec l’appareil photo",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 à imprimer : présentoirs, vitrines, cartes de visite. Le QR mène à votre lien, et le code dessous se saisit même sans caméra.",
  "Цвет постера": "Couleur de l’affiche",
  "Прислать PDF в чат": "Envoyer le PDF",
  "Вывести": "Retirer",
  "Заявка на {0} C не подтверждена": "Demande de {0} C non confirmée",
  "Вывод сейчас недоступен": "Retrait indisponible pour le moment",
  "Вывод недоступен": "Indisponible",
  "Деньгами на ваш счёт за {0}": "Sur votre compte sous {0}",
  "Вывод от {0} C": "Retrait dès {0} C",
  "Вывод заработает после входа через STEOS ID": "Le retrait s’active après connexion via STEOS ID",
  "Войдите через STEOS ID": "Connectez-vous via STEOS ID",
  "Вывод доступен на уровне {0}, от {1}": "Retrait possible au niveau {0}, dès {1}",
  "Нужен уровень {0}": "Niveau {0} requis",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Retrait au niveau {0}, dès {1}. D’ici là, les Circle servent dans STEOS",
  "Не подключён": "Non connecté",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "La connexion relie votre compte du bot à votre compte STEOS commun : le solde devient commun, et le retrait fonctionne ici et sur le site STEOS ID.",
  "Выплачено": "Payé",
  "В обработке": "En cours",
  "Отклонено": "Refusé",
  "Не удалось загрузить историю выводов": "Impossible de charger l’historique des retraits",
  "Выводов пока не было": "Aucun retrait pour l’instant",
  "за всё время": "au total",
  "Можно вывести": "Retirable",
  "Тестовая программа: настоящих выплат нет": "Programme test : pas de vrais paiements",
  "Баланс и выводы есть и на {0}.": "Solde et retraits aussi sur {0}.",
  "Вопрос о выводе?": "Une question sur le retrait ?",
  "Напишите в поддержку": "Écrivez au support",
  "Поделитесь ссылкой или промокодом": "Partagez votre lien ou code",
  "Друг привязывается к вам на {0}": "L’ami vous est rattaché pendant {0}",
  "Друг получает подарок": "L’ami reçoit un cadeau",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C tout de suite et −{1} % sur le premier pack Circle après l’abonnement",
  "Друг платит в STEOS": "L’ami paie dans STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Abonnement et packs Circle en Stars ou par carte",
  "Вам приходит процент": "Vous touchez un pourcentage",
  "{0}% с каждой оплаты, сразу на баланс": "{0} % de chaque paiement, direct sur le solde",
  "Шаг {0}": "Étape {0}",
  "От {0}": "Dès {0}",
  "С первого дня": "Dès le premier jour",
  "Если {0} {1} {2}": "Si {0} {1} {2}",
  "{0} C за {1}": "{0} C sur {1}",
  "Хватит на {0} в месяц": "De quoi faire {0} par mois",
  "Кружок стоит {0} C": "Une vidéo ronde coûte {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Calcul sur l’abonnement {0} : {1} par mois, soit {2}&nbsp;C. Le pourcentage vient de chaque paiement de l’ami pendant {3} de rattachement.",
  "Уровень считается вместе с вашими {0}.": "Vos acheteurs actuels comptent pour le niveau : {0}.",
  "Калькулятор дохода": "Calculateur de revenus",
  "Тариф друзей": "Forfait des amis",
  "Сколько друзей купят подписку": "Combien d’amis s’abonnent",
  "Вы получите": "Vous recevrez",
  "C в месяц": "C par mois",
  "Проценты, сроки и ограничения": "Pourcentages, délais et limites",
  "Circle можно вывести": "Circle retirables",
  "Circle работают внутри STEOS": "Circle utilisables dans STEOS",
  "Привязка на {0}": "Rattachement pour {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Pourcentage sur tous les paiements de l’ami : dès l’inscription via le lien ou le premier achat avec le code",
  "Ссылка главнее промокода": "Le lien prime sur le code",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Si l’ami est venu par le lien, le code ne change plus le rattachement",
  "Промокод только до первой покупки": "Code valable jusqu’au premier achat",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Après le premier paiement de l’ami, votre code partenaire ne marche plus pour lui",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C tout de suite, expirent au bout de {1}. {2} sur le premier pack Circle pendant {3} après l’abonnement",
  "Только уровень {0}": "Niveau {0} uniquement",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Dès {0} {1}, après connexion via STEOS ID. Pour entrepreneurs individuels, auto-entrepreneurs et équivalents à l’étranger",
  "Счёт на компанию STEOS": "Facture à une société STEOS",
  "Плательщик появится, когда вывод откроется": "Le payeur apparaîtra à l’ouverture des retraits",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "En Russie : {0}, en roubles. Statut international : {1}, en euros",
  "Выплата за {0}": "Paiement sous {0}",
  "После проверки счёта, от {0} C": "Après vérification de la facture, dès {0} C",
  "Коротко о главном": "L’essentiel en bref",
  "Здесь краткое изложение. Полный текст условий на {0}": "Ceci est un résumé. Les conditions complètes sont sur {0}",
  "Понятно": "Compris",
  "У вас {0}.": "Vous avez {0}.",
  "Покупателей пока нет.": "Pas encore d’acheteurs.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Le niveau se calcule sur tous les acheteurs depuis le début, rattachement expiré compris.",
  "Введите сумму": "Saisissez un montant",
  "Можно вывести не больше {0} C": "Retrait maximum : {0} C",
  "Заполните реквизиты": "Remplissez les coordonnées",
  "Загрузите счёт на оплату": "Importez une facture",
  "Счёт ещё проверяется": "Facture en cours de vérification",
  "Выплата в {0} · 1 C = {1} {0}": "Paiement en {0} · 1 C = {1} {0}",
  "Вывести {0} C": "Retirer {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Émettez la facture en {0}. Après vérification, l’argent arrive sous {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Émettez la facture en euros. Après vérification, l’argent arrive sous {0}. Les coordonnées seront enregistrées dans STEOS ID.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Émettez la facture en roubles. Après vérification, l’argent arrive sous {0}. Les coordonnées seront enregistrées dans STEOS ID.",
  "Скопировать {0}": "Copier : {0}",
  "юридический адрес": "adresse légale",
  "Скопировать название компании": "Copier le nom de la société",
  "Скопировать все реквизиты": "Tout copier",
  "Реквизиты для счёта": "Coordonnées de facturation",
  "Проверяем счёт…": "Vérification de la facture…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG ou PNG, 10 Mo max.",
  "Можно вывести {0} C": "{0} C retirables",
  "Сумма, C": "Montant, C",
  "Сумма вывода, C": "Montant du retrait, C",
  "Всё": "Tout",
  "Придёт на счёт": "Vous recevrez",
  "Реквизиты": "Coordonnées",
  "Счёт на оплату": "Facture",
  "Заявка на вывод принята": "Demande de retrait acceptée",
  "{0} придут за {1} после проверки счёта": "{0} arriveront sous {1} après vérification de la facture",
  "Ролик принят в обработку": "Vidéo en préparation",
  "Ролик в чате с ботом": "Vidéo dans le chat du bot",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Le bot l’enverra une fois prête. Livraison pas encore confirmée.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Enregistrez-la et publiez sur Reels, Shorts, TikTok ou VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Le code et le lien sont déjà à l’image. Le bot enverra la vidéo dans le chat, d’où vous pourrez l’enregistrer et la publier.",
  "Прислать в чат": "Envoyer dans le chat",
  "Текст выделен: скопируйте его вручную": "Le texte est sélectionné : copiez-le manuellement",
  "Баннер готов: отправить его в чат можно из Telegram": "Bannière prête : envoyez-la dans un chat depuis Telegram",
  "PDF принят в очередь": "PDF en file d’attente",
  "PDF в чате": "PDF dans le chat",
  "Не удалось загрузить период. Попробуйте ещё раз": "Impossible de charger la période. Réessayez",
  "Без начислений": "Aucun gain",
  "Значение выделено: скопируйте его вручную": "Valeur sélectionnée : copiez-la manuellement",
  "Реквизиты выделены: скопируйте их вручную": "Coordonnées sélectionnées : copiez-les manuellement",
  "Нужен файл PDF, JPG или PNG": "Il faut un fichier PDF, JPG ou PNG",
  "Файл {0}, можно до 10 МБ": "Fichier de {0}, 10 Mo max.",
  "Партнёрство не загрузилось": "Le partenariat n’a pas chargé",
  "Загружаем партнёрскую программу": "Chargement du programme partenaire",
  "за неделю": "sur la semaine",
  "за месяц": "sur le mois",
  "Для вывода войдите через STEOS ID": "Connectez-vous via STEOS ID pour retirer",
  "Вывод недоступен на текущем уровне": "Retrait indisponible à votre niveau",
  "Сумма больше доступной": "Montant supérieur au disponible",
  "Сумма меньше минимальной": "Montant inférieur au minimum",
  "Проверьте реквизиты и счёт": "Vérifiez les coordonnées et la facture",
  "Счёт ещё не проверен. Загрузите его заново": "Facture pas encore vérifiée. Importez-la à nouveau",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Pas de réponse. Vérifiez la même demande : ses données et sa clé sont enregistrées",
  "Не удалось загрузить список друзей": "Impossible de charger la liste d’amis",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Impossible de restaurer la demande précédente. Contactez le support avant d’en faire une nouvelle",
  "Партнёрская программа временно недоступна": "Programme partenaire momentanément indisponible",
  "Не удалось загрузить следующую страницу": "Impossible de charger la page suivante",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Impossible de préparer la bannière. Réessayez",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Le bot ne peut pas le préparer : ouvrez le chat du bot et réessayez",
  "Материал сейчас недоступен": "Ressource indisponible pour le moment",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Envoi non confirmé. Touchez à nouveau : la nouvelle tentative vérifie la demande précédente",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Envoi précédent non restauré. Contactez le support",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Envoi précédent confirmé. Touchez à nouveau",
  "Отправка не подтверждена": "Envoi non confirmé",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Facture refusée. Choisissez un PDF, JPG ou PNG de 10 Mo max.",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Impossible d’enregistrer la demande en sécurité. Rien n’a été envoyé",
  "Тут откроется инструмент «{0}»": "L’outil « {0} » s’ouvrira ici",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri et 2 400 autres voix diront tout ce que vous écrivez",
  "Снимите себя, и персонаж повторит ваши движения": "Filmez-vous et le personnage reproduira vos mouvements",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Choisissez un look : 3 photos d’un seul selfie en une minute",
  "Сделать": "Créer",
  "2 400 голосов, 19 языков": "2 400 voix, 19 langues",
  "Текст в речь голосом персонажа или своим клоном": "Texte en voix avec celle d’un personnage ou de votre clone",
  "Ваш голос за две минуты": "Votre voix en deux minutes",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Enregistrez un échantillon : le clone apparaîtra dans tous les outils de voix",
  "Движения": "Mouvements",
  "бесплатно": "gratuit",
  "/сек": "/s",
  "готов": "prêt",
  "Клон · готов": "Clone · prêt",
  "студия: Мой голос": "Ma voix",
  "Сейчас в тренде": "Tendance du moment",
  "Популярное за неделю": "Populaire cette semaine",
  "Геральт скажет ваш текст": "Geralt dira votre texte",
  "Вы в знаменитых сценах": "Vous dans des scènes cultes",
  "3 кадра в любом образе": "3 photos dans n’importe quel look",
  "Готовый сюжет с вами": "Une histoire prête avec vous",
  "Вы повторите любой танец": "Vous reproduirez n’importe quelle danse",
  "Ваш снимок в движении": "Votre photo en mouvement",
  "Фото скажет ваш текст": "La photo dira votre texte",
  "Легенды замка": "Légendes du château",
  "Город инков": "Cité inca",
  "Неоновый дождь": "Pluie de néon",
  "Утренний бег": "Footing du matin",
  "Танец теней": "Danse des ombres",
  "Дорога домой": "Le chemin du retour",
  "Ночной рейв": "Rave de nuit",
  "Снежный пик": "Pic enneigé",
  "Тайны Хейвена": "Les secrets de Haven",
  "Магия рун": "Magie des runes",
  "Странные дела": "Choses étranges",
  "Ночной рынок": "Marché de nuit",
  "Ретро-кадр": "Photo rétro",
  "Утро в горах": "Matin en montagne",
  "Золотой час": "Heure dorée",
  "Студийный свет": "Lumière studio",
  "Полароид": "Polaroid",
  "Киберпанк": "Cyberpunk",
  "Старый маяк": "Le vieux phare",
  "Шторм в заливе": "Tempête dans la baie",
  "Кинотрейлер": "Bande-annonce",
  "Город в движении": "La ville en mouvement",
  "Интервью": "Interview",
  "Пустыня на закате": "Désert au coucher du soleil",
  "Подводный мир": "Monde sous-marin",
  "Кружок «Привет»": "Vidéo ronde « Salut »",
  "Спокойной ночи": "Bonne nuit",
  "Поздравляю": "Félicitations",
  "Скучаю": "Tu me manques",
  "Новости дня": "Infos du jour",
  "Нос корабля": "La proue du navire",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Deux personnes à la proue, bras ouverts face au vent",
  "Героиня": "Héroïne",
  "роль: Герой": "Héros",
  "Уклонение от пуль": "Esquiver les balles",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Le temps se fige, vous vous cambrez et les balles passent",
  "Танец в закусочной": "Danse au diner",
  "Пара танцует твист у стойки придорожной закусочной": "Un couple danse le twist au comptoir d’un diner",
  "Танцор": "Danseur",
  "Танцовщица": "Danseuse",
  "Свидание под дождём": "Rendez-vous sous la pluie",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Une averse, une vieille maison et des retrouvailles attendues des années",
  "Он": "Lui",
  "Она": "Elle",
  "Речь перед битвой": "Discours avant la bataille",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Le chef passe devant les rangs et l’armée répond d’un rugissement",
  "Вождь": "Chef",
  "Знаменосец": "Porte-drapeau",
  "Погоня по крышам": "Poursuite sur les toits",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Des sauts entre les toits de la ville la nuit, la poursuite ne lâche rien",
  "Беглец": "Fugitif",
  "Преследователь": "Poursuivant",
  "Ограбление казино": "Braquage du casino",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Une équipe en smoking traverse la salle, le coffre est déjà ouvert",
  "Главарь": "Chef de bande",
  "Напарник": "Complice",
  "Напарница": "Complice",
  "Прощание на вокзале": "Adieux à la gare",
  "Поезд трогается, двое держатся за руки до последнего": "Le train démarre, deux mains se tiennent jusqu’au bout",
  "Пассажир": "Passager",
  "Провожающий": "Celui qui reste",
  "Дуэль на закате": "Duel au coucher du soleil",
  "Пустая улица, два стрелка и последние секунды тишины": "Une rue déserte, deux tireurs et les dernières secondes de silence",
  "Шериф": "Shérif",
  "Злодей": "Méchant",
  "Танец на лестнице": "Danse dans l’escalier",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Un méchant en costume vif danse sur un long escalier de rue",
  "Выход в открытый космос": "Sortie dans l’espace",
  "Астронавт парит над Землёй, трос уходит к станции": "Un astronaute flotte au-dessus de la Terre, relié à la station",
  "Астронавт": "Astronaute",
  "Рассвет над саванной": "Aube sur la savane",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "L’animal est levé au-dessus du rocher, toute la savane le regarde",
  "Главная роль": "Rôle principal",
  "Хранитель": "Gardien",
  "Полёт под луной": "Envol sous la lune",
  "Велосипед отрывается от земли и летит на фоне луны": "Le vélo décolle et vole devant la lune",
  "Финальная поддержка": "Le porté final",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Élan, saut et porté au-dessus de la tête sous les applaudissements",
  "Партнёрша": "Partenaire",
  "Партнёр": "Partenaire",
  "Песня на холме": "Chanson sur la colline",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Un alpage et le vent : vous tournoyez en chantant, les enfants accourent",
  "Бледная кожа": "Peau pâle",
  "Хвойный лес": "Forêt de conifères",
  "Первый взгляд": "Premier regard",
  "Туман над рекой": "Brume sur la rivière",
  "Полночь в школе": "Minuit au lycée",
  "Двое на поляне": "Deux dans la clairière",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Un rayon perce les pins, deux personnes se figent au milieu de la clairière",
  "Глаза цвета янтаря": "Yeux couleur ambre",
  "Бал выпускников": "Bal de promo",
  "Клятва": "Le serment",
  "Игра в грозу": "Match sous l’orage",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Le tonnerre gronde sur la clairière, chaque coup de batte résonne comme un éclat",
  "Отбивающий": "Batteur",
  "Подающая": "Lanceuse",
  "Ловец": "Receveur",
  "К вершине сосны": "Au sommet du pin",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Il la porte sur son dos jusqu’au sommet d’un pin, en bas la brume et toute la forêt",
  "Примерка брони": "Essayage de l’armure",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "L’armure s’enclenche pièce par pièce et le casque se referme sur votre visage",
  "Полёт над городом": "Vol au-dessus de la ville",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Accélération au-dessus de la ville la nuit, virage entre les tours et atterrissage sur un toit",
  "Пилот брони": "Pilote de l’armure",
  "Ночь в мастерской": "Nuit à l’atelier",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Étincelles de soudure, plans dans les airs et premier lancement réussi",
  "Изобретатель": "Inventeur",
  "Последний заряд": "La dernière charge",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "L’armure est presque à plat, l’équipe se met dos à dos et tout se joue au dernier tir",
  "Герой в броне": "Héros en armure",
  "Качели на паутине": "Balancement sur la toile",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Un saut depuis la corniche, la toile se tend et la rue défile sous vos pieds",
  "Герой в маске": "Héros masqué",
  "Поцелуй под дождём": "Baiser sous la pluie",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Une ruelle la nuit sous l’averse : il est suspendu la tête en bas, elle soulève le bord du masque",
  "Крыша на закате": "Toit au coucher du soleil",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Deux personnes au bord d’un toit, la ville bruisse en bas, le soleil passe derrière les tours",
  "Бой в поезде": "Combat dans le train",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Un combat sur le toit d’un train lancé, puis le héros arrête le wagon à mains nues",
  "Пассажирка": "Passagère",
  "Для маркетплейса": "Pour les marketplaces",
  "Праздники": "Fêtes",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Vœux, vidéos rondes et publications pour les fêtes : 1er avril, Pâques, 8 mars",
  "1 апреля": "1er avril",
  "Пасха": "Pâques",
  "8 марта": "8 mars",
  "Мода": "Mode",
  "Аватарки": "Avatars",
  "Фильмы": "Films",
  "Игры": "Jeux",
  "Путешествия": "Voyages",
  "Сумерки": "Crépuscule",
  "Железный человек": "Iron Man",
  "Человек-паук": "Spider-Man",
  "Романтика": "Romance",
  "Погони": "Poursuites",
  "Всей семьёй": "En famille",
  "Особая подборка": "Sélection spéciale",
  "Особая подборка {0}, {1}": "Sélection spéciale {0}, {1}",
  "Подборка {0}, {1}": "Sélection {0}, {1}",
  "{0} в подборке": "{0} dans la sélection",
  "шаблон|шаблона|шаблонов": "modèle|modèles",
  "шаблона|шаблонов|шаблонов": "modèle|modèles",
  "сцена|сцены|сцен": "scène|scènes",
  "инструмент|инструмента|инструментов": "outil|outils",
  "инструмента|инструментов|инструментов": "outil|outils",
  "стиль|стиля|стилей": "style|styles",
  "кадра|кадров|кадров": "photo|photos",
  "ребёнок|ребёнка|детей": "enfant|enfants",
  "питомец|питомца|питомцев": "animal|animaux",
  "кружки": "vidéos rondes",
  "голос": "voix",
  "текст": "texte",
  "для бизнеса": "business",
  "Кружок из видео": "Message vidéo depuis une vidéo",
  "Фото в новом стиле": "Photo dans un nouveau style",
  "Фото по описанию": "Photo à partir d’une description",
  "Семейный портрет": "Portrait de famille",
  "Видео в новом стиле": "Vidéo dans un nouveau style",
  "Видео по описанию": "Vidéo à partir d’une description",
  "Видео другим голосом": "Vidéo avec une autre voix",
  "Объёмное фото": "Photo 3D",
  "Анимация из серии": "Animation d’une série",
  "Видео из поездки": "Vidéo de voyage",
  "Фильм из фотографий": "Film à partir de photos",
  "Изменить видео": "Modifier une vidéo",
  "текст или запись": "texte ou enregistrement",
  "видео до 1 минуты": "vidéo jusqu’à 1 minute",
  "1 фото и текст": "1 photo et un texte",
  "запись или аудиофайл": "enregistrement ou fichier audio",
  "5 фото лица": "5 photos du visage",
  "1 селфи": "1 selfie",
  "описание словами": "une description",
  "фото или описание": "photo ou description",
  "старое фото": "une vieille photo",
  "чёрно-белое фото": "une photo noir et blanc",
  "фото близких": "photos de vos proches",
  "от 2 до 9 фото": "de 2 à 9 photos",
  "тема поста": "sujet de la publication",
  "1 фото или видео": "1 photo ou vidéo",
  "ваше фото": "votre photo",
  "фото тех, кто сыграет": "photos de ceux qui jouent",
  "1 видео": "1 vidéo",
  "видео и новый текст": "vidéo et nouveau texte",
  "видео с речью": "vidéo avec parole",
  "текст поздравления": "texte de vœux",
  "от 3 фото": "à partir de 3 photos",
  "фото из поездки": "photos de voyage",
  "семейные фото": "photos de famille",
  "сценарий": "script",
  "запись голоса": "enregistrement vocal",
  "песня": "chanson",
  "файл или ссылка": "fichier ou lien",
  "название товара": "nom du produit",
  "от 1 до 5 фото товара": "de 1 à 5 photos du produit",
  "фото товара": "photos du produit",
  "1 видео с вами": "1 vidéo de vous",
  "ваше видео": "votre vidéo",
  "картинка": "image",
  "идея словами": "une idée en mots",
  "ваш промпт": "votre prompt",
  "нужно: 1 фото": "1 photo",
  "нужно: Текст": "Texte",
  "нужно: Тема": "Sujet",
  "нужно: Запись": "Enregistrement",
  "формат: Reels": "Reels",
  "формат: фото": "photos",
  "формат: видео": "vidéos",
  "формат: кружков": "vidéos rondes",
  "формат: шаблонов": "modèles",
  "любое, где хорошо видно лицо": "n’importe laquelle où le visage est bien visible",
  "лицо крупно и при хорошем свете": "visage en gros plan et bien éclairé",
  "селфи, лицо крупно": "selfie, visage en gros plan",
  "снимок оживёт в ролике": "la photo s’anime dans une vidéo",
  "что скажет герой": "ce que dira le personnage",
  "или фото, из которых сделаем слайды": "ou des photos dont on fera des diapositives",
  "Сколько стоит одна генерация": "Combien coûte une génération",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Une photo coûte {0} C, une séance photo {1} C pour 3 photos, une vidéo {2} C pour 5 secondes. Les assistants texte, comme la description d’un produit, coûtent {3} C. Le prix est toujours affiché sur le bouton « Créer » avant le débit.",
  "Что такое C и как пополнить баланс": "Qu’est-ce que C et comment recharger",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C, ce sont les pièces Circle qui paient les créations. Les packs et l’abonnement s’achètent dans l’onglet « Solde », où l’on voit aussi le reste.",
  "Какие файлы можно загружать": "Quels fichiers puis-je importer",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Vidéos jusqu’à 1 minute et 15 Mo, photos en JPG ou PNG, audio en MP3, WAV ou M4A. Chaque outil affiche ses limites.",
  "Как сделать дешевле": "Comment payer moins cher",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "S’il vous manque des Circle, le bouton en bas de l’écran ouvre « Pas assez de Circle » avec l’option « Payer moins cher ». Remise de {0} %, le résultat portera un filigrane.",
  "Где найти готовые результаты": "Où trouver mes résultats",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "Dans « Historique », menu « Plus ». Vous pouvez y retélécharger un fichier ou l’envoyer dans le chat.",
  "Можно ли использовать свой голос": "Puis-je utiliser ma propre voix",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Oui. Clonez votre voix dans l’onglet « Clone » : elle apparaîtra dans la liste des voix de tous les outils de voix.",
  "Фотосессия из {0} в стиле шаблона": "Séance de {0} dans le style du modèle",
  "По желанию: {0}": "Facultatif : {0}",
  "Тут откроется шаблон «{0}»": "Le modèle « {0} » s’ouvrira ici",
  "Только до": "Avant uniquement",
  "Только после": "Après uniquement",
  "До: {0} %": "Avant : {0} %",
  "подборка": "sélection",
  "Все форматы": "Tous les formats",
  "Состав": "Distribution",
  "Вкладки каталога": "Onglets du catalogue",
  "Найти подборку": "Trouver une sélection",
  "Найти шаблон": "Trouver un modèle",
  "Поиск среди {0}": "Rechercher parmi {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "Aucune sélection pour « {0} ». Cherchez parmi tous les modèles",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "Rien pour « {0} » dans « {1} ». Cherchez dans tous les modèles",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "Rien pour « {0} » dans « Pour vous ». Cherchez dans tous les modèles",
  "В подборке «{0}» нет сцен «{1}»": "Aucune scène « {1} » dans « {0} »",
  "Посмотрите все сцены подборки": "Voir toutes les scènes de la sélection",
  "В подборке «{0}» нет {1}": "Pas de {1} dans « {0} »",
  "Посмотрите во всех форматах": "Regardez dans tous les formats",
  "В «Рекомендуем» нет {0}": "Pas de {0} dans « Pour vous »",
  "Пока ничего нет": "Rien pour l’instant",
  "Шаблоны этого формата появятся совсем скоро": "Des modèles dans ce format arrivent bientôt",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "Pas de {1} pour « {0} ». Cherchez dans tous les formats",
  "Искать во всех форматах": "Chercher dans tous les formats",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "Aucun modèle pour « {0} ». Essayez un autre mot",
  "Загружаем ещё": "Chargement…",
  "Это все шаблоны": "C’est tout pour les modèles",
  "Тренды": "Tendances",
  "Вкладки страницы": "Onglets de la page",
  "Найти сцену": "Trouver une scène",
  "Найти в подборке": "Chercher dans la sélection",
  "Искать во всех сценах": "Chercher dans toutes les scènes",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "Aucune sélection pour « {0} ». Cherchez parmi toutes les scènes",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "Rien pour « {0} » dans « {1} ». Cherchez dans toutes les scènes",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "Rien pour « {0} » dans « Tendances ». Cherchez dans toutes les scènes",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "Rien pour « {0} » dans « Pour vous ». Cherchez dans toutes les scènes",
  "В «Трендах» нет сцен «{0}»": "Aucune scène « {0} » dans « Tendances »",
  "В «Рекомендуем» нет сцен «{0}»": "Aucune scène « {0} » dans « Pour vous »",
  "Посмотрите все сцены этой вкладки": "Voir toutes les scènes de cet onglet",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "Rien dans « {0} » pour « {1} ». Cherchez dans tous les modèles",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Cette sélection n’a pas encore de tels modèles. Voyez-la en entier ou choisissez un autre onglet",
  "Поиск в подборке «{0}»: {1}": "Rechercher dans « {0} » : {1}",
  "Вкладки подборки": "Onglets de la sélection",
  "Нужно: {0}": "Requis : {0}",
  "Нужно": "Requis",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Aucun outil ni modèle pour « {0} ». Essayez un autre mot ou voyez tous les outils",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "Rien pour « {0} » dans « {1} ». Cherchez dans tous les outils",
  "Искать во всех": "Chercher partout",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "Aucun outil pour « {0} ». Essayez un autre mot",
  "Найти инструмент": "Trouver un outil",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Impossible d’ouvrir l’outil. Actualisez le catalogue et réessayez.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "L’outil ne s’est pas ouvert en 30 secondes. Réessayez ou revenez en arrière.",
  "Карточка товара": "Fiche produit",
  "Рилс готов": "Reel prêt",
  "Кавер не создан": "Reprise non créée",
  "Фотосессия не создана": "Séance photo non créée",
  "Рилс не создан": "Reel non créé",
  "Карточка не создана": "Fiche non créée",
  "Слайды не созданы": "Diapositives non créées",
  "Запись не обработана": "Enregistrement non traité",
  "Коллаж не создан": "Collage non créé",
  "· остаток {0} C": "· reste {0} C",
  "Вернули {0} C": "{0} C remboursés",
  "Списано {0} C со скидкой, {1} водяной знак": "{0} C débités avec remise, {1} filigrane",
  "Списано {0} C": "{0} C débités",
  "Рисованному стилю камера не нужна": "Un style dessiné n’a pas besoin de caméra",
  "У этой камеры объектив встроенный": "Cet appareil a un objectif intégré",
  "У этой камеры резкость не настраивается": "La netteté de cet appareil ne se règle pas",
  "У этого объектива диафрагма постоянная": "Cet objectif a une ouverture fixe",
  "Встроенный": "Intégré",
  "Как у камеры": "Comme l’appareil",
  "до {0} МБ": "jusqu’à {0} Mo",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "Aucun outil ni modèle pour {0}. Essayez un autre mot ou voyez tous les outils",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "Rien pour {0} dans {1}. Cherchez dans tous les outils",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "Aucun outil pour {0}. Essayez un autre mot",
  "в «Трендах»": "dans « Tendances »",
  "в «Рекомендуем»": "dans « Pour vous »",
  "в подборке {0}": "dans {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "Rien pour {0} {1}. Cherchez dans toutes les scènes",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "Rien dans {0} pour {1}. Cherchez dans tous les modèles",
  "сцен {0}": "scènes {0}",
  "В подборке {0} нет {1}": "Pas de {1} dans {0}",
  "В подборке {0} нет таких шаблонов": "{0} n’a pas de tels modèles",
  "Посмотрите её целиком или выберите другую вкладку": "Voyez-la en entier ou choisissez un autre onglet",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Rien pour {0} dans ce format. Cherchez dans tous les formats",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "Aucun modèle pour {0}. Essayez un autre mot",
  "Здесь нет шаблонов": "Aucun modèle ici",
  "Заказ принят": "Commande reçue",
  "Бот пришлёт результат в чат, в отдельную тему.": "Le bot enverra le résultat dans le chat, dans un sujet à part.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Modifiez la demande et réessayez. Les Circle d’une commande vérifiée ne sont pas remboursés.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Un problème est survenu de notre côté. Vos Circle sont revenus sur votre solde.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "L’outil est encore en cours de connexion : la commande est en file d’attente et démarrera seule, le bot enverra le résultat dans le chat.",
  "Сначала отметьте согласие ниже": "Cochez d’abord le consentement ci-dessous",
  "Главное фото: {0}": "Photo principale : {0}",
  "Загружаем превью…": "Chargement de l’aperçu…",
  "Фото не подошло": "Photo non adaptée",
  "Проверить загрузку": "Vérifier l’import",
  "Опишите, что хотите увидеть": "Décrivez ce que vous voulez voir",
  "Не помещается: до {0} знаков": "Trop long : {0} caractères max.",
  "{0} во весь экран": "{0} en plein écran",
  "Загрузить картинку": "Importer une image",
  "Ваша": "La vôtre",
  "Убрать картинку": "Retirer l’image",
  "Этот инструмент пока недоступен": "Cet outil n’est pas encore disponible",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Choisissez un autre outil ou revenez aux modèles.",
  "Вернуться": "Retour",
  "Образ": "Look",
  "Ваши селфи": "Vos selfies",
  "Три разных кадра: лицо крупно, при хорошем свете": "Trois photos différentes : visage en gros plan, bien éclairé",
  "Подтверждаю согласие людей на фото": "Je confirme l’accord des personnes sur les photos",
  "От одного до пяти ракурсов, первый — главный": "De un à cinq angles, le premier est le principal",
  "Категория": "Catégorie",
  "Набор сцен": "Ensemble de scènes",
  "Загрузите фото: нужно {0}": "Importez des photos : {0} requises",
  "Выберите: {0}": "Choisissez : {0}",
  "Не удалось загрузить экран.": "Impossible de charger l’écran.",
  "Сцен: {0}": "Scènes : {0}",
  "Заказ создан, следите за ним в «Истории».": "Commande créée, suivez-la dans « Historique ».",
  "Старые": "Plus anciens",
  "Длинные": "Plus longs",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Le style définit déjà la lumière et la couleur. Choisissez-en un autre pour les changer",
  "{0} открывается только до f/{1}": "{0} n’ouvre que jusqu’à f/{1}",
  "Объектив не задаёт светосилу": "L’objectif ne définit pas l’ouverture",
  "Этот объектив открывается только до f/{0}": "Cet objectif n’ouvre que jusqu’à f/{0}",
  "Назад к настройкам": "Retour aux réglages",
  "Группа": "Groupe",
  "Нашли {0}": "{0} trouvés",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Rien trouvé. Essayez un autre mot ou réinitialisez le groupe.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Le choix vous ramène aux réglages. Le prix ne change pas",
  "Сравнить: было и стало": "Comparer : avant et après",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Nous reprenons le style : couleur, lumière, retouche. L’image et ses visages ne sont pas copiés",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Nous reprenons la scène : fond, lumière, mise en scène. L’image et ses visages ne sont pas copiés",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Nous reprenons le look : tenue, pose, fond et lumière. C’est vous qui serez sur la photo, les visages ne sont pas copiés",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Image non adaptée : elle ne s’ouvre pas, essayez JPG ou PNG",
  "Картинка не подошла: больше {0} МБ": "Image non adaptée : plus de {0} Mo",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Image non adaptée : trop petite, {0} px minimum",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Image non adaptée : contenu protégé ou interdit",
  "Загрузить картинку-референс": "Importer une image de référence",
  "Озвучка текста": "Voix off d'un texte",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Enregistrez 2 secondes de parole et le bot parlera avec votre voix",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Les voix prêtes sont dans l’onglet « Mes voix » de la section Voix",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "La voix apparaît sous ce nom dans votre liste. Vous seul voyez la description",
  "Голос появится на вкладке «Мои»": "La voix apparaîtra dans l’onglet « Mes voix »",
  "Имя в списке голосов": "Nom dans la liste des voix",
  "Уже в «Озвучке»": "Déjà dans Voix",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "La voix est dans l’onglet « Mes voix », avec l’étiquette « La mienne »",
  "Карточка голоса": "Fiche de la voix",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Touchez une voix de la liste pour la renommer ou la supprimer",
  "Так голос выглядит в списке": "Voici la voix dans la liste",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "La voix est déjà dans l’onglet « Mes voix ». Écoutez-la",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Vérification et entraînement en cours, 1 à 3 minutes en général. La voix apparaîtra d’elle-même dans l’onglet « Mes voix »",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "La voix disparaîtra de l’onglet « Mes voix ». Impossible de la récupérer.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "1 à 3 minutes en général. Vous pouvez fermer l’app : la voix apparaîtra dans la liste",
  "Можно закрыть приложение": "Vous pouvez fermer l’app",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Enregistrez votre voix ou importez des fichiers : de 0:02 à 1:30 au total. MP3, WAV, M4A, OGG et WEBM, jusqu’à 10 fichiers de 20 Mo",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n} clones sur {n} créés. Supprimez-en un pour en ajouter un nouveau",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Sans abonnement, vous pouvez créer {n} clones. Avec, jusqu’à {0}",
  "До {0} клонов": "Jusqu’à {0} clones",
  "Три клона бесплатно": "Trois clones gratuits",
  "Запишите ещё один, другим тоном или настроением": "Enregistrez-en une autre, avec un autre ton ou une autre humeur",
  "С подпиской можно создать до {0}": "Avec un abonnement, vous pouvez en créer jusqu’à {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Bonjour ! Ceci est un enregistrement pour ma voix. Je parle calmement, à un rythme normal, comme avec un ami. Plus ce sera naturel maintenant, plus le clone sera fidèle.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Vous savez ce qui est le plus étrange quand on cuisine avec une vidéo ? On regarde quelqu’un couper un oignon en une minute et on se dit : c’est facile. Et puis l’oignon finit partout, sauf dans la poêle.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Hier, j’ai enfin vidé les cartons du déménagement. J’ai trouvé un vieux baladeur, trois chargeurs de téléphones que je n’ai plus et un carnet de projets pour l’été. Le baladeur marche encore.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Drôle de temps aujourd’hui : du soleil le matin, de la pluie à midi, et on annonce de la neige pour ce soir. Le moment idéal pour se faire une boisson chaude et prendre son temps.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Un, deux, trois, test. Vous m’entendez bien ? Je vais lire quelques phrases sur différents tons : d’abord calmement, puis un peu plus fort, et à la fin tout bas, presque en chuchotant.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Mon chat pense que le clavier est fait pour dormir et que l’écran sert à être caché par sa queue. Donc si quelque chose bruisse dans l’enregistrement, sachez que c’était un travail d’équipe.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Il y a une règle simple : si quelque chose ne marche pas au troisième essai, il faut se lever, se servir un thé et revenir cinq minutes plus tard. En général, ensuite tout marche tout seul.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Chut, vous entendez ? Des pas, tout près. On va jeter un œil prudemment au coin, et s’il n’y a personne, on court jusqu’à la porte. Mais pas de bruit, s’il vous plaît, je suis sérieux.",
  "Проверено": "Vérifiée",
  "Создание новых голосов пока недоступно": "La création de voix n’est pas encore disponible",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 secondes de parole : enregistrez ici ou importez des fichiers",
  "Внутренняя ошибка, попробуйте позже": "Erreur interne, réessayez plus tard",
  "образцов: {n}": "échantillons : {n}",
  "Образец короче 2 секунд": "L’échantillon dure moins de 2 secondes",
  "Образец длиннее 1,5 минуты": "L’échantillon dure plus de 1,5 minutes",
  "Слишком шумная запись — попробуйте в тихом месте": "Enregistrement trop bruyant : essayez dans un endroit calme",
  "В записи слышно несколько голосов": "Plusieurs voix s’entendent dans l’enregistrement",
  "Проверка не пройдена: голос не совпадает с образцами": "Échec de la vérification : la voix ne correspond pas aux échantillons",
  "Голос не прошёл правила площадки": "La voix ne respecte pas les règles de la plateforme",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Échec de la vérification : enregistrez un échantillon sans musique ni autres personnes",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Il faut entre 2 secondes et 1,5 minutes de parole au total",
  "Результат обработки уточняется, загляните чуть позже": "Le résultat est en cours de confirmation, revenez un peu plus tard",
  "Удалить голос «{n}»?": "Supprimer la voix « {n} » ?",
  "Навсегда, вместе с образцами": "Définitivement, avec ses échantillons",
  "Например, спокойный, низкий": "Par exemple : calme, grave",
  "Образец": "Échantillon",
  "Запись или файлы, от 2 секунд": "Enregistrement ou fichiers, 2 s minimum",
  "Имя, описание и согласие": "Nom, description et consentement",
  "Проверка и обучение": "Vérification et entraînement",
  "Модель STEOS · 1–3 минуты": "Modèle STEOS · 1–3 min",
  "Тихое место без эха": "Un endroit calme, sans écho",
  "Фоновый шум и музыка попадут в голос": "Le bruit de fond et la musique se retrouveront dans la voix",
  "Хороший микрофон": "Un bon micro",
  "Гарнитура или настольный микрофон лучше встроенного": "Un casque-micro ou un micro de bureau vaut mieux que le micro intégré",
  "То же оборудование": "Le même matériel",
  "Не меняйте микрофон между записями": "Ne changez pas de micro entre les enregistrements",
  "Под ним голос стоит в списке выбора": "La voix apparaît sous ce nom dans la liste",
  "Шумоподавление": "Réduction du bruit",
  "Включайте, только если в записи слышен шум": "À activer seulement si l’enregistrement contient du bruit",
  "Согласие обязательно": "Consentement obligatoire",
  "Клонировать можно свой голос или с согласия владельца": "Vous pouvez cloner votre voix ou celle d’une personne qui y consent",
  "Проверка образца": "Vérification de l’échantillon",
  "Один говорящий, без музыки и шума": "Une seule personne, sans musique ni bruit",
  "Обучение": "Entraînement",
  "Модель STEOS, обычно 1–3 минуты": "Modèle STEOS, 1 à 3 minutes en général",
  "Голос появится в списке сам": "La voix apparaîtra d’elle-même dans la liste",
  "Проверьте запись": "Vérifiez l’enregistrement",
  "Один голос, без музыки и шума на фоне": "Une seule voix, sans musique ni bruit de fond",
  "Длина образца": "Durée de l’échantillon",
  "Нужно не меньше 2 секунд чистой речи": "Il faut au moins 2 secondes de parole claire",
  "Образцы сохранены": "Échantillons enregistrés",
  "Можно попробовать снова с теми же файлами": "Vous pouvez réessayer avec les mêmes fichiers",
  "Не получилось — попробуйте снова": "Échec, réessayez",
  "Шаг {a} из {b}": "Étape {a} sur {b}",
  "Персональный": "Personnelle",
  "Дальше": "Suivant",
  "Продолжить": "Continuer",
  "К списку голосов": "Vers la liste",
  "Результат уточняется": "En vérification",
  "Попробовать снова": "Réessayer",
  "Голос готов": "La voix est prête",
  "Опишите голос": "Décrivez la voix",
  "Например, Мой голос": "Par exemple : Ma voix",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "C’est ma voix, ou j’ai le consentement de la personne. Je n’utiliserai pas le clone pour tromper, insulter ou créer du contenu interdit",
  "Загружаем {a} из {b}": "Importation {a} sur {b}",
  "Обрабатываем голос": "Traitement de la voix",
  "Не получилось создать голос": "Impossible de créer la voix",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "Le résultat est encore en cours de confirmation. Impossible de réessayer pour l’instant.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Échantillons enregistrés : vous pouvez réessayer avec les mêmes fichiers",
  "Загруженные файлы": "Fichiers importés",
  "Читаем аудио…": "Lecture de l’audio…",
  "Записать ещё": "Enregistrer plus",
  "Ждём разрешение…": "En attente d’autorisation…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Autorisez l’accès dans les réglages du navigateur ou importez un fichier",
  "Другой текст": "Autre texte",
  "Прочитайте вслух": "Lisez à voix haute",
  "Микрофон по умолчанию": "Micro par défaut",
  "Минимум": "Minimum",
  "Хорошо": "Bien",
  "Отлично": "Excellent",
  "Набрано {a} из {b}": "{a} sur {b} atteints",
  "из {t}": "sur {t}",
  "всё готово": "c’est prêt",
  "Файлов с ошибкой: {n}": "Fichiers en erreur : {n}",
  "до «{n}» ещё {t}": "encore {t} avant « {n} »",
  "Ещё {t} до минимума": "Encore {t} avant le minimum",
  "Нужно не меньше 2 секунд": "Il faut au moins 2 secondes",
  "Загрузка образцов": "Importation des échantillons",
  "Образцы приняты сервером": "Le serveur a reçu les échantillons",
  "Проверка голоса": "Vérification de la voix",
  "Пройдена": "Réussie",
  "Не запрашивалась": "Non demandée",
  "Результат проверки пока недоступен": "Le résultat de la vérification n’est pas encore disponible",
  "Обработка голоса": "Traitement de la voix",
  "Не удалось обработать": "Échec du traitement",
  "Выполняется на сервере": "En cours sur le serveur",
  "Очистка шума": "Nettoyage du bruit",
  "Пропущено": "Ignoré",
  "Модель STEOS · один говорящий, без музыки": "Modèle STEOS · une seule voix, sans musique",
  "Обучение голоса": "Entraînement de la voix",
  "Файл больше 20 МБ": "Fichier de plus de 20 Mo",
  "Запись {n}": "Enregistrement {n}",
  "Не удалось прочитать аудио": "Impossible de lire l’audio",
  "Неподдерживаемый формат": "Format non pris en charge",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Le résultat de la création précédente est encore en cours de confirmation. Revenez à cette demande pour ne pas créer un second clone.",
  "Проверить прошлое создание": "Vérifier la précédente",
  "Остановить": "Arrêter",
  "Ждём доступ": "En attente",
  "Ещё раз": "Réessayer",
  "Начать запись": "Enregistrer",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Touchez une voix de la liste pour ouvrir sa fiche : l’écouter, la renommer ou la supprimer.",
  "Озвучек": "Voix off",
  "Знаков": "Caractères",
  "Образцов": "Échantillons",
  "Доступна": "Disponible",
  "Недоступна": "Indisponible",
  "После обучения": "Après l’entraînement",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Entraînée sur vos enregistrements : {n} échantillons, {d} au total",
  "Происхождение: ваши записи. Подробнее": "Origine : vos enregistrements. En savoir plus",
  "Происхождение": "Origine",
  "Ваши записи": "Vos enregistrements",
  "Проверка": "Vérification",
  "Не пройдена": "Échouée",
  "Идёт": "En cours",
  "Переозвучка аудио": "Redoublage audio",
  "Создан": "Créée",
  "Доступ": "Accès",
  "Только вы": "Vous seul",
  "Голос пока недоступен для выбора. Обновите список.": "La voix n’est pas encore sélectionnable. Actualisez la liste.",
  "Голос ещё учится, обычно 1–3 минуты": "La voix est encore en entraînement, 1 à 3 minutes en général",
  "Коротко о голосе": "En bref",
  "О голосе": "À propos de la voix",
  "Голос не создан": "Voix non créée",
  "Обработка дольше обычного": "Plus long que d’habitude",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Le serveur traite encore la voix. Vous pouvez fermer l’app et revenir plus tard.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "L’avatar {n} restera sans voix ; ses cercles utiliseront la voix par défaut.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Les avatars {n} resteront sans voix ; leurs cercles utiliseront la voix par défaut.",
  "Записать первый голос": "Enregistrer ma première voix",
  "клон|клона|клонов": "clone|clones",
  "в месяц": "par mois",
  "{n} C в месяц": "{n} C par mois",
  "{n} своих голосов": "{n} voix perso",
  "Оформить": "S’abonner",
  "Подписка активна": "Abonnement actif",
  "Подписка «{n}»": "Abonnement « {n} »",
  "{n} голосов ваши": "{n} voix sont à vous",
  "Доступно — своих голосов": "Voix perso disponibles",
  "{n} голосов мало?": "{n} voix, pas assez ?",
  "Возьмите {n}": "Passez à {n}",
  "Нужно больше голосов?": "Besoin de plus de voix ?",
  "До {n} с подпиской": "Jusqu’à {n} avec un abonnement",
  "Посмотрите доступные подписки": "Voir les abonnements disponibles",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a} sur {b} utilisées. Enregistrez des voix pour différents usages et humeurs",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Sans abonnement, vous pouvez créer {a} {w}. Avec n’importe quel abonnement, jusqu’à {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Sans abonnement : {n}. La limite dépend de l’abonnement choisi.",
  "Занято {a} из {b}": "{a} sur {b} utilisées",
  "Без подписки · {n}": "Sans abonnement · {n}",
  "С подпиской · {n}": "Avec abonnement · {n}",
  "Смотреть все подписки": "Voir tous les abonnements",
  "Повторить сохранение": "Réessayer",
  "Сохраняем изменения…": "Enregistrement…",
  "Управление голосами временно недоступно": "La gestion des voix est temporairement indisponible",
  "клон: Мой голос": "Ma voix",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Les voix perso sont temporairement indisponibles. Actualisez la liste plus tard.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Le service des voix est temporairement indisponible. Réessayez plus tard.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Impossible de confirmer la limite de voix. Actualisez la liste plus tard.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Impossible de vérifier le compte. Réessayez plus tard.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Le nom de la voix doit comporter de 2 à 32 caractères.",
  "Описание должно содержать не больше 120 символов.": "La description ne doit pas dépasser 120 caractères.",
  "Добавьте от 1 до 10 подходящих образцов.": "Ajoutez de 1 à 10 échantillons adaptés.",
  "Превью этого голоса пока недоступно.": "L’aperçu de cette voix n’est pas encore disponible.",
  "Не удалось загрузить превью. Попробуйте позже.": "Impossible de charger l’aperçu. Réessayez plus tard.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "L’enregistrement est trop bruyant. Essayez dans un endroit calme.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Plusieurs voix s’entendent. Ajoutez la parole d’une seule personne.",
  "Голос не прошёл правила площадки.": "La voix ne respecte pas les règles de la plateforme.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Le service n’a pas pu traiter la voix. Vérifiez l’état avant de réessayer.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Le consentement a changé ou est indisponible. Actualisez la liste et confirmez la version actuelle avant de réessayer.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Importation refusée. Appuyez à nouveau sur le bouton pour réimporter l’échantillon.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Importation pas encore confirmée. Appuyez à nouveau sur le bouton : nous vérifierons d’abord l’importation précédente.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Choisissez un fichier audio MP3, WAV, M4A, OGG ou WebM.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Impossible de lire l’audio. Réessayez ou importez un fichier.",
  "Пример звучания": "Extrait audio",
  "Пример звучания пока недоступен": "Extrait audio pas encore disponible",
  "Превью голоса": "Aperçu de la voix",
  "Прослушать пример": "Écouter l’extrait",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0} % de réduction sur le premier pack Circle, valable {1} {2} après l’abonnement",
  "Вы уже пришли по ссылке партнёра": "Vous êtes déjà venu via le lien d’un partenaire",
  "Промокод партнёра уже применён": "Un code partenaire est déjà appliqué",
  "Тут откроется тема чата, куда бот прислал {0}": "Ici s’ouvrira le sujet du chat avec votre résultat : {0}",
  "можно вывести": "retirable",
  "только в STEOS": "uniquement dans STEOS",
  "Не короче {0} знаков": "Au moins {0} caractères",
  "Введите почту и пароль": "Saisissez votre e-mail et votre mot de passe",
  "от {0} знаков": "{0} caractères min.",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Après connexion, vos Circle sont partagés entre le bot et votre compte STEOS. Le solde et les retraits sont aussi sur {0}.",
  "Вход или новый аккаунт": "Connexion ou nouveau compte",
  "Придумайте пароль": "Créez un mot de passe",
  "Ваш пароль": "Votre mot de passe",
  "Принимаю {0} и {1} STEOS": "J’accepte les {0} et la {1} de STEOS",
  "согласие: условия": "conditions",
  "согласие: политику конфиденциальности": "politique de confidentialité",
  "Пришлём ссылку на почту": "Nous vous enverrons un lien par e-mail",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Ouvrez le lien de l’e-mail et définissez un nouveau mot de passe sur {0}. Puis connectez-vous ici avec celui-ci.",
  "Ссылка для нового пароля ушла на {0}": "Le lien pour un nouveau mot de passe a été envoyé à {0}",
  "Письма нет? Проверьте папку «Спам».": "Pas d’e-mail ? Vérifiez le dossier Spam.",
  "Аккаунт создан и подключён": "Compte créé et connecté",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Le solde du bot est désormais partagé avec votre compte STEOS.",
  "Подтвердите почту по ссылке из письма.": "Confirmez votre e-mail via le lien reçu.",
  "Вывод работает здесь и на {0}.": "Les retraits sont possibles ici et sur {0}.",
  "Открыть {0}": "Ouvrir {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Un lien a été envoyé à {0}. Ouvrez-le, puis vérifiez la connexion ici.",
  "Проверить подключение": "Vérifier la connexion",
  "Почти готово": "Presque terminé",
  "Почта ещё не подтверждена": "E-mail pas encore confirmé",
  "Не удалось проверить. Попробуйте позже": "Vérification impossible. Réessayez plus tard",
  "Озвучиваю тексты голосом героя": "Des textes avec la voix d’un héros",
  "Любой голос из библиотеки или свой": "Une voix de la bibliothèque ou la vôtre",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "Je fais lire des textes par des voix de héros dans STEOS. Essayez avec mon lien, code promo {0}",
  "Пишу текст, персонаж говорит": "J’écris, le personnage parle",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "Je crée des vidéos rondes avec des personnages dans STEOS : j’écris le texte, le personnage le dit. Code promo {0}",
  "Свои фото в любом образе": "Vos photos dans tous les styles",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Une séance photo dans tous les styles à partir de deux de mes photos, sans studio. STEOS, code promo {0}",
  "Вы в кадре, монтаж и музыка сами": "Vous à l’écran, montage et musique automatiques",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "Je joue dans des reels en un geste avec STEOS : histoire, montage et musique sont déjà dans le modèle. Code promo {0}",
  "Персонаж оживает": "Le personnage prend vie",
  "Говорит вашим текстом": "Dit votre texte",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Le personnage dit mon texte avec sa propre voix. Essayez STEOS, code promo {0}",
  "Клон голоса за минуту": "Un clone vocal en une minute",
  "Запишите от 2 секунд, дальше говорит клон": "Enregistrez 2 secondes, puis le clone parle",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Un clone de ma voix en une minute avec STEOS : maintenant il lit tout à ma place. Code promo {0}",
  "Старому фото цвет и резкость": "Couleur et netteté pour vos vieilles photos",
  "Восстановление за минуту": "Restauration en une minute",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "Je redonne couleur et netteté aux vieilles photos avec STEOS. Code promo {0}",
  "По ссылке или промокоду": "Par lien ou code promo",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Je vous offre +{0} C et {1} % de réduction sur le premier pack STEOS avec mon code promo {2}",
  "Кавер на любую песню": "Une reprise de n’importe quelle chanson",
  "Рок, джаз, lo-fi любым голосом": "Rock, jazz, lo-fi avec n’importe quelle voix",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Une reprise de n’importe quelle chanson avec n’importe quelle voix dans STEOS. Code promo {0}",
  "Мой аватар в любом образе": "Mon avatar dans tous les styles",
  "Свой аватар из 10 фото": "Votre avatar à partir de 10 photos",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Mon avatar dans tous les styles, créé à partir de 10 photos avec STEOS. Code promo {0}",
  "Это я, только говорю вашим текстом": "C’est moi, mais avec votre texte",
  "сторис: Мой голос": "Ma voix",
  "на баланс сразу": "sur le solde tout de suite",
  "на первый пакет Circle": "sur le premier pack Circle",
  "Сторис открыта в Telegram": "Story ouverte dans Telegram",
  "Сторис готова": "Story prête",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Il ne reste qu’à la publier dans l’éditeur Telegram",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Ici s’ouvrira l’éditeur de stories Telegram avec cette image et cette légende",
  "Подпись к сторис": "Légende de la story",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Le bouton-lien sur les stories Telegram n’existe qu’avec Premium. Tout le monde voit le code promo sur l’image.",
  "Опубликовать в сторис": "Publier en story",
  "Попробовать STEOS": "Essayer STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Impossible de préparer la story. Réessayez",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "C’est Telegram qui publie les stories : ouvrez la Mini App dans Telegram",
  "Ссылка и промокод уже на картинке": "Le lien et le code promo sont déjà sur l’image",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Essaie STEOS avec mon lien. Code promo {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Essaie STEOS avec mon lien : +{0} C et {1} % de réduction sur le premier pack. Code promo {2}",
  "Ссылка": "Lien",
  "Скопировать ссылку": "Copier le lien",
  "Друзьям {0} и {1} на первый пакет": "Vos amis reçoivent {0} et {1} sur le premier pack",
  "Промокод выделен: скопируйте вручную": "Code promo sélectionné : copiez-le manuellement",
  "Ссылка выделена: скопируйте вручную": "Lien sélectionné : copiez-le manuellement",
  "Ссылка скопирована": "Lien copié",
  "Ссылка выделена: скопируйте её вручную": "Lien sélectionné : copiez-le manuellement",
  "Ссылка выделена": "Lien sélectionné",
  "Вы пришли по приглашению": "Vous avez été invité",
  "{0} C на баланс": "{0} C sur votre solde",
  "Сгорят через {0} {1}": "Expirent dans {0} {1}",
  "{0} на первый пакет Circle": "{0} sur le premier pack Circle",
  "{0} {1} после оформления подписки": "{0} {1} après l’abonnement",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Les packs Circle s’achètent avec n’importe quel abonnement. La réduction démarre dès que vous vous abonnez.",
  "Выбрать тариф": "Choisir une offre",
  "QR-код ссылки приглашения, промокод {0}": "QR code du lien d’invitation, code promo {0}",
  "Друг наведёт камеру и откроет бота": "Votre ami scanne le code et ouvre le bot",
  "Цвет карточки": "Couleur de la carte",
  "Скачать картинку": "Télécharger",
  "Аврора": "Aurore",
  "Закат": "Couchant",
  "Океан": "Océan",
  "Графит": "Graphite",
  "Партнёры": "Partenaires",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "J’ai trouvé un bot où n’importe quel personnage dit ton texte dans un message vidéo. Il fait aussi des photos, des vidéos et des voix off avec n’importe quelle voix, directement dans Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Je partage une trouvaille : STEOS, un bot Telegram où je crée des messages vidéo avec des personnages, des voix off et des photos. Vous écrivez un texte, choisissez une voix, et c’est prêt en une minute.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Je restaure nos vieilles photos de famille dans STEOS : en une minute, elles retrouvent couleur et netteté. Envoyez-moi celles que vous voulez rafraîchir, ou essayez vous-mêmes.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Qui voulait un message vidéo avec la voix de son héros préféré ? Dans STEOS, tu écris un texte et un personnage de jeu ou de série le prononce. C’est un bot Telegram.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Je fais des photos produit, des visuels d’avantages et des descriptions pour les marketplaces dans STEOS en quelques minutes, sans studio ni designer. Ça pourrait vous servir aussi.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Je double mes vidéos avec mon clone vocal, je joue dans des reels à partir de modèles prêts et j’enregistre des reprises. Tout dans un seul bot STEOS sur Telegram.",
  "По моей ссылке +{0} C на старт.": "Avec mon lien, tu reçois +{0} C pour commencer.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Avec mon lien : +{0} C et −{1} % sur le premier pack.",
  "Попробуй сам.": "Essaie.",
  "Попробуйте сами.": "Essayez vous-mêmes.",
  "Актёры": "Acteurs",
  "Персонажи и актёры": "Personnages et acteurs",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "Aucune voix pour « {q} ». Essayez un autre mot ou parcourez les sélections",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Pas encore de voix ici. Regardez les autres onglets ou sélections",
  "Голос вернётся на экран создания": "La voix revient à l’écran de création",
  "После выбора пишите текст для озвучки в чат бота": "Ensuite, envoyez le texte à doubler au bot",
  "От Я до А": "De Z à A",
  "Сортировка и фильтры": "Tri et filtres",
  "Сбросить": "Réinitialiser",
  "Чаще всего выбирают": "Les plus choisis",
  "Сначала свежие": "Les plus récents d'abord",
  "Сначала давние": "Les plus anciens d'abord",
  "Сначала недорогие": "Les moins chers d'abord",
  "Сначала короткие ролики": "Vidéos courtes d'abord",
  "По названию": "Par nom",
  "По названию, с конца алфавита": "Par nom, depuis la fin de l'alphabet",
  "Вертикальные ролики": "Vidéos verticales",
  "Картинки и посты": "Images et publications",
  "Горизонтальные ролики": "Vidéos horizontales",
  "Видеосообщения Telegram": "Messages vidéo Telegram",
  "Один человек в кадре": "Une personne à l'image",
  "Трое и больше": "Trois ou plus",
  "С ребёнком": "Avec un enfant",
  "С питомцем": "Avec un animal",
  "Двое человек в кадре": "Deux personnes à l'image",
  "О разделе": "À propos",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Transforme le texte en voix : une voix du catalogue ou votre clone, avec réglages d’intonation et de vitesse.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Une copie de votre voix à partir d’un enregistrement : utilisez-la pour faire lire n’importe quel texte.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "Studio IA : vidéos, photos, cercles et autres modèles avec vous, vos proches et des personnages.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Crédits (C) sur le compte et recharge. Les crédits sont dépensés pour les voix et les commandes du studio.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Tâches et récompenses : accomplissez des tâches et gagnez des crédits.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Toutes vos voix et commandes du studio : écouter, télécharger ou recommencer.",
  "Ваш профиль и данные аккаунта.": "Votre profil et les données du compte.",
  "Настройки приложения: язык, валюта и уведомления.": "Paramètres de l’app : langue, devise et notifications.",
  "Ответы на частые вопросы и связь с поддержкой.": "Réponses aux questions fréquentes et contact avec le support.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Programme partenaire : invitez des amis et recevez un pourcentage de leurs recharges.",
  "Озвучка больших текстов и сценариев по ролям.": "Doublage de longs textes et de scripts par rôles.",
  "Вы или один близкий": "Vous ou un proche",
  "Вы и близкий": "Vous et un proche",
  "Товары и места": "Produits et lieux",
  "Фото товара, блюда или места": "Photo d’un produit, d’un plat ou d’un lieu",
  "В избранном": "Dans les favoris",
  "Голоса и персонажи, которые вы отметили сердцем": "Voix et personnages que vous avez marqués d’un cœur",
  "Нажмите — выбрать голос": "Touchez pour choisir une voix",
  "Удерживайте — карточка голоса": "Maintenez pour la fiche de la voix",
  "Карточка голоса или персонажа": "Fiche de voix ou de personnage",
  "Нажмите на голос, чтобы выбрать его": "Touchez une voix pour la choisir",
  "Удерживайте, чтобы открыть карточку голоса": "Maintenez pour ouvrir la fiche de la voix",
  "Удаление голоса": "Suppression de la voix",
  "Подсказка": "Astuce",
  "Пример звучания пока недоступен. Попробуйте позже.": "L’extrait n’est pas encore disponible. Réessayez plus tard.",
  "Языков: {0}": "Langues : {0}",
  "Ещё языков: {0}": "Autres langues : {0}",
  "Ход примера": "Progression de l’extrait",
  "Голос говорит на {0} языках": "La voix parle {0} langues",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Toutes les voix sont multilingues et liront le texte dans n’importe quelle langue du système.",
  "Голоса подборки": "Voix de la sélection",
  "Удерживайте голос, чтобы открыть его": "Maintenez une voix pour l’ouvrir",
  "Назад к голосу": "Retour à la voix",
  "Оригинал голоса говорил на {0} языке": "La voix d’origine parlait {0}",
  "Происхождение: {0}. Подробнее": "Origine : {0}. Détails",
  "Новый": "Nouvelle",
  "Официальный": "Officielle",
  "Актёр": "Acteur",
  "Удерживайте, чтобы послушать": "Maintenez pour écouter",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Maintenez la ligne d’une voix ou faites un clic droit pour ouvrir sa fiche. Un personnage s’ouvre d’un simple toucher.",
  "Подборка · Голосов: {0}": "Sélection · Voix : {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Les voix disponibles apparaîtront dans le catalogue. Ici, vous pourrez écouter un extrait et choisir une voix pour le bot.",
  "Зажмите голос": "Maintenez une voix",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Maintenez la ligne d’une voix pour ouvrir sa fiche : l’écouter et voir ses sélections. Un toucher bref choisit la voix.",
  "Нажмите на аватарку": "Touchez l’avatar",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "L’avatar rond de la ligne lit un extrait de la voix. Touchez à nouveau pour arrêter. Toucher la ligne choisit la voix.",
  "Сохраняйте в избранное": "Enregistrez dans les favoris",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Touchez le cœur sur la fiche d’une voix ou d’un personnage : ils se retrouveront dans la sélection « Favoris », en tête des « Sélections » et de « Recommandés ». Touchez à nouveau pour retirer.",
  "Запишите свой голос": "Enregistrez votre voix",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 secondes de parole ou quelques fichiers, et en deux minutes votre voix apparaîtra dans tous les outils de voix off. Touchez « Enregistrer » et lisez le texte à l’écran.",
  "Читать полностью": "Lire la suite",
  "Голос STEOS": "Voix STEOS",
  "Назад к персонажу": "Retour au personnage",
  "Назад к списку": "Retour à la liste",
  "Актёр STEOS": "Acteur STEOS",
  "Персонаж STEOS": "Personnage STEOS",
  "Об актёре": "À propos de l’acteur",
  "О персонаже": "À propos du personnage",
  "Голоса актёра": "Voix de l’acteur",
  "Голоса персонажа": "Voix du personnage",
  "шапка: Мой голос": "Ma voix",
  "Пример голоса «{0}»": "Extrait de la voix « {0} »",
  "Ещё языки": "Autres langues",
  "Юзеры": "Utilisateurs",
  "Лайки": "J’aime",
  "Пол": "Genre",
  "В каталоге с": "Au catalogue depuis",
  "Автор": "Auteur",
  "Откуда": "Origine",
  "Характер": "Caractère",
  "Голосов": "Voix",
  "Мужской": "Masculine",
  "Женский": "Féminine",
  "Детский": "Enfants",
  "Не указан": "Non indiqué",
  "Голос персонажа": "Voix du personnage",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Choisissez un fichier audio pris en charge jusqu’à {0} Mo.",
  "пол: Детский": "Enfant",
  "Состав подборки": "Contenu de la sélection",
  "Закрыть выбор голоса": "Fermer le choix de la voix",
  "Не удалось открыть запись для прослушивания.": "Impossible d’ouvrir l’enregistrement pour l’écouter.",
  "Использовать готовую запись": "Utiliser un enregistrement existant",
  "Подтвердите права на материалы, чтобы взять запись.": "Confirmez vos droits sur les contenus pour utiliser l’enregistrement.",
  "Работа из доната": "Création issue d’un don",
  "Модель синтеза": "Modèle de synthèse",
  "Новая модель": "Nouveau modèle",
  "Прежняя модель": "Modèle précédent",
  "Удерживайте — карточка голоса и модель синтеза": "Maintenez : fiche de la voix et modèle de synthèse",
  "Модель для озвучки в чате": "Modèle pour la voix dans le chat",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Nouveau modèle : émotions et intonation vivante, questions, de nombreuses langues, clones de voix",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Modèle précédent : cinq langues seulement, sans émotions ni intonation interrogative, sans clones",
  "Активная модель: STEOS Voice": "Modèle actif : STEOS Voice",
  "Активная модель:": "Modèle actif :",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Nouveau modèle : 19 langues, un son naturel aux intonations vivantes — sans timbre métallique ni robotique, un clonage de voix de qualité",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Modèle précédent : 5 langues seulement, sans émotions ni intonation interrogative, sans clones de voix",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "Avec le modèle STEOS Voice {0}, toutes les voix sont multilingues et liront le texte dans n’importe laquelle de ces langues.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "Avec le modèle STEOS Voice {0}, toutes les voix sont multilingues et liront le texte dans n’importe laquelle de {1}.",
  "этих языков": "ces langues",
  "Языки озвучки": "Langues de voix off",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Toute voix du modèle STEOS Voice {0} lira le texte dans chacune de ces langues",
  "Все голоса": "Toutes les voix",
  "Озвучка текста и переозвучка": "Synthèse vocale et changement de voix",
  "Переозвучка записи": "Changement de voix d’un enregistrement",
  "Меняют голос в вашей записи": "Changent la voix de votre enregistrement",
  "Выберите голос для переозвучки записи": "Choisissez une voix pour changer la voix de votre enregistrement",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Voix choisie — revenez au chat et appuyez sur « Continuer le changement de voix »"
}
